import { jsx as g, jsxs as K, Fragment as Je } from "react/jsx-runtime";
import { combineClasses as ie } from "@global-engineering-shared/object-utils";
import { makeStyles as Z, createStyles as te, useTheme as j, Popper as no, ClickAwayListener as ct, IconButton as ya, jssPreset as Sa, createTheme as Ca, Chip as ba, Popover as wa, Grow as xa, Box as Sr, Typography as Ra } from "@material-ui/core";
import { getThemeProps as W } from "@material-ui/styles";
import * as Rn from "react";
import Ct, { forwardRef as ue, useState as oe, useCallback as L, useEffect as J, Fragment as tr, useMemo as ye, useImperativeHandle as Me, useRef as pe, useLayoutEffect as Pa, createContext as ro, useContext as oo, Children as Pn, isValidElement as Fa, cloneElement as Da, useReducer as Ia, createElement as Ma } from "react";
import { Box as ge, Link as io, Typography as ke, IconButton as he, FormControl as nr, FormLabel as Jt, FormGroup as ao, FormHelperText as Xt, Checkbox as lo, Tooltip as Pt, Paper as rr, List as Fn, ListItem as Dn, ListItemIcon as $a, FormControlLabel as ka, TextField as Te, InputAdornment as qe, TableBody as Aa, TableRow as Gt, TableCell as In, TableHead as Ta, TableSortLabel as Ea, MenuItem as Mn, Alert as so, TableContainer as Va, Table as _a, ListItemText as jt, Breadcrumbs as Ba, ListItemSecondaryAction as Na, AppBar as uo, Toolbar as co, Avatar as La, RadioGroup as Oa, Button as $n, ButtonGroup as za, Badge as Ha } from "@global-engineering-shared/gweb-material-ui";
import { AlertStatusLightIcon as go, CheckLightIcon as Zt, WarningStatusLightIcon as or, InfoStatusLightIcon as ir, CrossLightIcon as lt, EditLightIcon as Ga, ColumnsLightIcon as ja, ChevronUpLightIcon as Wa, ChevronDownLightIcon as st, FilterLightIcon as ar, ForbiddenLightIcon as Ua, ChevronLeftLightIcon as po, ChevronRightLightIcon as fo, CalendarLightIcon as qa, TimeLightIcon as mo } from "@global-engineering-shared/gweb-global-icons";
import { parseISO as ot, startOfToday as Ka, setMonth as Ya, subMonths as Ja, addMonths as Cr, setYear as Xa, subYears as Za, addYears as Qa, isEqual as Ge, eachDayOfInterval as tt, endOfDay as el, isSameDay as nt, addMinutes as tl, addHours as nl, getHours as rl, getMinutes as ol, compareAsc as il, min as ho, max as vo, isValid as Oe, isAfter as Ft, eachMonthOfInterval as al, startOfMonth as kn, endOfMonth as An, eachWeekOfInterval as ll, startOfWeek as sl, endOfWeek as ul, parse as lr, format as Ke, set as yo, isBefore as So, getDay as Co, isToday as bo, addDays as br, isSameMonth as cl, formatISO as Wt } from "date-fns";
import { debounce as dl, capitalize as gl } from "lodash-es";
import { Search as pl, Cancel as fl, FirstPage as ml, NavigateBefore as hl, NavigateNext as vl, LastPage as yl } from "@material-ui/icons";
import "date-fns-tz";
import de from "classnames";
import { Autocomplete as Sl } from "@material-ui/lab";
import { createFilterOptions as qv } from "@material-ui/lab";
var xt = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e))(xt || {});
const ut = (e) => {
  var n, t, r, o, i, a, l, u;
  return {
    [xt.ERROR]: {
      title: e.palette.error.main,
      body: (n = e.palette.red) == null ? void 0 : n[50],
      border: (t = e.palette.red) == null ? void 0 : t[300],
      link: e.palette.error.dark
    },
    [xt.INFO]: {
      title: e.palette.primary.main,
      body: (r = e.palette.blue) == null ? void 0 : r[50],
      border: (o = e.palette.blue) == null ? void 0 : o[100],
      link: e.palette.primary.main
    },
    [xt.SUCCESS]: {
      title: e.palette.success.main,
      body: (i = e.palette.green) == null ? void 0 : i[50],
      border: (a = e.palette.green) == null ? void 0 : a[300],
      link: e.palette.success.main
    },
    [xt.WARNING]: {
      title: e.palette.warning.main,
      body: (l = e.palette.orange) == null ? void 0 : l[50],
      border: (u = e.palette.orange) == null ? void 0 : u[100],
      link: e.palette.warning.dark
    }
  };
}, Cl = Z(
  () => te({
    root: {
      width: "100%"
    }
  }),
  { name: "gBanner" }
), bl = Z(
  (e) => te({
    root: ({ severity: n }) => ({
      backgroundColor: ut(e)[n].body,
      border: "1px solid",
      borderBottomWidth: "0px",
      borderColor: ut(e)[n].border,
      display: "flex",
      flexDirection: "column",
      gap: e.spacing(0.75),
      padding: e.spacing(1),
      "&:last-child": {
        borderBottomLeftRadius: e.spacing(1),
        borderBottomRightRadius: e.spacing(1),
        borderBottomWidth: "1px"
      }
    }),
    content: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "24px"
    }
  }),
  { name: "gBannerContent" }
), wl = Z(
  (e) => te({
    root: ({ severity: n }) => ({
      minHeight: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: ut(e)[n].title,
      color: e.palette.common.white,
      gap: e.spacing(2),
      borderTopLeftRadius: e.spacing(1),
      borderTopRightRadius: e.spacing(1),
      padding: e.spacing(1)
    }),
    title: {
      width: "100%",
      color: e.palette.common.white,
      fontWeight: 500,
      lineHeight: "19px"
    },
    button: {
      padding: 0
    }
  }),
  { name: "gBannerTitle" }
), xl = Z(
  (e) => te({
    root: ({ severity: n }) => ({
      backgroundColor: ut(e)[n].body,
      borderBottomLeftRadius: e.spacing(1),
      borderBottomRightRadius: e.spacing(1),
      border: "1px solid",
      borderTop: "none",
      borderColor: ut(e)[n].border,
      padding: e.spacing(1),
      paddingTop: 0
    }),
    link: ({ severity: n }) => ({
      fontSize: "0.875rem",
      fontWeight: 600,
      cursor: "pointer",
      color: ut(e)[n].link
    })
  }),
  { name: "gBannerActions" }
), wo = (e) => {
  const n = j(), t = W({ name: "gBannerActions", props: { ...e }, theme: n }), { text: r, onClick: o, severity: i } = t, a = xl({ severity: i });
  return /* @__PURE__ */ g(ge, { className: a.root, children: /* @__PURE__ */ g(io, { underline: "always", onClick: o, className: a.link, role: "link", children: r }) });
};
wo.displayName = "BannerActions";
const xo = (e) => {
  const n = j(), t = W({ name: "gBannerContent", props: { ...e }, theme: n }), { message: r, severity: o, classes: i } = t, a = ie(bl({ severity: o }), i);
  return /* @__PURE__ */ g(ge, { className: a.root, children: Array.isArray(r) ? r.map((l, u) => /* @__PURE__ */ g(ke, { className: a.content, children: l }, `${l}-${u}`)) : /* @__PURE__ */ g(ke, { className: a.content, children: r }) });
};
xo.displayName = "BannerContent";
var Rt = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e))(Rt || {});
const Rl = {
  [Rt.ERROR]: /* @__PURE__ */ g(go, { "aria-label": "ErrorIcon" }),
  [Rt.SUCCESS]: /* @__PURE__ */ g(Zt, { "aria-label": "SuccessIcon" }),
  [Rt.WARNING]: /* @__PURE__ */ g(or, { "aria-label": "WarningIcon" }),
  [Rt.INFO]: /* @__PURE__ */ g(ir, { "aria-label": "InfoIcon" })
}, Ro = (e) => {
  const n = j(), t = W({ name: "gBannerTitle", props: { ...e }, theme: n }), { enableIcon: r, severity: o, title: i, onClose: a, classes: l } = t, u = ie(wl({ severity: o }), l);
  return /* @__PURE__ */ K(ge, { className: u.root, children: [
    r && Rl[o],
    /* @__PURE__ */ g(ke, { className: u.title, children: i }),
    a ? /* @__PURE__ */ g(
      he,
      {
        size: "small",
        onClick: a,
        "aria-label": "Dismiss banner icon",
        classes: { root: u.button },
        darkMode: !0,
        children: /* @__PURE__ */ g(lt, { fontSize: "medium" })
      }
    ) : null
  ] });
};
Ro.displayName = "BannerTitle";
const Pl = ue((e, n) => {
  const t = j(), r = W({ name: "gBanner", props: { ...e }, theme: t }), {
    open: o = !1,
    TitleProps: i,
    ContentProps: a,
    ActionsProps: l,
    TitleComponent: u = Ro,
    ContentComponent: s = xo,
    ActionsComponent: d = wo,
    severity: f,
    classes: p
  } = r, c = ie(Cl(), p);
  return o ? /* @__PURE__ */ K("div", { ref: n, role: "alert", className: c.root, children: [
    /* @__PURE__ */ g(u, { ...i, severity: f }),
    /* @__PURE__ */ g(s, { ...a, severity: f }),
    l ? /* @__PURE__ */ g(d, { ...l, severity: f }) : null
  ] }) : null;
});
Pl.displayName = "Banner";
const Fl = Z(
  (e) => te({
    container: {},
    label: {
      marginBottom: e.spacing(0.5)
    }
  }),
  { name: "gCheckboxGroup" }
), Dl = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gCheckboxGroup", props: { ...e }, theme: t }), {
      children: o,
      helperText: i,
      label: a,
      row: l = !1,
      HelperTextProps: u,
      LabelProps: s,
      classes: d = {},
      ...f
    } = r, p = ie(Fl(), d);
    return /* @__PURE__ */ K(
      nr,
      {
        component: "fieldset",
        variant: "outlined",
        className: p.container,
        ...f,
        ref: n,
        children: [
          a ? /* @__PURE__ */ g(Jt, { component: "legend", className: p.label, ...s, children: a }) : null,
          /* @__PURE__ */ g(ao, { row: l, children: o }),
          i ? /* @__PURE__ */ g(Xt, { ...u, children: i }) : null
        ]
      }
    );
  }
);
Dl.displayName = "CheckboxGroup";
const Fv = (e) => {
  const { children: n } = e;
  return /* @__PURE__ */ g(io, { variant: "body2", underline: "always", ...e, children: n });
}, Il = Z(() => ({
  checkbox: {
    padding: 0
  }
})), wr = ({ ...e }) => {
  const n = Il();
  return /* @__PURE__ */ g(lo, { ...e, className: n.checkbox });
}, Dv = ({
  row: e,
  value: n,
  id: t,
  editComponent: r,
  onCellUpdate: o,
  render: i,
  isEditable: a = !0,
  isProcessing: l,
  processingComponent: u
}) => {
  const [s, d] = oe(!1), [f, p] = oe(n), c = () => {
    d(!0);
  }, h = (C) => {
    p(C.target.value);
  }, v = L(() => {
    p(n), d(!1);
  }, [n]), S = () => {
    const C = { ...e.original, [t]: f };
    d(!1), o(C);
  };
  return J(() => {
    v();
  }, [v]), s ? /* @__PURE__ */ K(ge, { display: "flex", flexDirection: "row", children: [
    r(f, h),
    /* @__PURE__ */ g(Pt, { title: "Save", children: /* @__PURE__ */ g(
      he,
      {
        onClick: S,
        disabled: f === n,
        size: "small",
        "data-testid": "tableCellApproveButton",
        "data-tc": "tableCellEditConfirm",
        color: "default",
        children: /* @__PURE__ */ g(Zt, { fontSize: "small" })
      }
    ) }),
    /* @__PURE__ */ g(Pt, { title: "Cancel", children: /* @__PURE__ */ g(
      he,
      {
        onClick: v,
        size: "small",
        "data-testid": "tableCellDismissButton",
        "data-tc": "tableCellEditCancel",
        color: "default",
        children: /* @__PURE__ */ g(lt, { fontSize: "small" })
      }
    ) })
  ] }) : /* @__PURE__ */ K(Je, { children: [
    i(),
    l && u ? u : null,
    a && !l ? /* @__PURE__ */ g(Pt, { title: "Edit", children: /* @__PURE__ */ g(
      he,
      {
        onClick: c,
        size: "small",
        "data-testid": "tableCellEditButton",
        "data-tc": "tableCellEdit",
        color: "default",
        children: /* @__PURE__ */ g(Ga, { fontSize: "small" })
      }
    ) }) : null
  ] });
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function We(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Pe(e, n) {
  return (t) => {
    n.setState((r) => ({
      ...r,
      [e]: We(t, r[e])
    }));
  };
}
function Qt(e) {
  return e instanceof Function;
}
function Ml(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function $l(e, n) {
  const t = [], r = (o) => {
    o.forEach((i) => {
      t.push(i);
      const a = n(i);
      a != null && a.length && r(a);
    });
  };
  return r(e), t;
}
function z(e, n, t) {
  let r = [], o;
  return (i) => {
    let a;
    t.key && t.debug && (a = Date.now());
    const l = e(i);
    if (!(l.length !== r.length || l.some((d, f) => r[f] !== d)))
      return o;
    r = l;
    let s;
    if (t.key && t.debug && (s = Date.now()), o = n(...l), t == null || t.onChange == null || t.onChange(o), t.key && t.debug && t != null && t.debug()) {
      const d = Math.round((Date.now() - a) * 100) / 100, f = Math.round((Date.now() - s) * 100) / 100, p = f / 16, c = (h, v) => {
        for (h = String(h); h.length < v; )
          h = " " + h;
        return h;
      };
      console.info(`%c⏱ ${c(f, 5)} /${c(d, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * p, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return o;
  };
}
function H(e, n, t, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: r
  };
}
function kl(e, n, t, r) {
  const o = () => {
    var a;
    return (a = i.getValue()) != null ? a : e.options.renderFallbackValue;
  }, i = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(r),
    renderValue: o,
    getContext: z(() => [e, t, n, i], (a, l, u, s) => ({
      table: a,
      column: l,
      row: u,
      cell: s,
      getValue: s.getValue,
      renderValue: s.renderValue
    }), H(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(i, t, n, e);
  }, {}), i;
}
function Al(e, n, t, r) {
  var o, i;
  const l = {
    ...e._getDefaultColumnDef(),
    ...n
  }, u = l.accessorKey;
  let s = (o = (i = l.id) != null ? i : u ? u.replace(".", "_") : void 0) != null ? o : typeof l.header == "string" ? l.header : void 0, d;
  if (l.accessorFn ? d = l.accessorFn : u && (u.includes(".") ? d = (p) => {
    let c = p;
    for (const v of u.split(".")) {
      var h;
      c = (h = c) == null ? void 0 : h[v], process.env.NODE_ENV !== "production" && c === void 0 && console.warn(`"${v}" in deeply nested key "${u}" returned undefined.`);
    }
    return c;
  } : d = (p) => p[l.accessorKey]), !s)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(s)}`,
    accessorFn: d,
    parent: r,
    depth: t,
    columnDef: l,
    columns: [],
    getFlatColumns: z(() => [!0], () => {
      var p;
      return [f, ...(p = f.columns) == null ? void 0 : p.flatMap((c) => c.getFlatColumns())];
    }, H(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: z(() => [e._getOrderColumnsFn()], (p) => {
      var c;
      if ((c = f.columns) != null && c.length) {
        let h = f.columns.flatMap((v) => v.getLeafColumns());
        return p(h);
      }
      return [f];
    }, H(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const p of e._features)
    p.createColumn == null || p.createColumn(f, e);
  return f;
}
const ve = "debugHeaders";
function xr(e, n, t) {
  var r;
  let i = {
    id: (r = t.id) != null ? r : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], l = (u) => {
        u.subHeaders && u.subHeaders.length && u.subHeaders.map(l), a.push(u);
      };
      return l(i), a;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: n
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(i, e);
  }), i;
}
const Tl = {
  createTable: (e) => {
    e.getHeaderGroups = z(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r, o) => {
      var i, a;
      const l = (i = r == null ? void 0 : r.map((f) => t.find((p) => p.id === f)).filter(Boolean)) != null ? i : [], u = (a = o == null ? void 0 : o.map((f) => t.find((p) => p.id === f)).filter(Boolean)) != null ? a : [], s = t.filter((f) => !(r != null && r.includes(f.id)) && !(o != null && o.includes(f.id)));
      return _t(n, [...l, ...s, ...u], e);
    }, H(e.options, ve, "getHeaderGroups")), e.getCenterHeaderGroups = z(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r, o) => (t = t.filter((i) => !(r != null && r.includes(i.id)) && !(o != null && o.includes(i.id))), _t(n, t, e, "center")), H(e.options, ve, "getCenterHeaderGroups")), e.getLeftHeaderGroups = z(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => t.find((l) => l.id === a)).filter(Boolean)) != null ? o : [];
      return _t(n, i, e, "left");
    }, H(e.options, ve, "getLeftHeaderGroups")), e.getRightHeaderGroups = z(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, r) => {
      var o;
      const i = (o = r == null ? void 0 : r.map((a) => t.find((l) => l.id === a)).filter(Boolean)) != null ? o : [];
      return _t(n, i, e, "right");
    }, H(e.options, ve, "getRightHeaderGroups")), e.getFooterGroups = z(() => [e.getHeaderGroups()], (n) => [...n].reverse(), H(e.options, ve, "getFooterGroups")), e.getLeftFooterGroups = z(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), H(e.options, ve, "getLeftFooterGroups")), e.getCenterFooterGroups = z(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), H(e.options, ve, "getCenterFooterGroups")), e.getRightFooterGroups = z(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), H(e.options, ve, "getRightFooterGroups")), e.getFlatHeaders = z(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), H(e.options, ve, "getFlatHeaders")), e.getLeftFlatHeaders = z(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), H(e.options, ve, "getLeftFlatHeaders")), e.getCenterFlatHeaders = z(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), H(e.options, ve, "getCenterFlatHeaders")), e.getRightFlatHeaders = z(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), H(e.options, ve, "getRightFlatHeaders")), e.getCenterLeafHeaders = z(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), H(e.options, ve, "getCenterLeafHeaders")), e.getLeftLeafHeaders = z(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), H(e.options, ve, "getLeftLeafHeaders")), e.getRightLeafHeaders = z(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), H(e.options, ve, "getRightLeafHeaders")), e.getLeafHeaders = z(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, r) => {
      var o, i, a, l, u, s;
      return [...(o = (i = n[0]) == null ? void 0 : i.headers) != null ? o : [], ...(a = (l = t[0]) == null ? void 0 : l.headers) != null ? a : [], ...(u = (s = r[0]) == null ? void 0 : s.headers) != null ? u : []].map((d) => d.getLeafHeaders()).flat();
    }, H(e.options, ve, "getLeafHeaders"));
  }
};
function _t(e, n, t, r) {
  var o, i;
  let a = 0;
  const l = function(p, c) {
    c === void 0 && (c = 1), a = Math.max(a, c), p.filter((h) => h.getIsVisible()).forEach((h) => {
      var v;
      (v = h.columns) != null && v.length && l(h.columns, c + 1);
    }, 0);
  };
  l(e);
  let u = [];
  const s = (p, c) => {
    const h = {
      depth: c,
      id: [r, `${c}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    p.forEach((S) => {
      const C = [...v].reverse()[0], P = S.column.depth === h.depth;
      let F, E = !1;
      if (P && S.column.parent ? F = S.column.parent : (F = S.column, E = !0), C && (C == null ? void 0 : C.column) === F)
        C.subHeaders.push(S);
      else {
        const w = xr(t, F, {
          id: [r, c, F.id, S == null ? void 0 : S.id].filter(Boolean).join("_"),
          isPlaceholder: E,
          placeholderId: E ? `${v.filter((I) => I.column === F).length}` : void 0,
          depth: c,
          index: v.length
        });
        w.subHeaders.push(S), v.push(w);
      }
      h.headers.push(S), S.headerGroup = h;
    }), u.push(h), c > 0 && s(v, c - 1);
  }, d = n.map((p, c) => xr(t, p, {
    depth: a,
    index: c
  }));
  s(d, a - 1), u.reverse();
  const f = (p) => p.filter((h) => h.column.getIsVisible()).map((h) => {
    let v = 0, S = 0, C = [0];
    h.subHeaders && h.subHeaders.length ? (C = [], f(h.subHeaders).forEach((F) => {
      let {
        colSpan: E,
        rowSpan: w
      } = F;
      v += E, C.push(w);
    })) : v = 1;
    const P = Math.min(...C);
    return S = S + P, h.colSpan = v, h.rowSpan = S, {
      colSpan: v,
      rowSpan: S
    };
  });
  return f((o = (i = u[0]) == null ? void 0 : i.headers) != null ? o : []), u;
}
const sr = (e, n, t, r, o, i, a) => {
  let l = {
    id: n,
    index: r,
    original: t,
    depth: o,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (u) => {
      if (l._valuesCache.hasOwnProperty(u))
        return l._valuesCache[u];
      const s = e.getColumn(u);
      if (s != null && s.accessorFn)
        return l._valuesCache[u] = s.accessorFn(l.original, r), l._valuesCache[u];
    },
    getUniqueValues: (u) => {
      if (l._uniqueValuesCache.hasOwnProperty(u))
        return l._uniqueValuesCache[u];
      const s = e.getColumn(u);
      if (s != null && s.accessorFn)
        return s.columnDef.getUniqueValues ? (l._uniqueValuesCache[u] = s.columnDef.getUniqueValues(l.original, r), l._uniqueValuesCache[u]) : (l._uniqueValuesCache[u] = [l.getValue(u)], l._uniqueValuesCache[u]);
    },
    renderValue: (u) => {
      var s;
      return (s = l.getValue(u)) != null ? s : e.options.renderFallbackValue;
    },
    subRows: i ?? [],
    getLeafRows: () => $l(l.subRows, (u) => u.subRows),
    getParentRow: () => l.parentId ? e.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let u = [], s = l;
      for (; ; ) {
        const d = s.getParentRow();
        if (!d)
          break;
        u.push(d), s = d;
      }
      return u.reverse();
    },
    getAllCells: z(() => [e.getAllLeafColumns()], (u) => u.map((s) => kl(e, l, s, s.id)), H(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: z(() => [l.getAllCells()], (u) => u.reduce((s, d) => (s[d.column.id] = d, s), {}), H(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let u = 0; u < e._features.length; u++) {
    const s = e._features[u];
    s == null || s.createRow == null || s.createRow(l, e);
  }
  return l;
}, El = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Po = (e, n, t) => {
  var r;
  const o = t.toLowerCase();
  return !!(!((r = e.getValue(n)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(o));
};
Po.autoRemove = (e) => Ae(e);
const Fo = (e, n, t) => {
  var r;
  return !!(!((r = e.getValue(n)) == null || (r = r.toString()) == null) && r.includes(t));
};
Fo.autoRemove = (e) => Ae(e);
const Do = (e, n, t) => {
  var r;
  return ((r = e.getValue(n)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
Do.autoRemove = (e) => Ae(e);
const Io = (e, n, t) => {
  var r;
  return (r = e.getValue(n)) == null ? void 0 : r.includes(t);
};
Io.autoRemove = (e) => Ae(e) || !(e != null && e.length);
const Mo = (e, n, t) => !t.some((r) => {
  var o;
  return !((o = e.getValue(n)) != null && o.includes(r));
});
Mo.autoRemove = (e) => Ae(e) || !(e != null && e.length);
const $o = (e, n, t) => t.some((r) => {
  var o;
  return (o = e.getValue(n)) == null ? void 0 : o.includes(r);
});
$o.autoRemove = (e) => Ae(e) || !(e != null && e.length);
const ko = (e, n, t) => e.getValue(n) === t;
ko.autoRemove = (e) => Ae(e);
const Ao = (e, n, t) => e.getValue(n) == t;
Ao.autoRemove = (e) => Ae(e);
const ur = (e, n, t) => {
  let [r, o] = t;
  const i = e.getValue(n);
  return i >= r && i <= o;
};
ur.resolveFilterValue = (e) => {
  let [n, t] = e, r = typeof n != "number" ? parseFloat(n) : n, o = typeof t != "number" ? parseFloat(t) : t, i = n === null || Number.isNaN(r) ? -1 / 0 : r, a = t === null || Number.isNaN(o) ? 1 / 0 : o;
  if (i > a) {
    const l = i;
    i = a, a = l;
  }
  return [i, a];
};
ur.autoRemove = (e) => Ae(e) || Ae(e[0]) && Ae(e[1]);
const ze = {
  includesString: Po,
  includesStringSensitive: Fo,
  equalsString: Do,
  arrIncludes: Io,
  arrIncludesAll: Mo,
  arrIncludesSome: $o,
  equals: ko,
  weakEquals: Ao,
  inNumberRange: ur
};
function Ae(e) {
  return e == null || e === "";
}
const Vl = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Pe("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], r = t == null ? void 0 : t.getValue(e.id);
      return typeof r == "string" ? ze.includesString : typeof r == "number" ? ze.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? ze.equals : Array.isArray(r) ? ze.arrIncludes : ze.weakEquals;
    }, e.getFilterFn = () => {
      var t, r;
      return Qt(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (r = n.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? t : ze[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, r, o;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((r = n.options.enableColumnFilters) != null ? r : !0) && ((o = n.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((r) => r.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, r;
      return (t = (r = n.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((r) => {
        const o = e.getFilterFn(), i = r == null ? void 0 : r.find((d) => d.id === e.id), a = We(t, i ? i.value : void 0);
        if (Rr(o, a, e)) {
          var l;
          return (l = r == null ? void 0 : r.filter((d) => d.id !== e.id)) != null ? l : [];
        }
        const u = {
          id: e.id,
          value: a
        };
        if (i) {
          var s;
          return (s = r == null ? void 0 : r.map((d) => d.id === e.id ? u : d)) != null ? s : [];
        }
        return r != null && r.length ? [...r, u] : [u];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), r = (o) => {
        var i;
        return (i = We(n, o)) == null ? void 0 : i.filter((a) => {
          const l = t.find((u) => u.id === a.id);
          if (l) {
            const u = l.getFilterFn();
            if (Rr(u, a.value, l))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (n) => {
      var t, r;
      e.setColumnFilters(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Rr(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const _l = (e, n, t) => t.reduce((r, o) => {
  const i = o.getValue(e);
  return r + (typeof i == "number" ? i : 0);
}, 0), Bl = (e, n, t) => {
  let r;
  return t.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r > i || r === void 0 && i >= i) && (r = i);
  }), r;
}, Nl = (e, n, t) => {
  let r;
  return t.forEach((o) => {
    const i = o.getValue(e);
    i != null && (r < i || r === void 0 && i >= i) && (r = i);
  }), r;
}, Ll = (e, n, t) => {
  let r, o;
  return t.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = o = a) : (r > a && (r = a), o < a && (o = a)));
  }), [r, o];
}, Ol = (e, n) => {
  let t = 0, r = 0;
  if (n.forEach((o) => {
    let i = o.getValue(e);
    i != null && (i = +i) >= i && (++t, r += i);
  }), t)
    return r / t;
}, zl = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((i) => i.getValue(e));
  if (!Ml(t))
    return;
  if (t.length === 1)
    return t[0];
  const r = Math.floor(t.length / 2), o = t.sort((i, a) => i - a);
  return t.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, Hl = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), Gl = (e, n) => new Set(n.map((t) => t.getValue(e))).size, jl = (e, n) => n.length, sn = {
  sum: _l,
  min: Bl,
  max: Nl,
  extent: Ll,
  mean: Ol,
  median: zl,
  unique: Hl,
  uniqueCount: Gl,
  count: jl
}, Wl = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Pe("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((r) => r !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, r;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((r = n.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], r = t == null ? void 0 : t.getValue(e.id);
      if (typeof r == "number")
        return sn.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return sn.extent;
    }, e.getAggregationFn = () => {
      var t, r;
      if (!e)
        throw new Error();
      return Qt(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (r = n.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? t : sn[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, r;
      e.setGrouping(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const r = n.getColumn(t);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, r) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = t.subRows) != null && o.length);
    };
  }
};
function Ul(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const r = e.filter((i) => !n.includes(i.id));
  return t === "remove" ? r : [...n.map((i) => e.find((a) => a.id === i)).filter(Boolean), ...r];
}
const ql = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Pe("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = z((t) => [Dt(n, t)], (t) => t.findIndex((r) => r.id === e.id), H(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var r;
      return ((r = Dt(n, t)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var r;
      const o = Dt(n, t);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = z(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, r) => (o) => {
      let i = [];
      if (!(n != null && n.length))
        i = o;
      else {
        const a = [...n], l = [...o];
        for (; l.length && a.length; ) {
          const u = a.shift(), s = l.findIndex((d) => d.id === u);
          s > -1 && i.push(l.splice(s, 1)[0]);
        }
        i = [...i, ...l];
      }
      return Ul(i, t, r);
    }, H(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, un = () => ({
  left: [],
  right: []
}), Kl = {
  getInitialState: (e) => ({
    columnPinning: un(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Pe("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      n.setColumnPinning((o) => {
        var i, a;
        if (t === "right") {
          var l, u;
          return {
            left: ((l = o == null ? void 0 : o.left) != null ? l : []).filter((f) => !(r != null && r.includes(f))),
            right: [...((u = o == null ? void 0 : o.right) != null ? u : []).filter((f) => !(r != null && r.includes(f))), ...r]
          };
        }
        if (t === "left") {
          var s, d;
          return {
            left: [...((s = o == null ? void 0 : o.left) != null ? s : []).filter((f) => !(r != null && r.includes(f))), ...r],
            right: ((d = o == null ? void 0 : o.right) != null ? d : []).filter((f) => !(r != null && r.includes(f)))
          };
        }
        return {
          left: ((i = o == null ? void 0 : o.left) != null ? i : []).filter((f) => !(r != null && r.includes(f))),
          right: ((a = o == null ? void 0 : o.right) != null ? a : []).filter((f) => !(r != null && r.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, i, a;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((i = (a = n.options.enableColumnPinning) != null ? a : n.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((l) => l.id), {
        left: r,
        right: o
      } = n.getState().columnPinning, i = t.some((l) => r == null ? void 0 : r.includes(l)), a = t.some((l) => o == null ? void 0 : o.includes(l));
      return i ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, r;
      const o = e.getIsPinned();
      return o ? (t = (r = n.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = z(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, r, o) => {
      const i = [...r ?? [], ...o ?? []];
      return t.filter((a) => !i.includes(a.column.id));
    }, H(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = z(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, r) => (r ?? []).map((i) => t.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), H(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = z(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, r) => (r ?? []).map((i) => t.find((a) => a.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), H(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, r;
      return e.setColumnPinning(n ? un() : (t = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? t : un());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const r = e.getState().columnPinning;
      if (!n) {
        var o, i;
        return !!((o = r.left) != null && o.length || (i = r.right) != null && i.length);
      }
      return !!((t = r[n]) != null && t.length);
    }, e.getLeftLeafColumns = z(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((r) => n.find((o) => o.id === r)).filter(Boolean), H(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = z(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((r) => n.find((o) => o.id === r)).filter(Boolean), H(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = z(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r) => {
      const o = [...t ?? [], ...r ?? []];
      return n.filter((i) => !o.includes(i.id));
    }, H(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, Bt = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, cn = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), Yl = {
  getDefaultColumnDef: () => Bt,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: cn(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Pe("columnSizing", e),
    onColumnSizingInfoChange: Pe("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, r, o;
      const i = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : Bt.minSize, (r = i ?? e.columnDef.size) != null ? r : Bt.size), (o = e.columnDef.maxSize) != null ? o : Bt.maxSize);
    }, e.getStart = z((t) => [t, Dt(n, t), n.getState().columnSizing], (t, r) => r.slice(0, e.getIndex(t)).reduce((o, i) => o + i.getSize(), 0), H(n.options, "debugColumns", "getStart")), e.getAfter = z((t) => [t, Dt(n, t), n.getState().columnSizing], (t, r) => r.slice(e.getIndex(t) + 1).reduce((o, i) => o + i.getSize(), 0), H(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: r,
          ...o
        } = t;
        return o;
      });
    }, e.getCanResize = () => {
      var t, r;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((r = n.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var i;
          t += (i = o.column.getSize()) != null ? i : 0;
        }
      };
      return r(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const r = n.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (i) => {
        if (!r || !o || (i.persist == null || i.persist(), dn(i) && i.touches && i.touches.length > 1))
          return;
        const a = e.getSize(), l = e ? e.getLeafHeaders().map((C) => [C.column.id, C.column.getSize()]) : [[r.id, r.getSize()]], u = dn(i) ? Math.round(i.touches[0].clientX) : i.clientX, s = {}, d = (C, P) => {
          typeof P == "number" && (n.setColumnSizingInfo((F) => {
            var E, w;
            const I = n.options.columnResizeDirection === "rtl" ? -1 : 1, B = (P - ((E = F == null ? void 0 : F.startOffset) != null ? E : 0)) * I, A = Math.max(B / ((w = F == null ? void 0 : F.startSize) != null ? w : 0), -0.999999);
            return F.columnSizingStart.forEach((Y) => {
              let [O, M] = Y;
              s[O] = Math.round(Math.max(M + M * A, 0) * 100) / 100;
            }), {
              ...F,
              deltaOffset: B,
              deltaPercentage: A
            };
          }), (n.options.columnResizeMode === "onChange" || C === "end") && n.setColumnSizing((F) => ({
            ...F,
            ...s
          })));
        }, f = (C) => d("move", C), p = (C) => {
          d("end", C), n.setColumnSizingInfo((P) => ({
            ...P,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, c = t || typeof document < "u" ? document : null, h = {
          moveHandler: (C) => f(C.clientX),
          upHandler: (C) => {
            c == null || c.removeEventListener("mousemove", h.moveHandler), c == null || c.removeEventListener("mouseup", h.upHandler), p(C.clientX);
          }
        }, v = {
          moveHandler: (C) => (C.cancelable && (C.preventDefault(), C.stopPropagation()), f(C.touches[0].clientX), !1),
          upHandler: (C) => {
            var P;
            c == null || c.removeEventListener("touchmove", v.moveHandler), c == null || c.removeEventListener("touchend", v.upHandler), C.cancelable && (C.preventDefault(), C.stopPropagation()), p((P = C.touches[0]) == null ? void 0 : P.clientX);
          }
        }, S = Jl() ? {
          passive: !1
        } : !1;
        dn(i) ? (c == null || c.addEventListener("touchmove", v.moveHandler, S), c == null || c.addEventListener("touchend", v.upHandler, S)) : (c == null || c.addEventListener("mousemove", h.moveHandler, S), c == null || c.addEventListener("mouseup", h.upHandler, S)), n.setColumnSizingInfo((C) => ({
          ...C,
          startOffset: u,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? cn() : (t = e.initialState.columnSizingInfo) != null ? t : cn());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Nt = null;
function Jl() {
  if (typeof Nt == "boolean")
    return Nt;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Nt = e, Nt;
}
function dn(e) {
  return e.type === "touchstart";
}
const Xl = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Pe("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((r) => ({
        ...r,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, r;
      const o = e.columns;
      return (t = o.length ? o.some((i) => i.getIsVisible()) : (r = n.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, r;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((r = n.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = z(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((r) => r.column.getIsVisible()), H(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = z(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, r, o) => [...t, ...r, ...o], H(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, r) => z(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), H(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var r;
      e.setColumnVisibility(t ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var r;
      t = (r = t) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, i) => ({
        ...o,
        [i.id]: t || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var r;
      e.toggleAllColumnsVisible((r = t.target) == null ? void 0 : r.checked);
    };
  }
};
function Dt(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Zl = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Ql = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Pe("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const r = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, r, o, i;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((r = n.options.enableGlobalFilter) != null ? r : !0) && ((o = n.options.enableFilters) != null ? o : !0) && ((i = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ze.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: r
      } = e.options;
      return Qt(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[r]) != null ? n : ze[r];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, es = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Pe("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, i;
      e.setExpanded(r ? {} : (o = (i = e.initialState) == null ? void 0 : i.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const a = i.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((r) => {
        var o;
        const i = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(n.getRowModel().rowsById).forEach((l) => {
          a[l] = !0;
        }) : a = r, t = (o = t) != null ? o : !i, !i && t)
          return {
            ...a,
            [e.id]: !0
          };
        if (i && !t) {
          const {
            [e.id]: l,
            ...u
          } = a;
          return u;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var t;
      const r = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var t, r, o;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((r = n.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, r = e;
      for (; t && r.parentId; )
        r = n.getRow(r.parentId, !0), t = r.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, Tn = 0, En = 10, gn = () => ({
  pageIndex: Tn,
  pageSize: En
}), ts = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...gn(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Pe("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (i) => We(r, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? gn() : (o = e.initialState.pagination) != null ? o : gn());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let i = We(r, o.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, a)), {
          ...o,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, i;
      e.setPageIndex(r ? Tn : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? o : Tn);
    }, e.resetPageSize = (r) => {
      var o, i;
      e.setPageSize(r ? En : (o = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? o : En);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const i = Math.max(1, We(r, o.pageSize)), a = o.pageSize * o.pageIndex, l = Math.floor(a / i);
        return {
          ...o,
          pageIndex: l,
          pageSize: i
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var i;
      let a = We(r, (i = e.options.pageCount) != null ? i : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...o,
        pageCount: a
      };
    }), e.getPageOptions = z(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((i, a) => a)), o;
    }, H(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, pn = () => ({
  top: [],
  bottom: []
}), ns = {
  getInitialState: (e) => ({
    rowPinning: pn(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Pe("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, r, o) => {
      const i = r ? e.getLeafRows().map((u) => {
        let {
          id: s
        } = u;
        return s;
      }) : [], a = o ? e.getParentRows().map((u) => {
        let {
          id: s
        } = u;
        return s;
      }) : [], l = /* @__PURE__ */ new Set([...a, e.id, ...i]);
      n.setRowPinning((u) => {
        var s, d;
        if (t === "bottom") {
          var f, p;
          return {
            top: ((f = u == null ? void 0 : u.top) != null ? f : []).filter((v) => !(l != null && l.has(v))),
            bottom: [...((p = u == null ? void 0 : u.bottom) != null ? p : []).filter((v) => !(l != null && l.has(v))), ...Array.from(l)]
          };
        }
        if (t === "top") {
          var c, h;
          return {
            top: [...((c = u == null ? void 0 : u.top) != null ? c : []).filter((v) => !(l != null && l.has(v))), ...Array.from(l)],
            bottom: ((h = u == null ? void 0 : u.bottom) != null ? h : []).filter((v) => !(l != null && l.has(v)))
          };
        }
        return {
          top: ((s = u == null ? void 0 : u.top) != null ? s : []).filter((v) => !(l != null && l.has(v))),
          bottom: ((d = u == null ? void 0 : u.bottom) != null ? d : []).filter((v) => !(l != null && l.has(v)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = n.options;
      return typeof r == "function" ? r(e) : (t = r ?? o) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: r,
        bottom: o
      } = n.getState().rowPinning, i = t.some((l) => r == null ? void 0 : r.includes(l)), a = t.some((l) => o == null ? void 0 : o.includes(l));
      return i ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, r;
      const o = e.getIsPinned();
      if (!o)
        return -1;
      const i = (t = n._getPinnedRows(o)) == null ? void 0 : t.map((a) => {
        let {
          id: l
        } = a;
        return l;
      });
      return (r = i == null ? void 0 : i.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, r;
      return e.setRowPinning(n ? pn() : (t = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? t : pn());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const r = e.getState().rowPinning;
      if (!n) {
        var o, i;
        return !!((o = r.top) != null && o.length || (i = r.bottom) != null && i.length);
      }
      return !!((t = r[n]) != null && t.length);
    }, e._getPinnedRows = z((n) => [e.getRowModel().rows, e.getState().rowPinning[n], n], (n, t, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((a) => {
          const l = e.getRow(a, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((a) => n.find((l) => l.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, H(e.options, "debugRows", "_getPinnedRows")), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = z(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, r) => {
      const o = /* @__PURE__ */ new Set([...t ?? [], ...r ?? []]);
      return n.filter((i) => !o.has(i.id));
    }, H(e.options, "debugRows", "getCenterRows"));
  }
}, rs = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Pe("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const r = {
          ...t
        }, o = e.getPreGroupedRowModel().flatRows;
        return n ? o.forEach((i) => {
          i.getCanSelect() && (r[i.id] = !0);
        }) : o.forEach((i) => {
          delete r[i.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const r = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), o = {
        ...t
      };
      return e.getRowModel().rows.forEach((i) => {
        Vn(o, i.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = z(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? fn(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, H(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = z(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? fn(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, H(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = z(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? fn(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, H(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let r = !!(n.length && Object.keys(t).length);
      return r && n.some((o) => o.getCanSelect() && !t[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let r = !!n.length;
      return r && n.some((o) => !t[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, r) => {
      const o = e.getIsSelected();
      n.setRowSelection((i) => {
        var a;
        if (t = typeof t < "u" ? t : !o, e.getCanSelect() && o === t)
          return i;
        const l = {
          ...i
        };
        return Vn(l, e.id, t, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, n), l;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return cr(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return _n(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return _n(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (r) => {
        var o;
        t && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Vn = (e, n, t, r, o) => {
  var i;
  const a = o.getRow(n, !0);
  t ? (a.getCanMultiSelect() || Object.keys(e).forEach((l) => delete e[l]), a.getCanSelect() && (e[n] = !0)) : delete e[n], r && (i = a.subRows) != null && i.length && a.getCanSelectSubRows() && a.subRows.forEach((l) => Vn(e, l.id, t, r, o));
};
function fn(e, n) {
  const t = e.getState().rowSelection, r = [], o = {}, i = function(a, l) {
    return a.map((u) => {
      var s;
      const d = cr(u, t);
      if (d && (r.push(u), o[u.id] = u), (s = u.subRows) != null && s.length && (u = {
        ...u,
        subRows: i(u.subRows)
      }), d)
        return u;
    }).filter(Boolean);
  };
  return {
    rows: i(n.rows),
    flatRows: r,
    rowsById: o
  };
}
function cr(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function _n(e, n, t) {
  var r;
  if (!((r = e.subRows) != null && r.length))
    return !1;
  let o = !0, i = !1;
  return e.subRows.forEach((a) => {
    if (!(i && !o) && (a.getCanSelect() && (cr(a, n) ? i = !0 : o = !1), a.subRows && a.subRows.length)) {
      const l = _n(a, n);
      l === "all" ? i = !0 : (l === "some" && (i = !0), o = !1);
    }
  }), o ? "all" : i ? "some" : !1;
}
const Bn = /([0-9]+)/gm, os = (e, n, t) => To(Ye(e.getValue(t)).toLowerCase(), Ye(n.getValue(t)).toLowerCase()), is = (e, n, t) => To(Ye(e.getValue(t)), Ye(n.getValue(t))), as = (e, n, t) => dr(Ye(e.getValue(t)).toLowerCase(), Ye(n.getValue(t)).toLowerCase()), ls = (e, n, t) => dr(Ye(e.getValue(t)), Ye(n.getValue(t))), ss = (e, n, t) => {
  const r = e.getValue(t), o = n.getValue(t);
  return r > o ? 1 : r < o ? -1 : 0;
}, us = (e, n, t) => dr(e.getValue(t), n.getValue(t));
function dr(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Ye(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function To(e, n) {
  const t = e.split(Bn).filter(Boolean), r = n.split(Bn).filter(Boolean);
  for (; t.length && r.length; ) {
    const o = t.shift(), i = r.shift(), a = parseInt(o, 10), l = parseInt(i, 10), u = [a, l].sort();
    if (isNaN(u[0])) {
      if (o > i)
        return 1;
      if (i > o)
        return -1;
      continue;
    }
    if (isNaN(u[1]))
      return isNaN(a) ? -1 : 1;
    if (a > l)
      return 1;
    if (l > a)
      return -1;
  }
  return t.length - r.length;
}
const bt = {
  alphanumeric: os,
  alphanumericCaseSensitive: is,
  text: as,
  textCaseSensitive: ls,
  datetime: ss,
  basic: us
}, cs = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Pe("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of t) {
        const i = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return bt.datetime;
        if (typeof i == "string" && (r = !0, i.split(Bn).length > 1))
          return bt.alphanumeric;
      }
      return r ? bt.text : bt.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, r;
      if (!e)
        throw new Error();
      return Qt(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (r = n.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? t : bt[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, r) => {
      const o = e.getNextSortingOrder(), i = typeof t < "u" && t !== null;
      n.setSorting((a) => {
        const l = a == null ? void 0 : a.find((c) => c.id === e.id), u = a == null ? void 0 : a.findIndex((c) => c.id === e.id);
        let s = [], d, f = i ? t : o === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? l ? d = "toggle" : d = "add" : a != null && a.length && u !== a.length - 1 ? d = "replace" : l ? d = "toggle" : d = "replace", d === "toggle" && (i || o || (d = "remove")), d === "add") {
          var p;
          s = [...a, {
            id: e.id,
            desc: f
          }], s.splice(0, s.length - ((p = n.options.maxMultiSortColCount) != null ? p : Number.MAX_SAFE_INTEGER));
        } else
          d === "toggle" ? s = a.map((c) => c.id === e.id ? {
            ...c,
            desc: f
          } : c) : d === "remove" ? s = a.filter((c) => c.id !== e.id) : s = [{
            id: e.id,
            desc: f
          }];
        return s;
      });
    }, e.getFirstSortDir = () => {
      var t, r;
      return ((t = (r = e.columnDef.sortDescFirst) != null ? r : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var r, o;
      const i = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== i && ((r = n.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(t && (o = n.options.enableMultiRemove) != null) || o) ? !1 : a === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var t, r;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((r = n.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, r;
      return (t = (r = e.columnDef.enableMultiSort) != null ? r : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const r = (t = n.getState().sorting) == null ? void 0 : t.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, r;
      return (t = (r = n.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (r) => {
        t && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, r;
      e.setSorting(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, ds = [
  Tl,
  Xl,
  ql,
  Kl,
  El,
  Vl,
  Zl,
  //depends on ColumnFaceting
  Ql,
  //depends on ColumnFiltering
  cs,
  Wl,
  //depends on RowSorting
  es,
  ts,
  ns,
  rs,
  Yl
];
function gs(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...ds, ...(n = e._features) != null ? n : []];
  let o = {
    _features: r
  };
  const i = o._features.reduce((p, c) => Object.assign(p, c.getDefaultOptions == null ? void 0 : c.getDefaultOptions(o)), {}), a = (p) => o.options.mergeOptions ? o.options.mergeOptions(i, p) : {
    ...i,
    ...p
  };
  let u = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  o._features.forEach((p) => {
    var c;
    u = (c = p.getInitialState == null ? void 0 : p.getInitialState(u)) != null ? c : u;
  });
  const s = [];
  let d = !1;
  const f = {
    _features: r,
    options: {
      ...i,
      ...e
    },
    initialState: u,
    _queue: (p) => {
      s.push(p), d || (d = !0, Promise.resolve().then(() => {
        for (; s.length; )
          s.shift()();
        d = !1;
      }).catch((c) => setTimeout(() => {
        throw c;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (p) => {
      const c = We(p, o.options);
      o.options = a(c);
    },
    getState: () => o.options.state,
    setState: (p) => {
      o.options.onStateChange == null || o.options.onStateChange(p);
    },
    _getRowId: (p, c, h) => {
      var v;
      return (v = o.options.getRowId == null ? void 0 : o.options.getRowId(p, c, h)) != null ? v : `${h ? [h.id, c].join(".") : c}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (p, c) => {
      let h = (c ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[p];
      if (!h && (h = o.getCoreRowModel().rowsById[p], !h))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${p}`) : new Error();
      return h;
    },
    _getDefaultColumnDef: z(() => [o.options.defaultColumn], (p) => {
      var c;
      return p = (c = p) != null ? c : {}, {
        header: (h) => {
          const v = h.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (h) => {
          var v, S;
          return (v = (S = h.renderValue()) == null || S.toString == null ? void 0 : S.toString()) != null ? v : null;
        },
        ...o._features.reduce((h, v) => Object.assign(h, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...p
      };
    }, H(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: z(() => [o._getColumnDefs()], (p) => {
      const c = function(h, v, S) {
        return S === void 0 && (S = 0), h.map((C) => {
          const P = Al(o, C, S, v), F = C;
          return P.columns = F.columns ? c(F.columns, P, S + 1) : [], P;
        });
      };
      return c(p);
    }, H(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: z(() => [o.getAllColumns()], (p) => p.flatMap((c) => c.getFlatColumns()), H(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: z(() => [o.getAllFlatColumns()], (p) => p.reduce((c, h) => (c[h.id] = h, c), {}), H(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: z(() => [o.getAllColumns(), o._getOrderColumnsFn()], (p, c) => {
      let h = p.flatMap((v) => v.getLeafColumns());
      return c(h);
    }, H(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (p) => {
      const c = o._getAllFlatColumnsById()[p];
      return process.env.NODE_ENV !== "production" && !c && console.error(`[Table] Column with id '${p}' does not exist.`), c;
    }
  };
  Object.assign(o, f);
  for (let p = 0; p < o._features.length; p++) {
    const c = o._features[p];
    c == null || c.createTable == null || c.createTable(o);
  }
  return o;
}
function ps() {
  return (e) => z(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, i, a) {
      i === void 0 && (i = 0);
      const l = [];
      for (let s = 0; s < o.length; s++) {
        const d = sr(e, e._getRowId(o[s], s, a), o[s], s, i, void 0, a == null ? void 0 : a.id);
        if (t.flatRows.push(d), t.rowsById[d.id] = d, l.push(d), e.options.getSubRows) {
          var u;
          d.originalSubRows = e.options.getSubRows(o[s], s), (u = d.originalSubRows) != null && u.length && (d.subRows = r(d.originalSubRows, i + 1, d));
        }
      }
      return l;
    };
    return t.rows = r(n), t;
  }, H(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function fs() {
  return (e) => z(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (n, t, r) => !t.rows.length || n !== !0 && !Object.keys(n ?? {}).length || !r ? t : Eo(t), H(e.options, "debugTable", "getExpandedRowModel"));
}
function Eo(e) {
  const n = [], t = (r) => {
    var o;
    n.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: n,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function ms(e, n, t) {
  return t.options.filterFromLeafRows ? hs(e, n, t) : vs(e, n, t);
}
function hs(e, n, t) {
  var r;
  const o = [], i = {}, a = (r = t.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(u, s) {
    s === void 0 && (s = 0);
    const d = [];
    for (let p = 0; p < u.length; p++) {
      var f;
      let c = u[p];
      const h = sr(t, c.id, c.original, c.index, c.depth, void 0, c.parentId);
      if (h.columnFilters = c.columnFilters, (f = c.subRows) != null && f.length && s < a) {
        if (h.subRows = l(c.subRows, s + 1), c = h, n(c) && !h.subRows.length) {
          d.push(c), i[c.id] = c, o.push(c);
          continue;
        }
        if (n(c) || h.subRows.length) {
          d.push(c), i[c.id] = c, o.push(c);
          continue;
        }
      } else
        c = h, n(c) && (d.push(c), i[c.id] = c, o.push(c));
    }
    return d;
  };
  return {
    rows: l(e),
    flatRows: o,
    rowsById: i
  };
}
function vs(e, n, t) {
  var r;
  const o = [], i = {}, a = (r = t.options.maxLeafRowFilterDepth) != null ? r : 100, l = function(u, s) {
    s === void 0 && (s = 0);
    const d = [];
    for (let p = 0; p < u.length; p++) {
      let c = u[p];
      if (n(c)) {
        var f;
        if ((f = c.subRows) != null && f.length && s < a) {
          const v = sr(t, c.id, c.original, c.index, c.depth, void 0, c.parentId);
          v.subRows = l(c.subRows, s + 1), c = v;
        }
        d.push(c), o.push(c), i[c.id] = c;
      }
    }
    return d;
  };
  return {
    rows: l(e),
    flatRows: o,
    rowsById: i
  };
}
function ys() {
  return (e) => z(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (n, t, r) => {
    if (!n.rows.length || !(t != null && t.length) && !r) {
      for (let p = 0; p < n.flatRows.length; p++)
        n.flatRows[p].columnFilters = {}, n.flatRows[p].columnFiltersMeta = {};
      return n;
    }
    const o = [], i = [];
    (t ?? []).forEach((p) => {
      var c;
      const h = e.getColumn(p.id);
      if (!h)
        return;
      const v = h.getFilterFn();
      if (!v) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${h.id}.`);
        return;
      }
      o.push({
        id: p.id,
        filterFn: v,
        resolvedValue: (c = v.resolveFilterValue == null ? void 0 : v.resolveFilterValue(p.value)) != null ? c : p.value
      });
    });
    const a = t.map((p) => p.id), l = e.getGlobalFilterFn(), u = e.getAllLeafColumns().filter((p) => p.getCanGlobalFilter());
    r && l && u.length && (a.push("__global__"), u.forEach((p) => {
      var c;
      i.push({
        id: p.id,
        filterFn: l,
        resolvedValue: (c = l.resolveFilterValue == null ? void 0 : l.resolveFilterValue(r)) != null ? c : r
      });
    }));
    let s, d;
    for (let p = 0; p < n.flatRows.length; p++) {
      const c = n.flatRows[p];
      if (c.columnFilters = {}, o.length)
        for (let h = 0; h < o.length; h++) {
          s = o[h];
          const v = s.id;
          c.columnFilters[v] = s.filterFn(c, v, s.resolvedValue, (S) => {
            c.columnFiltersMeta[v] = S;
          });
        }
      if (i.length) {
        for (let h = 0; h < i.length; h++) {
          d = i[h];
          const v = d.id;
          if (d.filterFn(c, v, d.resolvedValue, (S) => {
            c.columnFiltersMeta[v] = S;
          })) {
            c.columnFilters.__global__ = !0;
            break;
          }
        }
        c.columnFilters.__global__ !== !0 && (c.columnFilters.__global__ = !1);
      }
    }
    const f = (p) => {
      for (let c = 0; c < a.length; c++)
        if (p.columnFilters[a[c]] === !1)
          return !1;
      return !0;
    };
    return ms(n.rows, f, e);
  }, H(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function Ss(e) {
  return (n) => z(() => [n.getState().pagination, n.getPrePaginationRowModel(), n.options.paginateExpandedRows ? void 0 : n.getState().expanded], (t, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: i
    } = t;
    let {
      rows: a,
      flatRows: l,
      rowsById: u
    } = r;
    const s = o * i, d = s + o;
    a = a.slice(s, d);
    let f;
    n.options.paginateExpandedRows ? f = {
      rows: a,
      flatRows: l,
      rowsById: u
    } : f = Eo({
      rows: a,
      flatRows: l,
      rowsById: u
    }), f.flatRows = [];
    const p = (c) => {
      f.flatRows.push(c), c.subRows.length && c.subRows.forEach(p);
    };
    return f.rows.forEach(p), f;
  }, H(n.options, "debugTable", "getPaginationRowModel"));
}
function Cs() {
  return (e) => z(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, t) => {
    if (!t.rows.length || !(n != null && n.length))
      return t;
    const r = e.getState().sorting, o = [], i = r.filter((u) => {
      var s;
      return (s = e.getColumn(u.id)) == null ? void 0 : s.getCanSort();
    }), a = {};
    i.forEach((u) => {
      const s = e.getColumn(u.id);
      s && (a[u.id] = {
        sortUndefined: s.columnDef.sortUndefined,
        invertSorting: s.columnDef.invertSorting,
        sortingFn: s.getSortingFn()
      });
    });
    const l = (u) => {
      const s = u.map((d) => ({
        ...d
      }));
      return s.sort((d, f) => {
        for (let c = 0; c < i.length; c += 1) {
          var p;
          const h = i[c], v = a[h.id], S = v.sortUndefined, C = (p = h == null ? void 0 : h.desc) != null ? p : !1;
          let P = 0;
          if (S) {
            const F = d.getValue(h.id), E = f.getValue(h.id), w = F === void 0, I = E === void 0;
            if (w || I) {
              if (S === "first")
                return w ? -1 : 1;
              if (S === "last")
                return w ? 1 : -1;
              P = w && I ? 0 : w ? S : -S;
            }
          }
          if (P === 0 && (P = v.sortingFn(d, f, h.id)), P !== 0)
            return C && (P *= -1), v.invertSorting && (P *= -1), P;
        }
        return d.index - f.index;
      }), s.forEach((d) => {
        var f;
        o.push(d), (f = d.subRows) != null && f.length && (d.subRows = l(d.subRows));
      }), s;
    };
    return {
      rows: l(t.rows),
      flatRows: o,
      rowsById: t.rowsById
    };
  }, H(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Ot(e, n) {
  return e ? bs(e) ? /* @__PURE__ */ Rn.createElement(e, n) : e : null;
}
function bs(e) {
  return ws(e) || typeof e == "function" || xs(e);
}
function ws(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function xs(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Rs(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = Rn.useState(() => ({
    current: gs(n)
  })), [r, o] = Rn.useState(() => t.current.initialState);
  return t.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      o(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), t.current;
}
const Ps = Z(() => ({
  label: {
    paddingLeft: 8
  }
})), Fs = ({
  globalFilter: e,
  setGlobalFilter: n
}) => /* @__PURE__ */ g(
  Te,
  {
    value: e || "",
    onChange: (t) => {
      n(t.target.value);
    },
    placeholder: "Search",
    InputProps: {
      startAdornment: /* @__PURE__ */ g(qe, { position: "start", children: /* @__PURE__ */ g(Pt, { title: "Search", children: /* @__PURE__ */ g(Je, { children: /* @__PURE__ */ g(pl, {}) }) }) }),
      endAdornment: e ? /* @__PURE__ */ g(qe, { position: "end", children: /* @__PURE__ */ g(he, { onClick: () => n(""), children: /* @__PURE__ */ g(fl, {}) }) }) : null
    }
  }
), Ds = ({ columns: e }) => {
  const [n, t] = oe(null), r = (a) => {
    t(n ? null : a.currentTarget);
  }, o = !!n, i = Ps();
  return /* @__PURE__ */ K(Je, { children: [
    /* @__PURE__ */ g(Pt, { title: "Show/Hide Columns", children: /* @__PURE__ */ g(he, { onClick: r, "data-testid": "tableColumnsMenuButton", children: o ? /* @__PURE__ */ g(lt, {}) : /* @__PURE__ */ g(ja, {}) }) }),
    /* @__PURE__ */ g(
      no,
      {
        open: o,
        anchorEl: n,
        modifiers: {
          flip: {
            enabled: !1
          }
        },
        children: /* @__PURE__ */ g(rr, { children: /* @__PURE__ */ g(ct, { onClickAway: r, children: /* @__PURE__ */ g(Fn, { children: e.filter((a) => !["id", "select"].includes(a.id)).map((a) => /* @__PURE__ */ g(Dn, { role: void 0, dense: !0, children: /* @__PURE__ */ g($a, { children: /* @__PURE__ */ g(
          ka,
          {
            className: i.label,
            control: /* @__PURE__ */ g(
              lo,
              {
                edge: "start",
                size: "small",
                color: "primary",
                checked: a.getIsVisible(),
                onChange: a.getToggleVisibilityHandler(),
                tabIndex: -1,
                disableRipple: !0,
                inputProps: {
                  "aria-labelledby": a.id
                }
              }
            ),
            id: a.id,
            label: typeof a.columnDef.header == "string" && a.columnDef.header.length ? a.columnDef.header : a.id
          }
        ) }) }, a.id)) }) }) })
      }
    )
  ] });
}, Is = ({
  columns: e,
  globalFilter: n,
  setGlobalFilter: t,
  enableGlobalFilter: r = !0,
  enableHiding: o = !0,
  components: i = {},
  componentProps: a = {},
  resetColumnFilters: l
}) => {
  const { TableBarContent: u, TableGlobalFilter: s = Fs } = i, { TableBarContentProps: d, TableBarContainerProps: f, TableGlobalFilterProps: p } = a;
  return /* @__PURE__ */ K(ge, { display: "flex", alignItems: "center", ...f, children: [
    u && /* @__PURE__ */ g(u, { ...d }),
    /* @__PURE__ */ K(Je, { children: [
      r ? /* @__PURE__ */ g(
        s,
        {
          ...p,
          resetColumnFilters: l,
          globalFilter: n,
          setGlobalFilter: t
        }
      ) : null,
      o ? /* @__PURE__ */ g(Ds, { columns: e }) : null
    ] })
  ] });
}, Ms = ({ rows: e, enableColumnSizing: n, subRowComponent: t, ...r }) => /* @__PURE__ */ g(Aa, { ...r, children: e.map((o) => {
  const i = o.getIsExpanded();
  return /* @__PURE__ */ K(tr, { children: [
    /* @__PURE__ */ g(Gt, { "data-tc": o.id, className: i ? "expandedParentRow" : "", children: o.getVisibleCells().map((a) => {
      var l;
      return /* @__PURE__ */ g(
        In,
        {
          align: ((l = a.column.columnDef.meta) == null ? void 0 : l.align) || "left",
          ...n ? {
            style: {
              width: o.getCanSelect() && a.column.id === "select" ? "auto" : a.column.getSize()
            }
          } : {},
          children: Ot(a.column.columnDef.cell, a.getContext())
        },
        a.id
      );
    }) }),
    t && o.getIsExpanded() && /* @__PURE__ */ g(Gt, { className: i ? "expandedChildRow" : "", children: t(o) })
  ] }, o.id);
}) }), $s = ({
  headerGroups: e,
  enableFilters: n = !0,
  enableSelection: t,
  enableColumnSizing: r,
  ...o
}) => /* @__PURE__ */ g(Ta, { ...o, children: e.map((i) => /* @__PURE__ */ K(tr, { children: [
  /* @__PURE__ */ g(Gt, { children: i.headers.map((a) => {
    var l;
    return /* @__PURE__ */ g(
      In,
      {
        align: ((l = a.column.columnDef.meta) == null ? void 0 : l.align) || "left",
        ...r ? {
          style: {
            width: t && a.column.id === "select" ? "auto" : a.getSize()
          }
        } : {},
        children: a.isPlaceholder ? null : a.column.getCanSort() ? /* @__PURE__ */ g(
          Ea,
          {
            onClick: a.column.getToggleSortingHandler(),
            disabled: !a.column.getCanSort(),
            active: !!a.column.getIsSorted(),
            direction: a.column.getIsSorted() === !1 ? void 0 : a.column.getIsSorted(),
            children: Ot(a.column.columnDef.header, a.getContext())
          }
        ) : Ot(a.column.columnDef.header, a.getContext())
      },
      a.id
    );
  }) }, 0),
  n ? /* @__PURE__ */ g(Gt, { children: i.headers.map((a) => {
    var l;
    return /* @__PURE__ */ g(
      In,
      {
        ...r ? {
          style: {
            width: t && a.column.id === "select" ? "auto" : a.getSize()
          }
        } : {},
        children: a.column.getCanFilter() ? Ot((l = a.column.columnDef.meta) == null ? void 0 : l.Filter, a.getContext()) : null
      },
      a.id
    );
  }) }, 1) : null
] }, i.id)) }), Vo = Z((e) => {
  var n;
  return {
    container: {
      paddingTop: e.spacing(1.5),
      display: "flex",
      alignItems: "center"
    },
    input: {
      fontSize: "0.875rem",
      height: "36px",
      outline: "none"
    },
    icon: {
      color: (n = e.palette.neutral) == null ? void 0 : n.main
    },
    select: {
      padding: e.spacing(1.5),
      outline: "none",
      "&&": {
        paddingRight: e.spacing(4.25)
      },
      "&:focus": {
        background: "inherit"
      }
    },
    label: {
      padding: e.spacing(0, 3),
      fontSize: "0.875rem"
    },
    rowNumberControlsWrapper: {
      display: "flex",
      alignItems: "center",
      gap: e.spacing(2)
    },
    navigationControlsWrapper: {
      display: "flex",
      alignItems: "center",
      gap: e.spacing(1.5),
      "& > button": {
        padding: 0
      }
    }
  };
}), ks = ({
  totalRows: e,
  pageIndex: n,
  pageSize: t
}) => {
  const r = e === 0 ? 0 : n * t + 1, o = e !== -1 ? Math.min(e, (n + 1) * t) : (n + 1) * t, i = e === -1 ? -1 : e;
  return `${r}–${o} of ${i !== -1 ? i : `more than ${o}`}`;
}, As = ({ totalRows: e, pageIndex: n, pageSize: t, pageOptionsLength: r }) => {
  const o = Vo();
  return /* @__PURE__ */ g("span", { className: o.label, children: typeof e == "number" ? ks({
    totalRows: e,
    pageIndex: n,
    pageSize: t
  }) : `${n + 1} of ${r}` });
}, Ts = (e) => {
  const n = Vo(), {
    totalRows: t,
    canPreviousPage: r,
    canNextPage: o,
    pageOptions: i,
    pageCount: a,
    pageSize: l,
    pageIndex: u,
    nextPage: s,
    previousPage: d,
    setPageSize: f,
    gotoPage: p,
    rowsPerPageOptions: c = [10, 20, 50]
  } = e;
  return /* @__PURE__ */ K("div", { className: n.container, children: [
    /* @__PURE__ */ K("div", { className: n.rowNumberControlsWrapper, children: [
      /* @__PURE__ */ g(ke, { variant: "body2", children: "Rows per page" }),
      /* @__PURE__ */ g(
        Te,
        {
          select: !0,
          size: "small",
          value: l,
          onChange: (h) => f(Number(h.target.value)),
          InputProps: {
            classes: { root: n.input }
          },
          SelectProps: {
            classes: {
              icon: n.icon,
              select: n.select
            }
          },
          children: c.map((h) => /* @__PURE__ */ g(Mn, { value: h, children: h }, h))
        }
      )
    ] }),
    /* @__PURE__ */ g(
      As,
      {
        totalRows: t,
        pageIndex: u,
        pageSize: l,
        pageOptionsLength: i.length
      }
    ),
    /* @__PURE__ */ K("div", { className: n.navigationControlsWrapper, children: [
      /* @__PURE__ */ g(he, { "aria-label": "first page", onClick: () => p(0), disabled: !r, children: /* @__PURE__ */ g(ml, {}) }),
      /* @__PURE__ */ g(
        he,
        {
          "aria-label": "previous page",
          onClick: () => d(),
          disabled: !r,
          children: /* @__PURE__ */ g(hl, {})
        }
      ),
      /* @__PURE__ */ g(he, { "aria-label": "next page", onClick: () => s(), disabled: !o, children: /* @__PURE__ */ g(vl, {}) }),
      /* @__PURE__ */ g(
        he,
        {
          "aria-label": "last page",
          onClick: () => p(a - 1),
          disabled: !o,
          children: /* @__PURE__ */ g(yl, {})
        }
      )
    ] })
  ] });
}, Es = Z((e) => ({
  tableContainer: ({ stickyHeader: n }) => n ? {
    position: "relative",
    overflowX: "inherit"
  } : null,
  head: ({
    stickyHeader: n,
    isTableScrolled: t
  }) => n ? {
    position: "sticky",
    top: 0,
    zIndex: 1,
    transition: "background-color 0.3s ease-in-out",
    backgroundColor: t ? e.palette.common.white : "transparent"
  } : null
})), Vs = () => {
  const [e, n] = oe(!1);
  return J(() => {
    const t = () => {
      const r = window.scrollY, i = document.getElementById("table-header").getBoundingClientRect();
      r > i.top ? n(!0) : n(!1);
    };
    return window.addEventListener("scroll", t), () => {
      window.removeEventListener("scroll", t);
    };
  }, []), {
    isTableScrolled: e
  };
}, _s = (e, n, t) => {
  const r = ot(e.getValue(n)), o = ot(t[0]), i = ot(t[1]);
  return o && i ? r.getTime() >= o.getTime() && r.getTime() <= i.getTime() : !0;
}, Bs = (e, n) => {
  const {
    columns: t,
    data: r,
    pagination: o,
    sorting: i,
    filtering: a,
    searching: l,
    selection: u,
    fetchData: s,
    hiddenColumns: d = [],
    columnOrder: f = [],
    columnPinning: p,
    enableFilters: c = !0,
    enableColumnFilters: h = !0,
    enableGlobalFilter: v = !0,
    enableHiding: S = !0,
    enablePagination: C = !0,
    enableColumnSizing: P = !1,
    enableRowSelection: F,
    enableExpanding: E = !1,
    rowsPerPageOptions: w,
    stickyHeader: I = !1,
    defaultColumn: B,
    "data-tc": A,
    classes: Y = {},
    error: O,
    subRowComponent: M,
    components: q = {},
    componentProps: V = {},
    ...G
  } = e, { isTableScrolled: me } = Vs(), k = ie(Es({ stickyHeader: I, isTableScrolled: me }), Y), [{ pageIndex: N, pageSize: ne }, ee] = oe({
    pageIndex: (o == null ? void 0 : o.initialPageIndex) || 0,
    pageSize: (o == null ? void 0 : o.initialPageSize) || 10
  }), re = d.reduce(
    (se, on) => (se[on] = !1, se),
    { id: !1 }
  ), [Q, ae] = oe(re), [le, Ie] = oe((i == null ? void 0 : i.initialSortBy) || []), [Se, Ve] = oe(
    (a == null ? void 0 : a.initialFilters) || []
  ), [Ce, we] = oe((l == null ? void 0 : l.initialSearch) || ""), [xe, $e] = oe((u == null ? void 0 : u.initialSelections) || {}), [Le, _e] = oe({}), Be = ye(
    () => ({
      pageIndex: N,
      pageSize: ne
    }),
    [N, ne]
  ), be = (se, on, va) => {
    const an = (() => {
      const ln = se.getValue(on);
      return typeof ln == "number" ? String(ln) : ln;
    })();
    return an == null ? void 0 : an.toLowerCase().includes(va.toLowerCase());
  }, T = ye(
    () => [
      {
        id: "select",
        header: ({ table: se }) => /* @__PURE__ */ g(
          wr,
          {
            "aria-label": "select all",
            checked: se.getIsAllRowsSelected(),
            indeterminate: se.getIsSomeRowsSelected(),
            onChange: se.getToggleAllRowsSelectedHandler()
          }
        ),
        cell: ({ row: se }) => /* @__PURE__ */ g("div", { children: /* @__PURE__ */ g(
          wr,
          {
            checked: se.getIsSelected(),
            disabled: !se.getCanSelect(),
            indeterminate: se.getIsSomeSelected(),
            onChange: se.getToggleSelectedHandler()
          }
        ) })
      }
    ],
    []
  ), _ = ye(
    () => [
      {
        id: "expand",
        cell: ({ row: se }) => /* @__PURE__ */ g(
          ya,
          {
            "data-testid": `expandIcon-${se.original.id}`,
            size: "small",
            onClick: () => se.toggleExpanded(),
            children: se.getIsExpanded() ? /* @__PURE__ */ g(Wa, { fontSize: "small" }) : /* @__PURE__ */ g(st, { fontSize: "small" })
          }
        )
      }
    ],
    []
  ), U = () => [
    ...F ? T : [],
    ...E ? _ : [],
    ...t
  ], { TableBarContent: b, TableGlobalFilter: R } = q, { TableBarContentProps: D, TableBarContainerProps: y, TableGlobalFilterProps: x } = V, $ = Rs({
    ...G,
    data: r,
    columns: U(),
    getRowId: (se) => se.id,
    state: {
      columnVisibility: Q,
      columnFilters: Se,
      ...f.length ? { columnOrder: f } : {},
      ...p && Object.keys(p).length ? { columnPinning: p } : {},
      globalFilter: Ce,
      sorting: le,
      expanded: Le,
      rowSelection: xe,
      ...o != null && o.manualPagination ? { pagination: Be } : {}
    },
    ...C && (o != null && o.manualPagination ? { onPaginationChange: ee, pageCount: o.pageCount } : { getPaginationRowModel: Ss() }),
    ...l != null && l.manualSearching ? {} : { globalFilterFn: be },
    filterFns: {
      dateRange: _s
    },
    manualPagination: o == null ? void 0 : o.manualPagination,
    manualSorting: i == null ? void 0 : i.manualSorting,
    manualFiltering: a == null ? void 0 : a.manualFiltering,
    onExpandedChange: _e,
    getCoreRowModel: ps(),
    getFilteredRowModel: ys(),
    getExpandedRowModel: fs(),
    getSortedRowModel: Cs(),
    onColumnVisibilityChange: ae,
    onColumnFiltersChange: Ve,
    onGlobalFilterChange: we,
    onSortingChange: Ie,
    onRowSelectionChange: u != null && u.manualSelection ? (se) => {
      u.handleSetRowSelection && u.handleSetRowSelection(se), $e(se);
    } : $e,
    enableFilters: c,
    enableColumnFilters: h,
    enableGlobalFilter: v,
    enableRowSelection: F,
    defaultColumn: B,
    enableExpanding: E
  }), {
    getAllColumns: ce,
    getHeaderGroups: Re,
    getRowModel: ht,
    getCanPreviousPage: vt,
    getCanNextPage: yt,
    getPageOptions: St,
    getPageCount: Xe,
    nextPage: Ze,
    getState: Vt,
    previousPage: ga,
    setPageSize: pa,
    setPageIndex: fa,
    resetColumnFilters: ma
  } = $;
  Me(n, () => $);
  const ha = () => {
  }, yr = ye(() => dl(s || ha, 250), [s]);
  return J(() => {
    s && yr({
      pageIndex: N,
      pageSize: ne,
      sortBy: le,
      filters: Se,
      search: Ce
    });
  }, [N, ne, le, Se, Ce, s, yr]), console.warn("DataTable component is deprecated. Please use GlobalTable instead."), /* @__PURE__ */ K(Je, { children: [
    /* @__PURE__ */ g(
      Is,
      {
        enableGlobalFilter: !!c && !!v,
        columns: ce(),
        globalFilter: Ce,
        setGlobalFilter: we,
        enableHiding: S,
        "data-tc": A,
        resetColumnFilters: ma,
        components: { TableBarContent: b, TableGlobalFilter: R },
        componentProps: { TableBarContentProps: D, TableBarContainerProps: y, TableGlobalFilterProps: x }
      }
    ),
    O && /* @__PURE__ */ g(so, { variant: "filled", severity: "error", children: O }),
    /* @__PURE__ */ g(Va, { "data-tc": A, className: k.tableContainer, children: /* @__PURE__ */ K(
      _a,
      {
        ...P ? { style: { width: $.getTotalSize() } } : {},
        className: k.table,
        children: [
          /* @__PURE__ */ g(
            $s,
            {
              id: "table-header",
              headerGroups: Re(),
              enableFilters: !!c && !!h,
              enableSelection: !!F,
              enableColumnSizing: !!P,
              className: k.head
            }
          ),
          /* @__PURE__ */ g(
            Ms,
            {
              rows: ht().rows,
              enableColumnSizing: !!P,
              subRowComponent: M,
              className: k.body
            }
          )
        ]
      }
    ) }),
    C ? /* @__PURE__ */ g(
      Ts,
      {
        totalRows: o == null ? void 0 : o.totalRows,
        canPreviousPage: vt(),
        canNextPage: yt(),
        pageOptions: St(),
        pageCount: Xe(),
        pageSize: Vt().pagination.pageSize,
        pageIndex: Vt().pagination.pageIndex,
        nextPage: Ze,
        previousPage: ga,
        setPageSize: pa,
        gotoPage: fa,
        rowsPerPageOptions: w,
        "data-tc": A
      }
    ) : null
  ] });
}, Iv = ue(Bs), Ns = Z(() => ({
  select: {
    "&:focus": {
      backgroundColor: "transparent"
    }
  },
  menuPaper: {
    marginTop: "0.25rem"
  },
  menuItem: {
    height: "38px"
  }
})), _o = Z(() => ({
  input: {
    width: "auto"
  }
})), Mv = ({
  column: e
}) => {
  const {
    setFilterValue: n,
    getFilterValue: t,
    columnDef: { meta: { selectOptions: r = [], showEmptyDefault: o = !1 } = {} }
  } = e, i = Ns(), [a, l] = oe(null), u = pe(null);
  return J(() => {
    u.current && l(u.current);
  }, [u]), /* @__PURE__ */ K(
    Te,
    {
      ref: u,
      select: !0,
      size: "small",
      value: t() || "",
      InputProps: {
        startAdornment: /* @__PURE__ */ g(qe, { position: "start", children: /* @__PURE__ */ g(ar, {}) })
      },
      SelectProps: {
        classes: {
          select: i.select
        },
        IconComponent: (s) => /* @__PURE__ */ g(st, { fontSize: "small", ...s }),
        MenuProps: {
          getContentAnchorEl: null,
          anchorEl: a,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          classes: {
            paper: i.menuPaper
          }
        }
      },
      onChange: (s) => {
        n(s.target.value || void 0);
      },
      children: [
        o && /* @__PURE__ */ g(Mn, { className: i.menuItem, dense: !0, children: /* @__PURE__ */ g(jt, { disableTypography: !0 }) }),
        r.map((s, d) => /* @__PURE__ */ g(
          Mn,
          {
            dense: !0,
            value: typeof s == "string" ? s : s.value,
            className: i.menuItem,
            children: /* @__PURE__ */ g(
              jt,
              {
                primary: typeof s == "string" ? s : s.displayValue,
                disableTypography: !0
              }
            )
          },
          d
        ))
      ]
    }
  );
}, $v = ({ column: e }) => {
  const { id: n, getFilterValue: t, setFilterValue: r } = e;
  return /* @__PURE__ */ g(
    Te,
    {
      size: "small",
      fullWidth: !0,
      name: n,
      InputLabelProps: { htmlFor: n },
      onChange: (o) => {
        r(o.target.value || void 0);
      },
      value: t() || "",
      InputProps: {
        inputProps: { "aria-label": e.columnDef.header },
        startAdornment: /* @__PURE__ */ g(qe, { position: "start", children: /* @__PURE__ */ g(ar, { fontSize: "small" }) })
      }
    }
  );
};
function gr(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
}
var $t;
(function(e) {
  e.event = "event", e.props = "prop";
})($t || ($t = {}));
function He() {
}
function Ls(e) {
  var n, t = void 0;
  return function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return n && r.length === n.length && r.every(function(i, a) {
      return i === n[a];
    }) || (n = r, t = e.apply(void 0, r)), t;
  };
}
function at(e) {
  return !!(e || "").match(/\d/);
}
function it(e) {
  return e == null;
}
function Os(e) {
  return typeof e == "number" && isNaN(e);
}
function Bo(e) {
  return it(e) || Os(e) || typeof e == "number" && !isFinite(e);
}
function No(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function zs(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function Hs(e, n, t) {
  var r = zs(t), o = e.search(/[1-9]/);
  return o = o === -1 ? e.length : o, e.substring(0, o) + e.substring(o, e.length).replace(r, "$1" + n);
}
function Gs(e) {
  var n = pe(e);
  n.current = e;
  var t = pe(function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return n.current.apply(n, r);
  });
  return t.current;
}
function pr(e, n) {
  n === void 0 && (n = !0);
  var t = e[0] === "-", r = t && n;
  e = e.replace("-", "");
  var o = e.split("."), i = o[0], a = o[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: a,
    hasNegation: t,
    addNegation: r
  };
}
function js(e) {
  if (!e)
    return e;
  var n = e[0] === "-";
  n && (e = e.substring(1, e.length));
  var t = e.split("."), r = t[0].replace(/^0+/, "") || "0", o = t[1] || "";
  return (n ? "-" : "") + r + (o ? "." + o : "");
}
function Lo(e, n, t) {
  for (var r = "", o = t ? "0" : "", i = 0; i <= n - 1; i++)
    r += e[i] || o;
  return r;
}
function Pr(e, n) {
  return Array(n + 1).join(e);
}
function Oo(e) {
  var n = e + "", t = n[0] === "-" ? "-" : "";
  t && (n = n.substring(1));
  var r = n.split(/[eE]/g), o = r[0], i = r[1];
  if (i = Number(i), !i)
    return t + o;
  o = o.replace(".", "");
  var a = 1 + i, l = o.length;
  return a < 0 ? o = "0." + Pr("0", Math.abs(a)) + o : a >= l ? o = o + Pr("0", a - l) : o = (o.substring(0, a) || "0") + "." + o.substring(a), t + o;
}
function Fr(e, n, t) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || t) && n, o = pr(e), i = o.beforeDecimal, a = o.afterDecimal, l = o.hasNegation, u = parseFloat("0." + (a || "0")), s = a.length <= n ? "0." + a : u.toFixed(n), d = s.split("."), f = i;
  i && Number(d[0]) && (f = i.split("").reverse().reduce(function(v, S, C) {
    return v.length > C ? (Number(v[0]) + Number(S)).toString() + v.substring(1, v.length) : S + v;
  }, d[0]));
  var p = Lo(d[1] || "", n, t), c = l ? "-" : "", h = r ? "." : "";
  return "" + c + f + h + p;
}
function je(e, n) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var t = e.createTextRange();
      return t.move("character", n), t.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(n, n), !0) : (e.focus(), !1);
  }
}
var zo = Ls(function(e, n) {
  for (var t = 0, r = 0, o = e.length, i = n.length; e[t] === n[t] && t < o; )
    t++;
  for (; e[o - 1 - r] === n[i - 1 - r] && i - r > t && o - r > t; )
    r++;
  return {
    from: { start: t, end: o - r },
    to: { start: t, end: i - r }
  };
});
function Ws(e, n, t) {
  return Math.min(Math.max(e, n), t);
}
function mn(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function Us() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function Ho(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function Go(e, n) {
  return e === void 0 && (e = " "), typeof e == "string" ? e : e[n] || " ";
}
function qs(e) {
  var n = e.currentValue, t = e.formattedValue, r = e.currentValueIndex, o = e.formattedValueIndex;
  return n[r] === t[o];
}
function Ks(e, n, t, r, o, i, a) {
  a === void 0 && (a = qs);
  var l = o.findIndex(function(E) {
    return E;
  }), u = e.slice(0, l);
  !n && !t.startsWith(u) && (n = u, t = u + t, r = r + u.length);
  for (var s = t.length, d = e.length, f = {}, p = new Array(s), c = 0; c < s; c++) {
    p[c] = -1;
    for (var h = 0, v = d; h < v; h++) {
      var S = a({
        currentValue: t,
        lastValue: n,
        formattedValue: e,
        currentValueIndex: c,
        formattedValueIndex: h
      });
      if (S && f[h] !== !0) {
        p[c] = h, f[h] = !0;
        break;
      }
    }
  }
  for (var C = r; C < s && (p[C] === -1 || !i(t[C])); )
    C++;
  var P = C === s || p[C] === -1 ? d : p[C];
  for (C = r - 1; C > 0 && p[C] === -1; )
    C--;
  var F = C === -1 || p[C] === -1 ? 0 : p[C] + 1;
  return F > P ? P : r - F < P - r ? F : P;
}
function Ut(e, n, t, r) {
  var o = e.length;
  if (n = Ws(n, 0, o), r === "left") {
    for (; n >= 0 && !t[n]; )
      n--;
    n === -1 && (n = t.indexOf(!0));
  } else {
    for (; n <= o && !t[n]; )
      n++;
    n > o && (n = t.lastIndexOf(!0));
  }
  return n === -1 && (n = o), n;
}
function Ys(e) {
  for (var n = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), t = 0, r = n.length; t < r; t++)
    n[t] = !!(at(e[t]) || at(e[t - 1]));
  return n;
}
function jo(e, n, t, r, o, i) {
  i === void 0 && (i = He);
  var a = Gs(function(h, v) {
    var S, C;
    return Bo(h) ? (C = "", S = "") : typeof h == "number" || v ? (C = typeof h == "number" ? Oo(h) : h, S = r(C)) : (C = o(h, void 0), S = r(C)), { formattedValue: S, numAsString: C };
  }), l = oe(function() {
    return a(it(e) ? n : e, t);
  }), u = l[0], s = l[1], d = function(h, v) {
    h.formattedValue !== u.formattedValue && s({
      formattedValue: h.formattedValue,
      numAsString: h.value
    }), i(h, v);
  }, f = e, p = t;
  it(e) && (f = u.numAsString, p = !0);
  var c = a(f, p);
  return ye(function() {
    s(c);
  }, [c.formattedValue]), [u, d];
}
function Js(e) {
  return e.replace(/[^0-9]/g, "");
}
function Xs(e) {
  return e;
}
function Wo(e) {
  var n = e.type;
  n === void 0 && (n = "text");
  var t = e.displayType;
  t === void 0 && (t = "input");
  var r = e.customInput, o = e.renderText, i = e.getInputRef, a = e.format;
  a === void 0 && (a = Xs);
  var l = e.removeFormatting;
  l === void 0 && (l = Js);
  var u = e.defaultValue, s = e.valueIsNumericString, d = e.onValueChange, f = e.isAllowed, p = e.onChange;
  p === void 0 && (p = He);
  var c = e.onKeyDown;
  c === void 0 && (c = He);
  var h = e.onMouseUp;
  h === void 0 && (h = He);
  var v = e.onFocus;
  v === void 0 && (v = He);
  var S = e.onBlur;
  S === void 0 && (S = He);
  var C = e.value, P = e.getCaretBoundary;
  P === void 0 && (P = Ys);
  var F = e.isValidInputCharacter;
  F === void 0 && (F = at);
  var E = e.isCharacterSame, w = gr(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), I = jo(C, u, !!s, a, l, d), B = I[0], A = B.formattedValue, Y = B.numAsString, O = I[1], M = pe({ formattedValue: A, numAsString: Y }), q = function(T, _) {
    M.current = { formattedValue: T.formattedValue, numAsString: T.value }, O(T, _);
  }, V = oe(!1), G = V[0], me = V[1], k = pe(null), N = pe({
    setCaretTimeout: null,
    focusTimeout: null
  });
  J(function() {
    return me(!0), function() {
      clearTimeout(N.current.setCaretTimeout), clearTimeout(N.current.focusTimeout);
    };
  }, []);
  var ne = a, ee = function(T, _) {
    var U = parseFloat(_);
    return {
      formattedValue: T,
      value: _,
      floatValue: isNaN(U) ? void 0 : U
    };
  }, re = function(T, _, U) {
    T.selectionStart === 0 && T.selectionEnd === T.value.length || (je(T, _), N.current.setCaretTimeout = setTimeout(function() {
      T.value === U && T.selectionStart !== _ && je(T, _);
    }, 0));
  }, Q = function(T, _, U) {
    return Ut(T, _, P(T), U);
  }, ae = function(T, _, U) {
    var b = P(_), R = Ks(_, A, T, U, b, F, E);
    return R = Ut(_, R, b), R;
  }, le = function(T) {
    var _ = T.formattedValue;
    _ === void 0 && (_ = "");
    var U = T.input, b = T.source, R = T.event, D = T.numAsString, y;
    if (U) {
      var x = T.inputValue || U.value, $ = mn(U);
      U.value = _, y = ae(x, _, $), y !== void 0 && re(U, y, _);
    }
    _ !== A && q(ee(_, D), { event: R, source: b });
  };
  J(function() {
    var T = M.current, _ = T.formattedValue, U = T.numAsString;
    A !== _ && (A !== Y || _ !== U) && q(ee(A, Y), {
      event: void 0,
      source: $t.props
    });
  }, [A, Y]);
  var Ie = k.current ? mn(k.current) : void 0, Se = typeof window < "u" ? Pa : J;
  Se(function() {
    var T = k.current;
    if (A !== M.current.formattedValue && T) {
      var _ = ae(M.current.formattedValue, A, Ie);
      T.value = A, re(T, _, A);
    }
  }, [A]);
  var Ve = function(T, _, U) {
    var b = zo(A, T), R = Object.assign(Object.assign({}, b), { lastValue: A }), D = l(T, R), y = ne(D);
    if (D = l(y, void 0), f && !f(ee(y, D))) {
      var x = _.target, $ = mn(x), ce = ae(T, A, $);
      return x.value = A, re(x, ce, A), !1;
    }
    return le({
      formattedValue: y,
      numAsString: D,
      inputValue: T,
      event: _,
      source: U,
      input: _.target
    }), !0;
  }, Ce = function(T) {
    var _ = T.target, U = _.value, b = Ve(U, T, $t.event);
    b && p(T);
  }, we = function(T) {
    var _ = T.target, U = T.key, b = _.selectionStart, R = _.selectionEnd, D = _.value;
    D === void 0 && (D = "");
    var y;
    if (U === "ArrowLeft" || U === "Backspace" ? y = Math.max(b - 1, 0) : U === "ArrowRight" ? y = Math.min(b + 1, D.length) : U === "Delete" && (y = b), y === void 0 || b !== R) {
      c(T);
      return;
    }
    var x = y;
    if (U === "ArrowLeft" || U === "ArrowRight") {
      var $ = U === "ArrowLeft" ? "left" : "right";
      x = Q(D, y, $), x !== y && T.preventDefault();
    } else
      U === "Delete" && !F(D[y]) ? x = Q(D, y, "right") : U === "Backspace" && !F(D[y]) && (x = Q(D, y, "left"));
    x !== y && re(_, x, D), T.isUnitTestRun && re(_, x, D), c(T);
  }, xe = function(T) {
    var _ = T.target, U = function() {
      var b = _.selectionStart, R = _.selectionEnd, D = _.value;
      if (D === void 0 && (D = ""), b === R) {
        var y = Q(D, b);
        y !== b && re(_, y, D);
      }
    };
    U(), requestAnimationFrame(function() {
      U();
    }), h(T);
  }, $e = function(T) {
    T.persist && T.persist();
    var _ = T.target, U = T.currentTarget;
    k.current = _, N.current.focusTimeout = setTimeout(function() {
      var b = _.selectionStart, R = _.selectionEnd, D = _.value;
      D === void 0 && (D = "");
      var y = Q(D, b);
      y !== b && !(b === 0 && R === D.length) && re(_, y, D), v(Object.assign(Object.assign({}, T), { currentTarget: U }));
    }, 0);
  }, Le = function(T) {
    k.current = null, clearTimeout(N.current.focusTimeout), clearTimeout(N.current.setCaretTimeout), S(T);
  }, _e = G && Us() ? "numeric" : void 0, Be = Object.assign({ inputMode: _e }, w, {
    type: n,
    value: A,
    onChange: Ce,
    onKeyDown: we,
    onMouseUp: xe,
    onFocus: $e,
    onBlur: Le
  });
  if (t === "text")
    return o ? Ct.createElement(Ct.Fragment, null, o(A, w) || null) : Ct.createElement("span", Object.assign({}, w, { ref: i }), A);
  if (r) {
    var be = r;
    return Ct.createElement(be, Object.assign({}, Be, { ref: i }));
  }
  return Ct.createElement("input", Object.assign({}, Be, { ref: i }));
}
function Dr(e, n) {
  var t = n.decimalScale, r = n.fixedDecimalScale, o = n.prefix;
  o === void 0 && (o = "");
  var i = n.suffix;
  i === void 0 && (i = "");
  var a = n.allowNegative, l = n.thousandsGroupStyle;
  if (l === void 0 && (l = "thousand"), e === "" || e === "-")
    return e;
  var u = en(n), s = u.thousandSeparator, d = u.decimalSeparator, f = t !== 0 && e.indexOf(".") !== -1 || t && r, p = pr(e, a), c = p.beforeDecimal, h = p.afterDecimal, v = p.addNegation;
  return t !== void 0 && (h = Lo(h, t, !!r)), s && (c = Hs(c, s, l)), o && (c = o + c), i && (h = h + i), v && (c = "-" + c), e = c + (f && d || "") + h, e;
}
function en(e) {
  var n = e.decimalSeparator;
  n === void 0 && (n = ".");
  var t = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return t === !0 && (t = ","), r || (r = [n, "."]), {
    decimalSeparator: n,
    thousandSeparator: t,
    allowedDecimalSeparators: r
  };
}
function Zs(e, n) {
  e === void 0 && (e = "");
  var t = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), o = t.test(e), i = r.test(e);
  return e = e.replace(/-/g, ""), o && !i && n && (e = "-" + e), e;
}
function Qs(e, n) {
  return new RegExp("(^-)|[0-9]|" + No(e), n ? "g" : void 0);
}
function eu(e, n, t) {
  return e === "" ? !0 : !(n != null && n.match(/\d/)) && !(t != null && t.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function tu(e, n, t) {
  var r;
  n === void 0 && (n = Ho(e));
  var o = t.allowNegative, i = t.prefix;
  i === void 0 && (i = "");
  var a = t.suffix;
  a === void 0 && (a = "");
  var l = t.decimalScale, u = n.from, s = n.to, d = s.start, f = s.end, p = en(t), c = p.allowedDecimalSeparators, h = p.decimalSeparator, v = e[f] === h;
  if (at(e) && (e === i || e === a) && n.lastValue === "")
    return e;
  if (f - d === 1 && c.indexOf(e[d]) !== -1) {
    var S = l === 0 ? "" : h;
    e = e.substring(0, d) + S + e.substring(d + 1, e.length);
  }
  var C = function(N, ne, ee) {
    var re = !1, Q = !1;
    i.startsWith("-") ? re = !1 : N.startsWith("--") ? (re = !1, Q = !0) : a.startsWith("-") && N.length === a.length ? re = !1 : N[0] === "-" && (re = !0);
    var ae = re ? 1 : 0;
    return Q && (ae = 2), ae && (N = N.substring(ae), ne -= ae, ee -= ae), { value: N, start: ne, end: ee, hasNegation: re };
  }, P = C(e, d, f), F = P.hasNegation;
  r = P, e = r.value, d = r.start, f = r.end;
  var E = C(n.lastValue, u.start, u.end), w = E.start, I = E.end, B = E.value, A = e.substring(d, f);
  e.length && B.length && (w > B.length - a.length || I < i.length) && !(A && a.startsWith(A)) && (e = B);
  var Y = 0;
  e.startsWith(i) ? Y += i.length : d < i.length && (Y = d), e = e.substring(Y), f -= Y;
  var O = e.length, M = e.length - a.length;
  e.endsWith(a) ? O = M : (f > M || f > e.length - a.length) && (O = f), e = e.substring(0, O), e = Zs(F ? "-" + e : e, o), e = (e.match(Qs(h, !0)) || []).join("");
  var q = e.indexOf(h);
  e = e.replace(new RegExp(No(h), "g"), function(N, ne) {
    return ne === q ? "." : "";
  });
  var V = pr(e, o), G = V.beforeDecimal, me = V.afterDecimal, k = V.addNegation;
  return s.end - s.start < u.end - u.start && G === "" && v && !parseFloat(me) && (e = k ? "-" : ""), e;
}
function nu(e, n) {
  var t = n.prefix;
  t === void 0 && (t = "");
  var r = n.suffix;
  r === void 0 && (r = "");
  var o = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), i = e[0] === "-";
  o.fill(!1, 0, t.length + (i ? 1 : 0));
  var a = e.length;
  return o.fill(!1, a - r.length + 1, a + 1), o;
}
function ru(e) {
  var n = en(e), t = n.thousandSeparator, r = n.decimalSeparator, o = e.prefix;
  o === void 0 && (o = "");
  var i = e.allowNegative;
  if (i === void 0 && (i = !0), t === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + t + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return o.startsWith("-") && i && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + o + `
      allowNegative: ` + i + `
    `), i = !1), Object.assign(Object.assign({}, e), { allowNegative: i });
}
function ou(e) {
  e = ru(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var n = e.suffix, t = e.allowNegative, r = e.allowLeadingZeros, o = e.onKeyDown;
  o === void 0 && (o = He);
  var i = e.onBlur;
  i === void 0 && (i = He);
  var a = e.thousandSeparator, l = e.decimalScale, u = e.fixedDecimalScale, s = e.prefix;
  s === void 0 && (s = "");
  var d = e.defaultValue, f = e.value, p = e.valueIsNumericString, c = e.onValueChange, h = gr(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), v = en(e), S = v.decimalSeparator, C = v.allowedDecimalSeparators, P = function(k) {
    return Dr(k, e);
  }, F = function(k, N) {
    return tu(k, N, e);
  }, E = it(f) ? d : f, w = p ?? eu(E, s, n);
  it(f) ? it(d) || (w = w || typeof d == "number") : w = w || typeof f == "number";
  var I = function(k) {
    return Bo(k) ? k : (typeof k == "number" && (k = Oo(k)), w && typeof l == "number" ? Fr(k, l, !!u) : k);
  }, B = jo(I(f), I(d), !!w, P, F, c), A = B[0], Y = A.numAsString, O = A.formattedValue, M = B[1], q = function(k) {
    var N = k.target, ne = k.key, ee = N.selectionStart, re = N.selectionEnd, Q = N.value;
    if (Q === void 0 && (Q = ""), ee !== re) {
      o(k);
      return;
    }
    ne === "Backspace" && Q[0] === "-" && ee === s.length + 1 && t && je(N, 1), l && u && (ne === "Backspace" && Q[ee - 1] === S ? (je(N, ee - 1), k.preventDefault()) : ne === "Delete" && Q[ee] === S && k.preventDefault()), C != null && C.includes(ne) && Q[ee] === S && je(N, ee + 1);
    var ae = a === !0 ? "," : a;
    ne === "Backspace" && Q[ee - 1] === ae && je(N, ee - 1), ne === "Delete" && Q[ee] === ae && je(N, ee + 1), o(k);
  }, V = function(k) {
    var N = Y;
    if (N.match(/\d/g) || (N = ""), r || (N = js(N)), u && l && (N = Fr(N, l, u)), N !== Y) {
      var ne = Dr(N, e);
      M({
        formattedValue: ne,
        value: N,
        floatValue: parseFloat(N)
      }, {
        event: k,
        source: $t.event
      });
    }
    i(k);
  }, G = function(k) {
    return k === S ? !0 : at(k);
  }, me = function(k) {
    var N = k.currentValue, ne = k.lastValue, ee = k.formattedValue, re = k.currentValueIndex, Q = k.formattedValueIndex, ae = N[re], le = ee[Q], Ie = zo(ne, N), Se = Ie.to;
    return re >= Se.start && re < Se.end && C && C.includes(ae) && le === S ? !0 : ae === le;
  };
  return Object.assign(Object.assign({}, h), {
    value: O,
    valueIsNumericString: !1,
    isValidInputCharacter: G,
    isCharacterSame: me,
    onValueChange: M,
    format: P,
    removeFormatting: F,
    getCaretBoundary: function(k) {
      return nu(k, e);
    },
    onKeyDown: q,
    onBlur: V
  });
}
function iu(e, n) {
  var t = n.format, r = n.allowEmptyFormatting, o = n.mask, i = n.patternChar;
  if (i === void 0 && (i = "#"), e === "" && !r)
    return "";
  for (var a = 0, l = t.split(""), u = 0, s = t.length; u < s; u++)
    t[u] === i && (l[u] = e[a] || Go(o, a), a += 1);
  return l.join("");
}
function au(e, n, t) {
  n === void 0 && (n = Ho(e));
  var r = t.format, o = t.patternChar;
  o === void 0 && (o = "#");
  var i = n.from, a = n.to, l = n.lastValue;
  l === void 0 && (l = "");
  var u = function(S) {
    return r[S] === o;
  }, s = function(S, C) {
    for (var P = "", F = 0; F < S.length; F++)
      u(C + F) && at(S[F]) && (P += S[F]);
    return P;
  }, d = function(S) {
    return S.replace(/[^0-9]/g, "");
  };
  if (!r.match(/\d/))
    return d(e);
  if (l === "" && e.length === r.length) {
    for (var f = "", p = 0; p < e.length; p++)
      if (u(p))
        at(e[p]) && (f += e[p]);
      else if (e[p] !== r[p])
        return d(e);
    return f;
  }
  var c = l.substring(0, i.start), h = e.substring(a.start, a.end), v = l.substring(i.end);
  return "" + s(c, 0) + d(h) + s(v, i.end);
}
function lu(e, n) {
  var t = n.format, r = n.mask, o = n.patternChar;
  o === void 0 && (o = "#");
  var i = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), a = 0, l = -1, u = {};
  t.split("").forEach(function(p, c) {
    var h = void 0;
    p === o && (a++, h = Go(r, a - 1), l === -1 && e[c] === h && (l = c)), u[c] = h;
  });
  for (var s = function(p) {
    return t[p] === o && e[p] !== u[p];
  }, d = 0, f = i.length; d < f; d++)
    i[d] = d === l || s(d) || s(d - 1);
  return i[t.indexOf(o)] = !0, i;
}
function su(e) {
  var n = e.mask;
  if (n) {
    var t = n === "string" ? n : n.toString();
    if (t.match(/\d/g))
      throw new Error("Mask " + n + " should not contain numeric character;");
  }
}
function uu(e, n) {
  return e === "" ? !0 : !(n != null && n.match(/\d/)) && typeof e == "string" && (!!e.match(/^\d+$/) || e === "");
}
function cu(e) {
  e.mask, e.allowEmptyFormatting;
  var n = e.format, t = e.inputMode;
  t === void 0 && (t = "numeric");
  var r = e.onKeyDown;
  r === void 0 && (r = He);
  var o = e.patternChar;
  o === void 0 && (o = "#");
  var i = e.value, a = e.defaultValue, l = e.valueIsNumericString, u = gr(e, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
  su(e);
  var s = function(h) {
    return lu(h, e);
  }, d = function(h) {
    var v = h.key, S = h.target, C = S.selectionStart, P = S.selectionEnd, F = S.value;
    if (C !== P) {
      r(h);
      return;
    }
    var E = C;
    if (v === "Backspace" || v === "Delete") {
      var w = "right";
      if (v === "Backspace") {
        for (; E > 0 && n[E - 1] !== o; )
          E--;
        w = "left";
      } else {
        for (var I = n.length; E < I && n[E] !== o; )
          E++;
        w = "right";
      }
      E = Ut(F, E, s(F), w);
    } else
      n[E] !== o && v !== "ArrowLeft" && v !== "ArrowRight" && (E = Ut(F, E + 1, s(F), "right"));
    E !== C && je(S, E), r(h);
  }, f = it(i) ? a : i, p = l ?? uu(f, n), c = Object.assign(Object.assign({}, e), { valueIsNumericString: p });
  return Object.assign(Object.assign({}, u), {
    value: i,
    defaultValue: a,
    valueIsNumericString: p,
    inputMode: t,
    format: function(h) {
      return iu(h, c);
    },
    removeFormatting: function(h, v) {
      return au(h, v, c);
    },
    getCaretBoundary: s,
    onKeyDown: d
  });
}
const du = Z(() => te({}), { name: "gNumberField" }), Uo = ue((e, n) => {
  const t = j(), r = W({ name: "gNumberField", props: { ...e }, theme: t }), { classes: o = {} } = r, i = ou({ ...r }), a = ie(du(), o);
  return /* @__PURE__ */ g(
    Wo,
    {
      classes: a,
      customInput: Te,
      getInputRef: n,
      ...i
    }
  );
});
Uo.displayName = "NumberField";
const kv = ({ column: e }) => {
  const { id: n, getFilterValue: t, setFilterValue: r } = e;
  return /* @__PURE__ */ g(
    Uo,
    {
      size: "small",
      fullWidth: !0,
      name: n,
      InputLabelProps: { htmlFor: n },
      onChange: (o) => {
        r(o.target.value || void 0);
      },
      value: t() || "",
      InputProps: {
        inputProps: { "aria-label": e.columnDef.header },
        startAdornment: /* @__PURE__ */ g(qe, { position: "start", children: /* @__PURE__ */ g(ar, { fontSize: "small" }) })
      }
    }
  );
}, hn = (e, n = "dd/MM/yyyy", t = /* @__PURE__ */ new Date(), r) => lr(e, n, t, r), vn = (e, n = "dd/MM/yyyy HH:mm", t = /* @__PURE__ */ new Date(), r) => lr(e, n, t, r), yn = (e) => {
  const n = Ke(/* @__PURE__ */ new Date(), "dd/MM/yyyy");
  return lr(`${n} ${e}`, "dd/MM/yyyy HH:mm", /* @__PURE__ */ new Date());
}, Qe = (e) => yo(e, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
var qo = /* @__PURE__ */ ((e) => (e[e.SUNDAY = 0] = "SUNDAY", e[e.MONDAY = 1] = "MONDAY", e[e.TUESDAY = 2] = "TUESDAY", e[e.WEDNESDAY = 3] = "WEDNESDAY", e[e.THURSDAY = 4] = "THURSDAY", e[e.FRIDAY = 5] = "FRIDAY", e[e.SATURDAY = 6] = "SATURDAY", e))(qo || {});
const Ko = (e, n, t) => (Ge(e, n) || Ft(e, n)) && (Ge(e, t) || So(e, t)), Sn = (e, n, t = !0) => !!n.before && So(e, t ? Qe(n.before) : n.before) || !!n.after && Ft(e, t ? Qe(n.after) : n.after) || !!n.between && Ko(
  e,
  t ? Qe(n.between[0]) : n.between[0],
  t ? Qe(n.between[1]) : n.between[1]
) || !!n.exact && n.exact.some((r) => Ge(e, t ? Qe(r) : r)), Yo = ro(void 0), Ee = ({
  children: e,
  options: n
}) => {
  const {
    weekStartsOn: t = qo.MONDAY,
    viewing: r = /* @__PURE__ */ new Date(),
    value: o = [],
    numberOfMonths: i = 1,
    disabled: a = !1,
    selectivity: l
  } = n || {}, [u, s] = oe(r), [d, f] = oe(null), [p, c] = oe(!1), h = L(() => s(Ka()), [s]), v = L((b) => s((R) => Ya(R, b)), []), S = L(() => s((b) => Ja(b, 1)), []), C = L(() => s((b) => Cr(b, 1)), []), P = L((b) => s((R) => Xa(R, b)), []), F = L(() => s((b) => Za(b, 1)), []), E = L(() => s((b) => Qa(b, 1)), []), [w, I] = oe(o), B = L(() => I([]), []), A = L(
    (b) => w.findIndex((R) => Ge(R, b)) > -1,
    [w]
  ), Y = L(
    (b) => w.findIndex((R) => Ge(Qe(R), b)) > -1,
    [w]
  ), O = L(
    (b) => {
      if (a)
        return !1;
      if (l) {
        const R = Sn(b, l.period);
        return l.state === "enable" ? R : !R;
      }
      return !0;
    },
    [l, a]
  ), M = L((b, R) => {
    I(R ? Array.isArray(b) ? b : [b] : (D) => D.concat(Array.isArray(b) ? b : [b]));
  }, []), q = L(
    (b) => I(
      (R) => Array.isArray(b) ? R.filter((D) => !b.map((y) => y.getTime()).includes(D.getTime())) : R.filter((D) => !Ge(D, b))
    ),
    []
  ), V = L(
    (b, R) => A(b) ? q(b) : M(b, R),
    [q, A, M]
  ), G = L(
    (b, R, D, y) => {
      const x = tt({ start: b, end: R }), $ = [b, ...x.slice(1, -1), y ? el(R) : R];
      I(D ? $ : (ce) => ce.concat($));
    },
    []
  ), me = L((b, R) => {
    I((D) => D.filter((y) => !tt({ start: b, end: R }).map((x) => nt(y, x))));
  }, []), k = L(
    (b, R = !0) => {
      if (!l)
        return !1;
      const D = Sn(b, l.period, R);
      return l.state === "enable" ? !D : D;
    },
    [l]
  ), N = L(
    ([b, R], D = !0) => {
      if (!l)
        return !1;
      const y = tt({ start: b, end: R }), x = (Ge(b, R) ? y : [b, ...y.slice(1, -1), R]).some(($) => Sn($, l.period, D));
      return l.state === "enable" ? !x : x;
    },
    [l]
  ), ne = L(
    (b) => {
      const R = w.length > 0 ? tl(nl(b, rl(w[0])), ol(w[0])) : b;
      V(R, !0);
    },
    [w, V]
  ), ee = L(
    (b) => {
      const R = w.sort((D, y) => il(D, y));
      R.length === 0 ? M(b) : R.length === 1 ? G(ho([R[0], b]), vo([R[0], b]), !0, !0) : M(b, !0);
    },
    [M, G, w]
  ), re = (b) => {
    b.key === "Enter" && (b.preventDefault(), c(!1));
  }, Q = L(
    ({
      day: b,
      onClick: R,
      onKeyDown: D,
      className: y
    }) => ({
      key: `${b}`,
      onClick: (x) => {
        x.preventDefault(), ne(b), R && R(b);
      },
      onKeyDown: (x) => {
        re(x), D && D(x);
      },
      disabled: !O(b) && !A(b),
      className: y
    }),
    [O, A, ne]
  ), ae = L(
    ({
      day: b,
      onClick: R,
      onKeyDown: D,
      className: y
    }) => ({
      key: `${b}`,
      onClick: (x) => {
        x.preventDefault(), ee(b), R && R(b);
      },
      onKeyDown: (x) => {
        re(x), D && D(x);
      },
      disabled: !O(b) && !A(b),
      className: y
    }),
    [O, A, ee]
  ), le = (b, R, D) => {
    if (b.key === "Enter") {
      b.preventDefault();
      const y = b.target;
      y == null || y.blur(), c(!1), D(R);
    }
  }, Ie = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const R = hn(b), D = Oe(R);
      D ? M(R, !0) : D ? w.length > 0 && k(w[0]) && f({ reason: "invalidSelection" }) : f({ reason: "invalidDate" });
    },
    [B, k, M, w]
  ), Se = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y,
      disabled: x
    }) => ({
      disabled: x,
      onChange: ($) => {
        f(null), R && R($);
      },
      onFocus: () => c(!0),
      onBlur: ($) => {
        Ie(b), D && D($);
      },
      onKeyDown: ($) => {
        le($, b, Ie), y && y($);
      },
      error: !!d
    }),
    [d, Ie]
  ), Ve = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const [R, D] = b.split("-"), y = hn(R.trim()), x = hn(D.trim()), $ = Oe(y) && Oe(x) && (nt || Ft(x, y));
      $ ? G(y, x, !0) : $ ? w.length > 1 && N([w[0], w[w.length - 1]]) && f({ reason: "invalidRangeSelection" }) : f({ reason: "invalidRange" });
    },
    [B, N, G, w]
  ), Ce = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y,
      disabled: x
    }) => ({
      disabled: x,
      onChange: ($) => {
        f(null), R && R($);
      },
      onFocus: () => c(!0),
      onBlur: ($) => {
        Ve(b), D && D($);
      },
      onKeyDown: ($) => {
        le($, b, Ve), y && y($);
      },
      error: !!d
    }),
    [d, Ve]
  ), we = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const R = vn(b), D = Oe(R);
      D ? M(R, !0) : D ? w.length > 0 && k(w[0], !1) && f({ reason: "invalidSelection" }) : f({ reason: "invalidDate" });
    },
    [B, k, M, w]
  ), xe = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y,
      disabled: x
    }) => ({
      disabled: x,
      onChange: ($) => {
        f(null), R && R($);
      },
      onFocus: () => c(!0),
      onBlur: ($) => {
        we(b), D && D($);
      },
      onKeyDown: ($) => {
        le($, b, we), y && y($);
      },
      error: !!d
    }),
    [d, we]
  ), $e = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const [R, D] = b.split("-"), y = vn(R.trim()), x = vn(D.trim()), $ = Oe(y) && Oe(x) && Ft(x, y);
      $ ? G(y, x, !0) : $ ? w.length > 1 && N([w[0], w[w.length - 1]], !1) && f({ reason: "invalidRangeSelection" }) : f({ reason: "invalidRange" });
    },
    [B, N, G, w]
  ), Le = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y,
      disabled: x
    }) => ({
      disabled: x,
      onChange: ($) => {
        f(null), R && R($);
      },
      onFocus: () => c(!0),
      onBlur: ($) => {
        $e(b), D && D($);
      },
      onKeyDown: ($) => {
        le($, b, $e), y && y($);
      },
      error: !!d
    }),
    [d, $e]
  ), _e = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const R = yn(b), D = Oe(R);
      D ? M(R, !0) : D ? w.length > 0 && k(w[0], !1) && f({ reason: "invalidTimeSelection" }) : f({ reason: "invalidTime" });
    },
    [B, k, M, w]
  ), Be = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y
    }) => ({
      onChange: (x) => {
        f(null), R && R(x);
      },
      onBlur: (x) => {
        _e(b), D && D(x);
      },
      onKeyDown: (x) => {
        le(x, b, _e), y && y(x);
      },
      error: !!d
    }),
    [d, _e]
  ), be = L(
    (b) => {
      if (b === "") {
        B();
        return;
      }
      const [R, D] = b.split("-"), y = yn(R.trim()), x = yn(D.trim()), $ = Oe(y) && Oe(x) && Ft(x, y);
      $ ? G(y, x, !0) : $ ? w.length > 1 && N([w[0], w[w.length - 1]], !1) && f({ reason: "invalidTimeRangeSelection" }) : f({ reason: "invalidTimeRange" });
    },
    [B, N, G, w]
  ), T = L(
    ({
      inputValue: b,
      onChange: R,
      onBlur: D,
      onKeyDown: y
    }) => ({
      onChange: (x) => {
        f(null), R && R(x);
      },
      onBlur: (x) => {
        be(b), D && D(x);
      },
      onKeyDown: (x) => {
        le(x, b, be), y && y(x);
      },
      error: !!d
    }),
    [d, be]
  ), _ = ye(
    () => al({
      start: kn(u),
      end: An(Cr(u, i - 1))
    }).map(
      (b) => ll(
        {
          start: kn(b),
          end: An(b)
        },
        { weekStartsOn: t }
      ).map(
        (R) => tt({
          start: sl(R, { weekStartsOn: t }),
          end: ul(R, { weekStartsOn: t })
        })
      )
    ),
    [u, t, i]
  ), U = ye(
    () => ({
      clearTime: Qe,
      inRange: Ko,
      isSelectable: O,
      hasError: k,
      error: d,
      setError: f,
      hasRangeError: N,
      disabled: a,
      open: p,
      setOpen: c,
      viewing: u,
      setViewing: s,
      viewToday: h,
      viewMonth: v,
      viewPreviousMonth: S,
      viewNextMonth: C,
      viewYear: P,
      viewPreviousYear: F,
      viewNextYear: E,
      value: w,
      setValue: I,
      clearSelected: B,
      isSelected: A,
      isSelectedDay: Y,
      select: M,
      deselect: q,
      toggle: V,
      selectRange: G,
      deselectRange: me,
      calendar: _,
      getCalendarButtonProps: Q,
      getRangeCalendarButtonProps: ae,
      getDateInputProps: Se,
      getDateRangeInputProps: Ce,
      getDateTimeInputProps: xe,
      getDateTimeRangeInputProps: Le,
      getTimeInputProps: Be,
      getTimeRangeInputProps: T
    }),
    [
      O,
      k,
      d,
      f,
      N,
      a,
      p,
      c,
      u,
      s,
      h,
      v,
      S,
      C,
      P,
      F,
      E,
      w,
      I,
      B,
      A,
      Y,
      M,
      q,
      V,
      G,
      me,
      _,
      Q,
      ae,
      Se,
      Ce,
      xe,
      Le,
      Be,
      T
    ]
  );
  return /* @__PURE__ */ g(Yo.Provider, { value: U, children: e });
};
function De() {
  const e = oo(Yo);
  if (!e)
    throw new Error("useDatePicker must be used within DatePickerProvider");
  return e;
}
const gu = (e, n) => {
  if (e != null) {
    if (typeof e == "function") {
      e(n);
      return;
    }
    try {
      e.current = n;
    } catch {
      throw new Error(`Cannot assign value '${n}' to ref '${e}'`);
    }
  }
}, pu = (...e) => (n) => {
  e.forEach((t) => {
    gu(t, n);
  });
}, Jo = (...e) => ye(() => pu(...e), e), dt = (e) => {
  let n = "";
  switch (e.reason) {
    case "invalidDate":
      n = "Invalid date format";
      break;
    case "invalidRange":
      n = "Invalid date range";
      break;
    case "invalidTime":
      n = "Invalid time format";
      break;
    case "invalidTimeRange":
      n = "Invalid time range";
      break;
    case "invalidSelection":
      n = "Date does not meet selection criteria";
      break;
    case "invalidTimeSelection":
      n = "Time does not meet selection criteria";
      break;
    case "invalidRangeSelection":
      n = "Date range does not meet selection criteria";
      break;
    case "invalidTimeRangeSelection":
      n = "Time range does not meet selection criteria";
      break;
    default:
      n = "Unknown error";
  }
  return n;
}, fu = (e) => {
  const n = e.getBoundingClientRect(), t = window.innerWidth || document.documentElement.clientWidth, r = window.innerHeight || document.documentElement.clientHeight, o = n.top - n.height < 0, i = n.left < 0, a = n.left + n.width > t, l = n.top + n.height > r;
  return [o ? "top" : "", a ? "right" : "", l ? "bottom" : "", i ? "left" : ""].filter(Boolean).join("-");
}, Xo = ({ offset: e }) => {
  const n = L(
    (r) => {
      const o = fu(r), { vertical: i = 0, horizontal: a = 0 } = e || {};
      switch (o) {
        case "top-right":
          return {
            top: null,
            right: `${a}px`,
            bottom: null,
            left: null
          };
        case "bottom":
          return {
            top: null,
            bottom: `${i}px`,
            left: null,
            right: null
          };
        case "right":
          return {
            top: null,
            right: `${a}px`,
            bottom: null,
            left: null
          };
        case "right-bottom":
          return {
            top: null,
            right: `${a}px`,
            bottom: `${i}px`,
            left: null
          };
        default:
          return {
            top: null,
            right: null,
            bottom: null,
            left: null
          };
      }
    },
    [e]
  );
  return { setPositioningStyles: L(
    (r) => {
      if (!r)
        return;
      const o = n(r);
      o.top !== null && (r.style.top = o.top), o.right !== null && (r.style.right = o.right), o.bottom !== null && (r.style.bottom = o.bottom), o.left !== null && (r.style.left = o.left);
    },
    [n]
  ) };
}, mu = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1440
  }
}, hu = "#ffffff", vu = "#000000", yu = "#f8f8f8", Su = "#dadada", Cu = "#c2c2c2", bu = "#aaaaaa", wu = "#919191", xu = "#7c7c7c", Ru = "#686868", Pu = "#555555", Fu = "#434343", Du = "#323232", Iu = "#232323", Mu = "#D5D5D5", $u = "#AAAAAA", ku = "#303030", Au = "#616161", Tu = "#F7F9FA", Zo = "#F2F5F7", Eu = "#DCE2E8", Qo = "#C1CCD6", ei = "#9FAFBD", Vu = "#7A8E9E", tn = "#5B7082", _u = "#3E5263", ti = "#2A3D4D", Bu = "#1C2936", ni = "#0F1820", Nu = "#0F1820", Lu = "#0F1820", Ou = "#0F1820", zu = "#0F1820", ri = "#F2F7FC", Hu = "#e5f0f9", Gu = "#cde1f3", ju = "#b3d2ed", Wu = "#9bc3e7", Uu = "#81b4e1", oi = "#68a6dc", qu = "#5097d6", Ku = "#3688d0", Yu = "#1e79ca", ii = "#046ac4", Ju = "#03559d", ai = "#024076", Xu = "#02335E", Zu = "#022a4e", li = "#10C6FF", si = "#f4faea", Qu = "#ebf7da", ec = "#d6f0b1", tc = "#aad971", ui = "#79bf38", nc = "#53a31c", ci = "#3d7d0e", rc = "#2f5c0e", di = "#264211", oc = "#1c2e10", ic = "#081a15", ac = "#081a15", lc = "#081a15", sc = "#081a15", gi = "#fcf8f8", uc = "#fcf0f0", cc = "#fadcd9", dc = "#fabbb4", pi = "#fc9086", gc = "#fa5243", fi = "#d91f10", pc = "#a0150a", mi = "#75160c", fc = "#4f150f", mc = "#24120c", hc = "#24120c", vc = "#24120c", yc = "#24120c", hi = "#fef8f3", Sc = "#fdf0e7", Cc = "#fde2d0", bc = "#fbd4b7", wc = "#fac6a0", xc = "#f9b788", vi = "#f8a971", Rc = "#f79b5a", Pc = "#f58d41", Fc = "#f57f2a", yi = "#f37012", Dc = "#c25a0e", Si = "#92430b", Ic = "#612d07", Ci = "#f5f6fa", Mc = "#eaedf5", $c = "#d7dceb", kc = "#c2cbe1", Ac = "#aebad8", Tc = "#9aa8ce", Ec = "#8697c4", Vc = "#7286bb", bi = "#5d75b1", _c = "#4a64a7", wi = "#35529d", Bc = "#2a427e", xi = "#20315e", Nc = "#15213f", Lc = "#fdf6fa", Oc = "#fbedf4", zc = "#f7dbea", Hc = "#f3c9e0", Gc = "#efb7d6", jc = "#eba5cb", Wc = "#e793c1", Uc = "#e382b7", qc = "#df6fad", Kc = "#db5ea3", Yc = "#d74b98", Jc = "#ac3c7a", Xc = "#812d5b", Zc = "#561e3d", Ri = "#f3f9fb", Qc = "#e7f3f7", ed = "#cfe7f0", td = "#b7dbe8", nd = "#9fcfe1", rd = "#87c3da", Pi = "#87c3da", od = "#58accc", id = "#409fc4", ad = "#2894bd", Fi = "#1087b5", ld = "#0d6c91", Di = "#0a516d", sd = "#063648", ud = Zo, cd = Qo, dd = tn, gd = ti, pd = ni, fd = tn, md = ei, hd = tn, vd = wi, yd = bi, Sd = xi, Cd = Ci, bd = ui, wd = ci, xd = di, Rd = si, Pd = pi, Fd = fi, Dd = mi, Id = gi, Md = vi, $d = yi, kd = Si, Ad = hi, Td = oi, Ed = ii, Vd = ai, _d = ri, Bd = li, Nd = Pi, Ld = Fi, Od = Di, zd = Ri, m = {
  white: hu,
  black: vu,
  gray50: Tu,
  gray100: Zo,
  gray200: Eu,
  gray300: Qo,
  gray400: ei,
  gray500: Vu,
  gray600: tn,
  gray700: _u,
  gray800: ti,
  gray900: Bu,
  gray1000: ni,
  gray1200: Nu,
  gray1400: Lu,
  gray1600: Ou,
  gray1800: zu,
  grey50: yu,
  grey100: Su,
  grey200: Cu,
  grey300: bu,
  grey400: wu,
  grey500: xu,
  grey600: Ru,
  grey700: Pu,
  grey800: Fu,
  grey900: Du,
  grey1000: Iu,
  greyA100: Mu,
  greyA200: $u,
  greyA400: ku,
  greyA700: Au,
  blue50: ri,
  blue100: Hu,
  blue200: Gu,
  blue300: ju,
  blue400: Wu,
  blue500: Uu,
  blue600: oi,
  blue700: qu,
  blue800: Ku,
  blue900: Yu,
  blue1000: ii,
  blue1200: Ju,
  blue1400: ai,
  blue1500: Xu,
  blue1600: Zu,
  green50: si,
  green100: Qu,
  green200: ec,
  green300: tc,
  green400: ui,
  green500: nc,
  green600: ci,
  green700: rc,
  green800: di,
  green900: oc,
  green1000: ic,
  green1200: ac,
  green1400: lc,
  green1600: sc,
  red50: gi,
  red100: uc,
  red200: cc,
  red300: dc,
  red400: pi,
  red500: gc,
  red600: fi,
  red700: pc,
  red800: mi,
  red900: fc,
  red1000: mc,
  red1200: hc,
  red1400: vc,
  red1600: yc,
  orange50: hi,
  orange100: Sc,
  orange200: Cc,
  orange300: bc,
  orange400: wc,
  orange500: xc,
  orange600: vi,
  orange700: Rc,
  orange800: Pc,
  orange900: Fc,
  orange1000: yi,
  orange1200: Dc,
  orange1400: Si,
  orange1600: Ic,
  violet50: Ci,
  violet100: Mc,
  violet200: $c,
  violet300: kc,
  violet400: Ac,
  violet500: Tc,
  violet600: Ec,
  violet700: Vc,
  violet800: bi,
  violet900: _c,
  violet1000: wi,
  violet1200: Bc,
  violet1400: xi,
  violet1600: Nc,
  magenta50: Lc,
  magenta100: Oc,
  magenta200: zc,
  magenta300: Hc,
  magenta400: Gc,
  magenta500: jc,
  magenta600: Wc,
  magenta700: Uc,
  magenta800: qc,
  magenta900: Kc,
  magenta1000: Yc,
  magenta1200: Jc,
  magenta1400: Xc,
  magenta1600: Zc,
  cyan50: Ri,
  cyan100: Qc,
  cyan200: ed,
  cyan300: td,
  cyan400: nd,
  cyan500: rd,
  cyan600: Pi,
  cyan700: od,
  cyan800: id,
  cyan900: ad,
  cyan1000: Fi,
  cyan1200: ld,
  cyan1400: Di,
  cyan1600: sd,
  neutralLighter: ud,
  neutralLight: cd,
  neutralBase: dd,
  neutralDark: gd,
  successLight: bd,
  successMain: wd,
  successDark: xd,
  successContrast: Rd,
  errorLight: Pd,
  errorMain: Fd,
  errorDark: Dd,
  errorContrast: Id,
  warningLight: Md,
  warningMain: $d,
  warningDark: kd,
  warningContrast: Ad,
  infoLight: yd,
  infoMain: vd,
  infoDark: Sd,
  infoContrast: Cd,
  primaryLight: Td,
  primaryMain: Ed,
  primaryDark: Vd,
  primaryContrast: _d,
  primaryAccent: Bd,
  secondaryLight: Nd,
  secondaryMain: Ld,
  secondaryDark: Od,
  secondaryContrast: zd,
  textPrimary: pd,
  textSecondary: fd,
  textDisabled: md,
  textHint: hd,
  accentBlue: li
};
function fe() {
  return fe = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, fe.apply(this, arguments);
}
var Ir = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Hd = (typeof window > "u" ? "undefined" : Ir(window)) === "object" && (typeof document > "u" ? "undefined" : Ir(document)) === "object" && document.nodeType === 9, Gd = process.env.NODE_ENV === "production";
function Fe(e, n) {
  if (!Gd) {
    if (e)
      return;
    var t = "Warning: " + n;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
function kt(e) {
  "@babel/helpers - typeof";
  return kt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, kt(e);
}
function jd(e, n) {
  if (kt(e) !== "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (kt(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function Wd(e) {
  var n = jd(e, "string");
  return kt(n) === "symbol" ? n : String(n);
}
function Mr(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Wd(r.key), r);
  }
}
function Ii(e, n, t) {
  return n && Mr(e.prototype, n), t && Mr(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Nn(e, n) {
  return Nn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, r) {
    return t.__proto__ = r, t;
  }, Nn(e, n);
}
function Mi(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Nn(e, n);
}
function $r(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ud(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var qd = {}.constructor;
function Ln(e) {
  if (e == null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(Ln);
  if (e.constructor !== qd)
    return e;
  var n = {};
  for (var t in e)
    n[t] = Ln(e[t]);
  return n;
}
function $i(e, n, t) {
  e === void 0 && (e = "unnamed");
  var r = t.jss, o = Ln(n), i = r.plugins.onCreateRule(e, o, t);
  return i || (e[0] === "@" && process.env.NODE_ENV !== "production" && Fe(!1, "[JSS] Unknown rule " + e), null);
}
var kr = function(e, n) {
  for (var t = "", r = 0; r < e.length && e[r] !== "!important"; r++)
    t && (t += n), t += e[r];
  return t;
}, It = function(e) {
  if (!Array.isArray(e))
    return e;
  var n = "";
  if (Array.isArray(e[0]))
    for (var t = 0; t < e.length && e[t] !== "!important"; t++)
      n && (n += ", "), n += kr(e[t], " ");
  else
    n = kr(e, ", ");
  return e[e.length - 1] === "!important" && (n += " !important"), n;
};
function gt(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function wt(e, n) {
  for (var t = "", r = 0; r < n; r++)
    t += "  ";
  return t + e;
}
function At(e, n, t) {
  t === void 0 && (t = {});
  var r = "";
  if (!n)
    return r;
  var o = t, i = o.indent, a = i === void 0 ? 0 : i, l = n.fallbacks;
  t.format === !1 && (a = -1 / 0);
  var u = gt(t), s = u.linebreak, d = u.space;
  if (e && a++, l)
    if (Array.isArray(l))
      for (var f = 0; f < l.length; f++) {
        var p = l[f];
        for (var c in p) {
          var h = p[c];
          h != null && (r && (r += s), r += wt(c + ":" + d + It(h) + ";", a));
        }
      }
    else
      for (var v in l) {
        var S = l[v];
        S != null && (r && (r += s), r += wt(v + ":" + d + It(S) + ";", a));
      }
  for (var C in n) {
    var P = n[C];
    P != null && C !== "fallbacks" && (r && (r += s), r += wt(C + ":" + d + It(P) + ";", a));
  }
  return !r && !t.allowEmpty || !e ? r : (a--, r && (r = "" + s + r + s), wt("" + e + d + "{" + r, a) + wt("}", a));
}
var Kd = /([[\].#*$><+~=|^:(),"'`\s])/g, Ar = typeof CSS < "u" && CSS.escape, fr = function(e) {
  return Ar ? Ar(e) : e.replace(Kd, "\\$1");
}, ki = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "style", this.isProcessed = !1;
    var i = o.sheet, a = o.Renderer;
    this.key = t, this.options = o, this.style = r, i ? this.renderer = i.renderer : a && (this.renderer = new a());
  }
  var n = e.prototype;
  return n.prop = function(t, r, o) {
    if (r === void 0)
      return this.style[t];
    var i = o ? o.force : !1;
    if (!i && this.style[t] === r)
      return this;
    var a = r;
    (!o || o.process !== !1) && (a = this.options.jss.plugins.onChangeValue(r, t, this));
    var l = a == null || a === !1, u = t in this.style;
    if (l && !u && !i)
      return this;
    var s = l && u;
    if (s ? delete this.style[t] : this.style[t] = a, this.renderable && this.renderer)
      return s ? this.renderer.removeProperty(this.renderable, t) : this.renderer.setProperty(this.renderable, t, a), this;
    var d = this.options.sheet;
    return d && d.attached && process.env.NODE_ENV !== "production" && Fe(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), On = /* @__PURE__ */ function(e) {
  Mi(n, e);
  function n(r, o, i) {
    var a;
    a = e.call(this, r, o, i) || this;
    var l = i.selector, u = i.scoped, s = i.sheet, d = i.generateId;
    return l ? a.selectorText = l : u !== !1 && (a.id = d($r($r(a)), s), a.selectorText = "." + fr(a.id)), a;
  }
  var t = n.prototype;
  return t.applyTo = function(r) {
    var o = this.renderer;
    if (o) {
      var i = this.toJSON();
      for (var a in i)
        o.setProperty(r, a, i[a]);
    }
    return this;
  }, t.toJSON = function() {
    var r = {};
    for (var o in this.style) {
      var i = this.style[o];
      typeof i != "object" ? r[o] = i : Array.isArray(i) && (r[o] = It(i));
    }
    return r;
  }, t.toString = function(r) {
    var o = this.options.sheet, i = o ? o.options.link : !1, a = i ? fe({}, r, {
      allowEmpty: !0
    }) : r;
    return At(this.selectorText, this.style, a);
  }, Ii(n, [{
    key: "selector",
    set: function(r) {
      if (r !== this.selectorText) {
        this.selectorText = r;
        var o = this.renderer, i = this.renderable;
        if (!(!i || !o)) {
          var a = o.setSelector(i, r);
          a || o.replaceRule(i, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), n;
}(ki), Yd = {
  onCreateRule: function(e, n, t) {
    return e[0] === "@" || t.parent && t.parent.type === "keyframes" ? null : new On(e, n, t);
  }
}, Cn = {
  indent: 1,
  children: !0
}, Jd = /@([\w-]+)/, Xd = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "conditional", this.isProcessed = !1, this.key = t;
    var i = t.match(Jd);
    this.at = i ? i[1] : "unknown", this.query = o.name || "@" + this.at, this.options = o, this.rules = new nn(fe({}, o, {
      parent: this
    }));
    for (var a in r)
      this.rules.add(a, r[a]);
    this.rules.process();
  }
  var n = e.prototype;
  return n.getRule = function(t) {
    return this.rules.get(t);
  }, n.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, n.addRule = function(t, r, o) {
    var i = this.rules.add(t, r, o);
    return i ? (this.options.jss.plugins.onProcessRule(i), i) : null;
  }, n.replaceRule = function(t, r, o) {
    var i = this.rules.replace(t, r, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, n.toString = function(t) {
    t === void 0 && (t = Cn);
    var r = gt(t), o = r.linebreak;
    if (t.indent == null && (t.indent = Cn.indent), t.children == null && (t.children = Cn.children), t.children === !1)
      return this.query + " {}";
    var i = this.rules.toString(t);
    return i ? this.query + " {" + o + i + o + "}" : "";
  }, e;
}(), Zd = /@container|@media|@supports\s+/, Qd = {
  onCreateRule: function(e, n, t) {
    return Zd.test(e) ? new Xd(e, n, t) : null;
  }
}, bn = {
  indent: 1,
  children: !0
}, eg = /@keyframes\s+([\w-]+)/, zn = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = t.match(eg);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Fe(!1, "[JSS] Bad keyframes name " + t)), this.key = this.type + "-" + this.name, this.options = o;
    var a = o.scoped, l = o.sheet, u = o.generateId;
    this.id = a === !1 ? this.name : fr(u(this, l)), this.rules = new nn(fe({}, o, {
      parent: this
    }));
    for (var s in r)
      this.rules.add(s, r[s], fe({}, o, {
        parent: this
      }));
    this.rules.process();
  }
  var n = e.prototype;
  return n.toString = function(t) {
    t === void 0 && (t = bn);
    var r = gt(t), o = r.linebreak;
    if (t.indent == null && (t.indent = bn.indent), t.children == null && (t.children = bn.children), t.children === !1)
      return this.at + " " + this.id + " {}";
    var i = this.rules.toString(t);
    return i && (i = "" + o + i + o), this.at + " " + this.id + " {" + i + "}";
  }, e;
}(), tg = /@keyframes\s+/, ng = /\$([\w-]+)/g, Hn = function(e, n) {
  return typeof e == "string" ? e.replace(ng, function(t, r) {
    return r in n ? n[r] : (process.env.NODE_ENV !== "production" && Fe(!1, '[JSS] Referenced keyframes rule "' + r + '" is not defined.'), t);
  }) : e;
}, Tr = function(e, n, t) {
  var r = e[n], o = Hn(r, t);
  o !== r && (e[n] = o);
}, rg = {
  onCreateRule: function(e, n, t) {
    return typeof e == "string" && tg.test(e) ? new zn(e, n, t) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(e, n, t) {
    return n.type !== "style" || !t || ("animation-name" in e && Tr(e, "animation-name", t.keyframes), "animation" in e && Tr(e, "animation", t.keyframes)), e;
  },
  onChangeValue: function(e, n, t) {
    var r = t.options.sheet;
    if (!r)
      return e;
    switch (n) {
      case "animation":
        return Hn(e, r.keyframes);
      case "animation-name":
        return Hn(e, r.keyframes);
      default:
        return e;
    }
  }
}, og = /* @__PURE__ */ function(e) {
  Mi(n, e);
  function n() {
    return e.apply(this, arguments) || this;
  }
  var t = n.prototype;
  return t.toString = function(r) {
    var o = this.options.sheet, i = o ? o.options.link : !1, a = i ? fe({}, r, {
      allowEmpty: !0
    }) : r;
    return At(this.key, this.style, a);
  }, n;
}(ki), ig = {
  onCreateRule: function(e, n, t) {
    return t.parent && t.parent.type === "keyframes" ? new og(e, n, t) : null;
  }
}, ag = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = t, this.style = r, this.options = o;
  }
  var n = e.prototype;
  return n.toString = function(t) {
    var r = gt(t), o = r.linebreak;
    if (Array.isArray(this.style)) {
      for (var i = "", a = 0; a < this.style.length; a++)
        i += At(this.at, this.style[a]), this.style[a + 1] && (i += o);
      return i;
    }
    return At(this.at, this.style, t);
  }, e;
}(), lg = /@font-face/, sg = {
  onCreateRule: function(e, n, t) {
    return lg.test(e) ? new ag(e, n, t) : null;
  }
}, ug = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = t, this.style = r, this.options = o;
  }
  var n = e.prototype;
  return n.toString = function(t) {
    return At(this.key, this.style, t);
  }, e;
}(), cg = {
  onCreateRule: function(e, n, t) {
    return e === "@viewport" || e === "@-ms-viewport" ? new ug(e, n, t) : null;
  }
}, dg = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "simple", this.isProcessed = !1, this.key = t, this.value = r, this.options = o;
  }
  var n = e.prototype;
  return n.toString = function(t) {
    if (Array.isArray(this.value)) {
      for (var r = "", o = 0; o < this.value.length; o++)
        r += this.key + " " + this.value[o] + ";", this.value[o + 1] && (r += `
`);
      return r;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), gg = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, pg = {
  onCreateRule: function(e, n, t) {
    return e in gg ? new dg(e, n, t) : null;
  }
}, Er = [Yd, Qd, rg, ig, sg, cg, pg], fg = {
  process: !0
}, Vr = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, nn = /* @__PURE__ */ function() {
  function e(t) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = t, this.classes = t.classes, this.keyframes = t.keyframes;
  }
  var n = e.prototype;
  return n.add = function(t, r, o) {
    var i = this.options, a = i.parent, l = i.sheet, u = i.jss, s = i.Renderer, d = i.generateId, f = i.scoped, p = fe({
      classes: this.classes,
      parent: a,
      sheet: l,
      jss: u,
      Renderer: s,
      generateId: d,
      scoped: f,
      name: t,
      keyframes: this.keyframes,
      selector: void 0
    }, o), c = t;
    t in this.raw && (c = t + "-d" + this.counter++), this.raw[c] = r, c in this.classes && (p.selector = "." + fr(this.classes[c]));
    var h = $i(c, r, p);
    if (!h)
      return null;
    this.register(h);
    var v = p.index === void 0 ? this.index.length : p.index;
    return this.index.splice(v, 0, h), h;
  }, n.replace = function(t, r, o) {
    var i = this.get(t), a = this.index.indexOf(i);
    i && this.remove(i);
    var l = o;
    return a !== -1 && (l = fe({}, o, {
      index: a
    })), this.add(t, r, l);
  }, n.get = function(t) {
    return this.map[t];
  }, n.remove = function(t) {
    this.unregister(t), delete this.raw[t.key], this.index.splice(this.index.indexOf(t), 1);
  }, n.indexOf = function(t) {
    return this.index.indexOf(t);
  }, n.process = function() {
    var t = this.options.jss.plugins;
    this.index.slice(0).forEach(t.onProcessRule, t);
  }, n.register = function(t) {
    this.map[t.key] = t, t instanceof On ? (this.map[t.selector] = t, t.id && (this.classes[t.key] = t.id)) : t instanceof zn && this.keyframes && (this.keyframes[t.name] = t.id);
  }, n.unregister = function(t) {
    delete this.map[t.key], t instanceof On ? (delete this.map[t.selector], delete this.classes[t.key]) : t instanceof zn && delete this.keyframes[t.name];
  }, n.update = function() {
    var t, r, o;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (t = arguments.length <= 0 ? void 0 : arguments[0], r = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2]) : (r = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], t = null), t)
      this.updateOne(this.get(t), r, o);
    else
      for (var i = 0; i < this.index.length; i++)
        this.updateOne(this.index[i], r, o);
  }, n.updateOne = function(t, r, o) {
    o === void 0 && (o = fg);
    var i = this.options, a = i.jss.plugins, l = i.sheet;
    if (t.rules instanceof e) {
      t.rules.update(r, o);
      return;
    }
    var u = t.style;
    if (a.onUpdate(r, t, l, o), o.process && u && u !== t.style) {
      a.onProcessStyle(t.style, t, l);
      for (var s in t.style) {
        var d = t.style[s], f = u[s];
        d !== f && t.prop(s, d, Vr);
      }
      for (var p in u) {
        var c = t.style[p], h = u[p];
        c == null && c !== h && t.prop(p, null, Vr);
      }
    }
  }, n.toString = function(t) {
    for (var r = "", o = this.options.sheet, i = o ? o.options.link : !1, a = gt(t), l = a.linebreak, u = 0; u < this.index.length; u++) {
      var s = this.index[u], d = s.toString(t);
      !d && !i || (r && (r += l), r += d);
    }
    return r;
  }, e;
}(), Ai = /* @__PURE__ */ function() {
  function e(t, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = fe({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new nn(this.options);
    for (var o in t)
      this.rules.add(o, t[o]);
    this.rules.process();
  }
  var n = e.prototype;
  return n.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, n.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, n.addRule = function(t, r, o) {
    var i = this.queue;
    this.attached && !i && (this.queue = []);
    var a = this.rules.add(t, r, o);
    return a ? (this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && (i ? i.push(a) : (this.insertRule(a), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), a) : (this.deployed = !1, a)) : null;
  }, n.replaceRule = function(t, r, o) {
    var i = this.rules.get(t);
    if (!i)
      return this.addRule(t, r, o);
    var a = this.rules.replace(t, r, o);
    return a && this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && this.renderer && (a ? i.renderable && this.renderer.replaceRule(i.renderable, a) : this.renderer.deleteRule(i)), a) : (this.deployed = !1, a);
  }, n.insertRule = function(t) {
    this.renderer && this.renderer.insertRule(t);
  }, n.addRules = function(t, r) {
    var o = [];
    for (var i in t) {
      var a = this.addRule(i, t[i], r);
      a && o.push(a);
    }
    return o;
  }, n.getRule = function(t) {
    return this.rules.get(t);
  }, n.deleteRule = function(t) {
    var r = typeof t == "object" ? t : this.rules.get(t);
    return !r || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !r.renderable ? !1 : (this.rules.remove(r), this.attached && r.renderable && this.renderer ? this.renderer.deleteRule(r.renderable) : !0);
  }, n.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, n.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, n.update = function() {
    var t;
    return (t = this.rules).update.apply(t, arguments), this;
  }, n.updateOne = function(t, r, o) {
    return this.rules.updateOne(t, r, o), this;
  }, n.toString = function(t) {
    return this.rules.toString(t);
  }, e;
}(), mg = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var n = e.prototype;
  return n.onCreateRule = function(t, r, o) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var a = this.registry.onCreateRule[i](t, r, o);
      if (a)
        return a;
    }
    return null;
  }, n.onProcessRule = function(t) {
    if (!t.isProcessed) {
      for (var r = t.options.sheet, o = 0; o < this.registry.onProcessRule.length; o++)
        this.registry.onProcessRule[o](t, r);
      t.style && this.onProcessStyle(t.style, t, r), t.isProcessed = !0;
    }
  }, n.onProcessStyle = function(t, r, o) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++)
      r.style = this.registry.onProcessStyle[i](r.style, r, o);
  }, n.onProcessSheet = function(t) {
    for (var r = 0; r < this.registry.onProcessSheet.length; r++)
      this.registry.onProcessSheet[r](t);
  }, n.onUpdate = function(t, r, o, i) {
    for (var a = 0; a < this.registry.onUpdate.length; a++)
      this.registry.onUpdate[a](t, r, o, i);
  }, n.onChangeValue = function(t, r, o) {
    for (var i = t, a = 0; a < this.registry.onChangeValue.length; a++)
      i = this.registry.onChangeValue[a](i, r, o);
    return i;
  }, n.use = function(t, r) {
    r === void 0 && (r = {
      queue: "external"
    });
    var o = this.plugins[r.queue];
    o.indexOf(t) === -1 && (o.push(t), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(i, a) {
      for (var l in a)
        l in i ? i[l].push(a[l]) : process.env.NODE_ENV !== "production" && Fe(!1, '[JSS] Unknown hook "' + l + '".');
      return i;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), hg = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var n = e.prototype;
  return n.add = function(t) {
    var r = this.registry, o = t.options.index;
    if (r.indexOf(t) === -1) {
      if (r.length === 0 || o >= this.index) {
        r.push(t);
        return;
      }
      for (var i = 0; i < r.length; i++)
        if (r[i].options.index > o) {
          r.splice(i, 0, t);
          return;
        }
    }
  }, n.reset = function() {
    this.registry = [];
  }, n.remove = function(t) {
    var r = this.registry.indexOf(t);
    this.registry.splice(r, 1);
  }, n.toString = function(t) {
    for (var r = t === void 0 ? {} : t, o = r.attached, i = Ud(r, ["attached"]), a = gt(i), l = a.linebreak, u = "", s = 0; s < this.registry.length; s++) {
      var d = this.registry[s];
      o != null && d.attached !== o || (u && (u += l), u += d.toString(i));
    }
    return u;
  }, Ii(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), Mt = new hg(), Gn = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), jn = "2f1acc6c3a606b082e5eef5e54414ffb";
Gn[jn] == null && (Gn[jn] = 0);
var _r = Gn[jn]++, vg = 1e10, Br = function(e) {
  e === void 0 && (e = {});
  var n = 0, t = function(r, o) {
    n += 1, n > vg && process.env.NODE_ENV !== "production" && Fe(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var i = "", a = "";
    return o && (o.options.classNamePrefix && (a = o.options.classNamePrefix), o.options.jss.id != null && (i = String(o.options.jss.id))), e.minify ? "" + (a || "c") + _r + i + n : a + r.key + "-" + _r + (i ? "-" + i : "") + "-" + n;
  };
  return t;
}, Ti = function(e) {
  var n;
  return function() {
    return n || (n = e()), n;
  };
}, yg = function(e, n) {
  try {
    return e.attributeStyleMap ? e.attributeStyleMap.get(n) : e.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, Sg = function(e, n, t) {
  try {
    var r = t;
    if (Array.isArray(t) && (r = It(t)), e.attributeStyleMap)
      e.attributeStyleMap.set(n, r);
    else {
      var o = r ? r.indexOf("!important") : -1, i = o > -1 ? r.substr(0, o - 1) : r;
      e.style.setProperty(n, i, o > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, Cg = function(e, n) {
  try {
    e.attributeStyleMap ? e.attributeStyleMap.delete(n) : e.style.removeProperty(n);
  } catch (t) {
    process.env.NODE_ENV !== "production" && Fe(!1, '[JSS] DOMException "' + t.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, bg = function(e, n) {
  return e.selectorText = n, e.selectorText === n;
}, Ei = Ti(function() {
  return document.querySelector("head");
});
function wg(e, n) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    if (r.attached && r.options.index > n.index && r.options.insertionPoint === n.insertionPoint)
      return r;
  }
  return null;
}
function xg(e, n) {
  for (var t = e.length - 1; t >= 0; t--) {
    var r = e[t];
    if (r.attached && r.options.insertionPoint === n.insertionPoint)
      return r;
  }
  return null;
}
function Rg(e) {
  for (var n = Ei(), t = 0; t < n.childNodes.length; t++) {
    var r = n.childNodes[t];
    if (r.nodeType === 8 && r.nodeValue.trim() === e)
      return r;
  }
  return null;
}
function Pg(e) {
  var n = Mt.registry;
  if (n.length > 0) {
    var t = wg(n, e);
    if (t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element
      };
    if (t = xg(n, e), t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element.nextSibling
      };
  }
  var r = e.insertionPoint;
  if (r && typeof r == "string") {
    var o = Rg(r);
    if (o)
      return {
        parent: o.parentNode,
        node: o.nextSibling
      };
    process.env.NODE_ENV !== "production" && Fe(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function Fg(e, n) {
  var t = n.insertionPoint, r = Pg(n);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(e, r.node);
    return;
  }
  if (t && typeof t.nodeType == "number") {
    var o = t, i = o.parentNode;
    i ? i.insertBefore(e, o.nextSibling) : process.env.NODE_ENV !== "production" && Fe(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Ei().appendChild(e);
}
var Dg = Ti(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), Nr = function(e, n, t) {
  try {
    "insertRule" in e ? e.insertRule(n, t) : "appendRule" in e && e.appendRule(n);
  } catch (r) {
    return process.env.NODE_ENV !== "production" && Fe(!1, "[JSS] " + r.message), !1;
  }
  return e.cssRules[t];
}, Lr = function(e, n) {
  var t = e.cssRules.length;
  return n === void 0 || n > t ? t : n;
}, Ig = function() {
  var e = document.createElement("style");
  return e.textContent = `
`, e;
}, Mg = /* @__PURE__ */ function() {
  function e(t) {
    this.getPropertyValue = yg, this.setProperty = Sg, this.removeProperty = Cg, this.setSelector = bg, this.hasInsertedRules = !1, this.cssRules = [], t && Mt.add(t), this.sheet = t;
    var r = this.sheet ? this.sheet.options : {}, o = r.media, i = r.meta, a = r.element;
    this.element = a || Ig(), this.element.setAttribute("data-jss", ""), o && this.element.setAttribute("media", o), i && this.element.setAttribute("data-meta", i);
    var l = Dg();
    l && this.element.setAttribute("nonce", l);
  }
  var n = e.prototype;
  return n.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      Fg(this.element, this.sheet.options);
      var t = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && t && (this.hasInsertedRules = !1, this.deploy());
    }
  }, n.detach = function() {
    if (this.sheet) {
      var t = this.element.parentNode;
      t && t.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, n.deploy = function() {
    var t = this.sheet;
    if (t) {
      if (t.options.link) {
        this.insertRules(t.rules);
        return;
      }
      this.element.textContent = `
` + t.toString() + `
`;
    }
  }, n.insertRules = function(t, r) {
    for (var o = 0; o < t.index.length; o++)
      this.insertRule(t.index[o], o, r);
  }, n.insertRule = function(t, r, o) {
    if (o === void 0 && (o = this.element.sheet), t.rules) {
      var i = t, a = o;
      if (t.type === "conditional" || t.type === "keyframes") {
        var l = Lr(o, r);
        if (a = Nr(o, i.toString({
          children: !1
        }), l), a === !1)
          return !1;
        this.refCssRule(t, l, a);
      }
      return this.insertRules(i.rules, a), a;
    }
    var u = t.toString();
    if (!u)
      return !1;
    var s = Lr(o, r), d = Nr(o, u, s);
    return d === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(t, s, d), d);
  }, n.refCssRule = function(t, r, o) {
    t.renderable = o, t.options.parent instanceof Ai && this.cssRules.splice(r, 0, o);
  }, n.deleteRule = function(t) {
    var r = this.element.sheet, o = this.indexOf(t);
    return o === -1 ? !1 : (r.deleteRule(o), this.cssRules.splice(o, 1), !0);
  }, n.indexOf = function(t) {
    return this.cssRules.indexOf(t);
  }, n.replaceRule = function(t, r) {
    var o = this.indexOf(t);
    return o === -1 ? !1 : (this.element.sheet.deleteRule(o), this.cssRules.splice(o, 1), this.insertRule(r, o));
  }, n.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), $g = 0, kg = /* @__PURE__ */ function() {
  function e(t) {
    this.id = $g++, this.version = "10.10.0", this.plugins = new mg(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Br,
      Renderer: Hd ? Mg : null,
      plugins: []
    }, this.generateId = Br({
      minify: !1
    });
    for (var r = 0; r < Er.length; r++)
      this.plugins.use(Er[r], {
        queue: "internal"
      });
    this.setup(t);
  }
  var n = e.prototype;
  return n.setup = function(t) {
    return t === void 0 && (t = {}), t.createGenerateId && (this.options.createGenerateId = t.createGenerateId), t.id && (this.options.id = fe({}, this.options.id, t.id)), (t.createGenerateId || t.id) && (this.generateId = this.options.createGenerateId(this.options.id)), t.insertionPoint != null && (this.options.insertionPoint = t.insertionPoint), "Renderer" in t && (this.options.Renderer = t.Renderer), t.plugins && this.use.apply(this, t.plugins), this;
  }, n.createStyleSheet = function(t, r) {
    r === void 0 && (r = {});
    var o = r, i = o.index;
    typeof i != "number" && (i = Mt.index === 0 ? 0 : Mt.index + 1);
    var a = new Ai(t, fe({}, r, {
      jss: this,
      generateId: r.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: i
    }));
    return this.plugins.onProcessSheet(a), a;
  }, n.removeStyleSheet = function(t) {
    return t.detach(), Mt.remove(t), this;
  }, n.createRule = function(t, r, o) {
    if (r === void 0 && (r = {}), o === void 0 && (o = {}), typeof t == "object")
      return this.createRule(void 0, t, r);
    var i = fe({}, o, {
      name: t,
      jss: this,
      Renderer: this.options.Renderer
    });
    i.generateId || (i.generateId = this.generateId), i.classes || (i.classes = {}), i.keyframes || (i.keyframes = {});
    var a = $i(t, r, i);
    return a && this.plugins.onProcessRule(a), a;
  }, n.use = function() {
    for (var t = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return o.forEach(function(a) {
      t.plugins.use(a);
    }), this;
  }, e;
}(), Vi = function(e) {
  return new kg(e);
};
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
Vi();
function Wn(e, n) {
  if (!n)
    return !0;
  if (Array.isArray(n)) {
    for (var t = 0; t < n.length; t++) {
      var r = Wn(e, n[t]);
      if (!r)
        return !1;
    }
    return !0;
  }
  if (n.indexOf(" ") > -1)
    return Wn(e, n.split(" "));
  var o = e.options.parent;
  if (n[0] === "$") {
    var i = o.getRule(n.substr(1));
    return i ? i === e ? (process.env.NODE_ENV !== "production" && Fe(!1, `[JSS] Cyclic composition detected. 
` + e.toString()), !1) : (o.classes[e.key] += " " + o.classes[i.key], !0) : (process.env.NODE_ENV !== "production" && Fe(!1, `[JSS] Referenced rule is not defined. 
` + e.toString()), !1);
  }
  return o.classes[e.key] += " " + n, !0;
}
function Ag() {
  function e(n, t) {
    return "composes" in n && (Wn(t, n.composes), delete n.composes), n;
  }
  return {
    onProcessStyle: e
  };
}
var zt = function(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}, wn = "extendCurrValue" + Date.now();
function Tg(e, n, t, r) {
  var o = typeof e.extend;
  if (o === "string") {
    if (!t)
      return;
    var i = t.getRule(e.extend);
    if (!i)
      return;
    if (i === n) {
      process.env.NODE_ENV !== "production" && Fe(!1, `[JSS] A rule tries to extend itself 
` + n.toString());
      return;
    }
    var a = i.options.parent;
    if (a) {
      var l = a.rules.raw[e.extend];
      rt(l, n, t, r);
    }
    return;
  }
  if (Array.isArray(e.extend)) {
    for (var u = 0; u < e.extend.length; u++) {
      var s = e.extend[u], d = typeof s == "string" ? fe({}, e, {
        extend: s
      }) : e.extend[u];
      rt(d, n, t, r);
    }
    return;
  }
  for (var f in e.extend) {
    if (f === "extend") {
      rt(e.extend.extend, n, t, r);
      continue;
    }
    if (zt(e.extend[f])) {
      f in r || (r[f] = {}), rt(e.extend[f], n, t, r[f]);
      continue;
    }
    r[f] = e.extend[f];
  }
}
function Eg(e, n, t, r) {
  for (var o in e)
    if (o !== "extend") {
      if (zt(r[o]) && zt(e[o])) {
        rt(e[o], n, t, r[o]);
        continue;
      }
      if (zt(e[o])) {
        r[o] = rt(e[o], n, t);
        continue;
      }
      r[o] = e[o];
    }
}
function rt(e, n, t, r) {
  return r === void 0 && (r = {}), Tg(e, n, t, r), Eg(e, n, t, r), r;
}
function Vg() {
  function e(t, r, o) {
    return "extend" in t ? rt(t, r, o) : t;
  }
  function n(t, r, o) {
    if (r !== "extend")
      return t;
    if (t == null || t === !1) {
      for (var i in o[wn])
        o.prop(i, null);
      return o[wn] = null, null;
    }
    if (typeof t == "object") {
      for (var a in t)
        o.prop(a, t[a]);
      o[wn] = t;
    }
    return null;
  }
  return {
    onProcessStyle: e,
    onChangeValue: n
  };
}
var Ue = "@global", Un = "@global ", _g = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "global", this.at = Ue, this.isProcessed = !1, this.key = t, this.options = o, this.rules = new nn(fe({}, o, {
      parent: this
    }));
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var n = e.prototype;
  return n.getRule = function(t) {
    return this.rules.get(t);
  }, n.addRule = function(t, r, o) {
    var i = this.rules.add(t, r, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, n.replaceRule = function(t, r, o) {
    var i = this.rules.replace(t, r, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, n.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, n.toString = function(t) {
    return this.rules.toString(t);
  }, e;
}(), Bg = /* @__PURE__ */ function() {
  function e(t, r, o) {
    this.type = "global", this.at = Ue, this.isProcessed = !1, this.key = t, this.options = o;
    var i = t.substr(Un.length);
    this.rule = o.jss.createRule(i, r, fe({}, o, {
      parent: this
    }));
  }
  var n = e.prototype;
  return n.toString = function(t) {
    return this.rule ? this.rule.toString(t) : "";
  }, e;
}(), Ng = /\s*,\s*/g;
function _i(e, n) {
  for (var t = e.split(Ng), r = "", o = 0; o < t.length; o++)
    r += n + " " + t[o].trim(), t[o + 1] && (r += ", ");
  return r;
}
function Lg(e, n) {
  var t = e.options, r = e.style, o = r ? r[Ue] : null;
  if (o) {
    for (var i in o)
      n.addRule(i, o[i], fe({}, t, {
        selector: _i(i, e.selector)
      }));
    delete r[Ue];
  }
}
function Og(e, n) {
  var t = e.options, r = e.style;
  for (var o in r)
    if (!(o[0] !== "@" || o.substr(0, Ue.length) !== Ue)) {
      var i = _i(o.substr(Ue.length), e.selector);
      n.addRule(i, r[o], fe({}, t, {
        selector: i
      })), delete r[o];
    }
}
function zg() {
  function e(t, r, o) {
    if (!t)
      return null;
    if (t === Ue)
      return new _g(t, r, o);
    if (t[0] === "@" && t.substr(0, Un.length) === Un)
      return new Bg(t, r, o);
    var i = o.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (o.scoped = !1), !o.selector && o.scoped === !1 && (o.selector = t), null;
  }
  function n(t, r) {
    t.type !== "style" || !r || (Lg(t, r), Og(t, r));
  }
  return {
    onCreateRule: e,
    onProcessRule: n
  };
}
Vi({
  plugins: [Vg(), Ag(), zg(), ...Sa().plugins]
});
const qn = {
  primary: {
    main: m.primaryMain,
    light: m.primaryLight,
    dark: m.primaryDark,
    contrastText: m.primaryContrast,
    accent: m.primaryAccent
  },
  secondary: {
    main: m.secondaryMain,
    light: m.secondaryLight,
    dark: m.secondaryDark,
    contrastText: m.secondaryContrast
  },
  error: {
    main: m.errorMain,
    light: m.errorLight,
    dark: m.errorDark,
    contrastText: m.errorContrast
  },
  warning: {
    main: m.warningMain,
    light: m.warningLight,
    dark: m.warningDark,
    contrastText: m.warningContrast
  },
  success: {
    main: m.successMain,
    light: m.successLight,
    dark: m.successDark,
    contrastText: m.successContrast
  },
  text: {
    primary: m.textPrimary,
    secondary: m.textSecondary,
    disabled: m.textDisabled,
    hint: m.textHint
  },
  neutral: {
    main: m.neutralBase,
    light: m.neutralLight,
    dark: m.neutralDark,
    lighter: m.neutralLighter
  },
  // deprecated but still in use
  grey: {
    50: m.grey50,
    100: m.grey100,
    200: m.grey200,
    300: m.grey300,
    400: m.grey400,
    500: m.grey500,
    600: m.grey600,
    700: m.grey700,
    800: m.grey800,
    900: m.grey900,
    A100: m.greyA100,
    A200: m.greyA200,
    A400: m.greyA400,
    A700: m.greyA700
  },
  gray: {
    50: m.gray50,
    100: m.gray100,
    200: m.gray200,
    300: m.gray300,
    400: m.gray400,
    500: m.gray500,
    600: m.gray600,
    700: m.gray700,
    800: m.gray800,
    900: m.gray900,
    1e3: m.gray1000,
    1200: m.gray1200,
    1400: m.gray1400,
    1600: m.gray1600,
    1800: m.gray1800
  },
  green: {
    50: m.green50,
    100: m.green100,
    200: m.green200,
    300: m.green300,
    400: m.green400,
    500: m.green500,
    600: m.green600,
    700: m.green700,
    800: m.green800,
    900: m.green900,
    1e3: m.green1000,
    1200: m.green1200,
    1400: m.green1400,
    1600: m.green1600
  },
  magenta: {
    50: m.magenta50,
    100: m.magenta100,
    200: m.magenta200,
    300: m.magenta300,
    400: m.magenta400,
    500: m.magenta500,
    600: m.magenta600,
    700: m.magenta700,
    800: m.magenta800,
    900: m.magenta900,
    1e3: m.magenta1000,
    1200: m.magenta1200,
    1400: m.magenta1400,
    1600: m.magenta1600
  },
  orange: {
    50: m.orange50,
    100: m.orange100,
    200: m.orange200,
    300: m.orange300,
    400: m.orange400,
    500: m.orange500,
    600: m.orange600,
    700: m.orange700,
    800: m.orange800,
    900: m.orange900,
    1e3: m.orange1000,
    1200: m.orange1200,
    1400: m.orange1400,
    1600: m.orange1600
  },
  red: {
    50: m.red50,
    100: m.red100,
    200: m.red200,
    300: m.red300,
    400: m.red400,
    500: m.red500,
    600: m.red600,
    700: m.red700,
    800: m.red800,
    900: m.red900,
    1e3: m.red1000,
    1200: m.red1200,
    1400: m.red1400,
    1600: m.red1600
  },
  violet: {
    50: m.violet50,
    100: m.violet100,
    200: m.violet200,
    300: m.violet300,
    400: m.violet400,
    500: m.violet500,
    600: m.violet600,
    700: m.violet700,
    800: m.violet800,
    900: m.violet900,
    1e3: m.violet1000,
    1200: m.violet1200,
    1400: m.violet1400,
    1600: m.violet1600
  },
  blue: {
    50: m.blue50,
    100: m.blue100,
    200: m.blue200,
    300: m.blue300,
    400: m.blue400,
    500: m.blue500,
    600: m.blue600,
    700: m.blue700,
    800: m.blue800,
    900: m.blue900,
    1e3: m.blue1000,
    1200: m.blue1200,
    1400: m.blue1400,
    1500: m.blue1500,
    1600: m.blue1600,
    accent: m.accentBlue
  },
  cyan: {
    50: m.cyan50,
    100: m.cyan100,
    200: m.cyan200,
    300: m.cyan300,
    400: m.cyan400,
    500: m.cyan500,
    600: m.cyan600,
    700: m.cyan700,
    800: m.cyan800,
    900: m.cyan900,
    1e3: m.cyan1000,
    1200: m.cyan1200,
    1400: m.cyan1400,
    1600: m.cyan1600
  }
}, Hg = {
  root: {
    border: 0,
    boxShadow: "none",
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: 0
    }
  }
}, Gg = {
  TransitionProps: {
    timeout: 0
  }
}, jg = {}, Or = {}, Wg = {
  root: {
    padding: 0
  }
}, X = (e) => `${e * 0.5}rem`, Ug = {
  root: {
    padding: `0 0 ${X(0.5)}`,
    "&$expanded": {
      minHeight: "auto",
      margin: 0
    }
  },
  focusVisible: {},
  disabled: {},
  content: {
    margin: 0,
    "&$expanded": {
      margin: 0
    }
  },
  expandIcon: {
    transition: "none",
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0
  }
}, qg = {
  expandIcon: /* @__PURE__ */ g(st, { fontSize: "small" })
}, Kg = {}, Yg = {
  closeText: "Close",
  severity: "info",
  variant: "standard",
  iconMapping: {
    error: /* @__PURE__ */ g(Ua, { fontSize: "small", color: "inherit" }),
    info: /* @__PURE__ */ g(ir, { fontSize: "small", color: "inherit" }),
    success: /* @__PURE__ */ g(Zt, { fontSize: "small", color: "inherit" }),
    warning: /* @__PURE__ */ g(or, { fontSize: "small", color: "inherit" })
  }
}, Jg = {
  root: {
    color: "inherit"
  }
}, Xg = {}, Zg = {
  root: {
    boxShadow: "none"
  }
}, Qg = {}, Tt = {
  low: "0px 2px 4px -1px rgba(0, 34, 63, 0.15), 0px 1px 2px -1px rgba(0, 34, 63, 0.10)",
  medium: "0px 4px 16px -2px rgba(0, 34, 63, 0.15), 0px 2px 4px -1px rgba(0, 34, 63, 0.15)",
  high: "0px 8px 24px -2px rgba(0, 21, 38, 0.30), 0px 2px 16px -2px rgba(0, 34, 63, 0.20)"
}, ep = {
  input: {
    "&&&": {
      padding: `${X(1)} 0`
    },
    "&&&:first-child": {
      paddingLeft: 0
    }
  },
  inputRoot: {
    "&&": {
      padding: `0 0 0 ${X(1)}`,
      height: "auto"
    },
    "&&:empty": {
      height: "32px"
    }
  },
  endAdornment: {
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    height: "100%",
    alignItems: "flex-start"
  },
  tag: {
    height: X(3),
    margin: `${X(0.25)} ${X(0.6)}`
  },
  paper: {
    boxShadow: Tt.medium,
    borderRadius: "8px"
  },
  popupIndicator: {
    padding: X(1)
  },
  clearIndicator: {
    padding: X(1)
  }
}, tp = {
  popupIcon: /* @__PURE__ */ g(st, { fontSize: "small" })
}, np = {}, rp = {};
function op(e) {
  for (var n = "https://mui.com/production-error/?code=" + e, t = 1; t < arguments.length; t += 1)
    n += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified Material-UI error #" + e + "; visit " + n + " for the full message.";
}
function ip(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (e < n || e > t) && console.error("Material-UI: The value provided ".concat(e, " is out of range [").concat(n, ", ").concat(t, "].")), Math.min(Math.max(n, e), t);
}
function ap(e) {
  e = e.substr(1);
  var n = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"), t = e.match(n);
  return t && t[0].length === 1 && (t = t.map(function(r) {
    return r + r;
  })), t ? "rgb".concat(t.length === 4 ? "a" : "", "(").concat(t.map(function(r, o) {
    return o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function Bi(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Bi(ap(e));
  var n = e.indexOf("("), t = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(e, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : op(3, e));
  var r = e.substring(n + 1, e.length - 1).split(",");
  return r = r.map(function(o) {
    return parseFloat(o);
  }), {
    type: t,
    values: r
  };
}
function lp(e) {
  var n = e.type, t = e.values;
  return n.indexOf("rgb") !== -1 ? t = t.map(function(r, o) {
    return o < 3 ? parseInt(r, 10) : r;
  }) : n.indexOf("hsl") !== -1 && (t[1] = "".concat(t[1], "%"), t[2] = "".concat(t[2], "%")), "".concat(n, "(").concat(t.join(", "), ")");
}
function Kn(e, n) {
  return e = Bi(e), n = ip(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.values[3] = n, lp(e);
}
const sp = {
  root: {
    backgroundColor: Kn(m.black, 0.2)
  }
}, up = {}, zr = {}, cp = {}, dp = {}, gp = {
  open: !1
}, pp = {}, fp = {}, mp = {}, hp = {}, vp = {}, yp = {}, Sp = {}, Ni = {
  borderRadius: 4
}, Cp = {
  root: {
    textTransform: "none",
    padding: `${X(2)} ${X(3)}`,
    borderRadius: Ni.borderRadius,
    height: "32px"
  },
  sizeLarge: {
    height: "48px"
  },
  contained: {
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none"
    },
    "&$disabled": {
      color: m.gray400,
      backgroundColor: m.neutralLighter
    }
  },
  containedSizeLarge: {
    padding: `${X(2)} ${X(3)}`
  },
  outlined: {
    borderWidth: "1px",
    borderColor: "inherit",
    "&$disabled": {
      color: m.gray400,
      border: `1px solid ${m.neutralLight}`
    }
  },
  outlinedPrimary: {
    border: `1px solid ${m.primaryMain}`,
    "&:hover": {
      borderColor: m.primaryDark,
      color: m.primaryDark,
      backgroundColor: m.blue50
    }
  },
  outlinedSizeLarge: {
    borderWidth: "1.4px",
    padding: `${X(2)} ${X(3)}`,
    "&:hover": {
      borderWidth: "1.4px"
    },
    "&$disabled": {
      borderWidth: "1.4px"
    }
  },
  text: {
    padding: 0,
    minWidth: 0,
    height: "auto",
    "& .MuiTypography-button": {
      textDecoration: "none"
    },
    "&:hover": {
      "&&": {
        backgroundColor: "transparent"
      }
    },
    "&$disabled": {
      color: m.gray400
    }
  },
  textPrimary: {
    color: m.primaryMain,
    "&:hover": {
      color: m.primaryDark
    }
  }
}, bp = {
  color: "primary",
  disableElevation: !0,
  size: "medium",
  variant: "contained"
}, wp = {
  grouped: {}
}, xp = {
  color: "primary",
  variant: "contained",
  orientation: "horizontal",
  disableElevation: !0,
  size: "medium"
}, Rp = {
  root: {
    overflow: "visible",
    boxShadow: Tt.low,
    borderRadius: "8px"
  }
}, Pp = {}, Hr = {}, Fp = {}, Dp = {}, Ip = {}, Mp = {}, $p = {}, kp = {}, Ap = {}, Tp = {
  root: {
    padding: X(1),
    paddingRight: X(0.75),
    color: m.neutralBase
  },
  colorPrimary: {
    "&$disabled": {
      color: m.neutralLight
    },
    "&$indeterminate": {
      color: m.primaryMain
    }
  },
  colorSecondary: {
    "&$indeterminate": {
      color: m.secondaryMain
    }
  }
}, Ep = {
  color: "primary",
  size: "small"
}, Vp = {
  labelSmall: {
    fontSize: "0.75rem"
  }
}, _p = {
  color: "primary",
  deleteIcon: /* @__PURE__ */ g(lt, { fontSize: "small" })
}, Bp = {
  labelSmall: {
    fontSize: "0.75rem"
  }
}, Np = {
  color: "primary",
  deleteIcon: /* @__PURE__ */ g(lt, { fontSize: "small" })
}, Lp = {}, Op = {}, zp = {}, Hp = {}, Gp = {}, jp = {
  variant: "indeterminate"
}, Wp = {}, Up = {
  maxWidth: "xl"
}, qp = {}, Kp = {}, Yp = {}, Jp = {}, Xp = {}, Zp = {}, Qp = {}, ef = {}, tf = {}, nf = {}, rf = {}, of = {}, af = {}, lf = {}, sf = {}, uf = {}, cf = {}, df = {}, gf = {}, pf = {}, ff = {}, mf = {}, hf = {
  fullWidth: !0,
  maxWidth: "md"
}, vf = {}, yf = {}, Sf = {}, Cf = {}, bf = {}, wf = {}, xf = {}, Rf = {}, Pf = {}, Ff = {
  color: "primary"
}, Df = {}, If = {}, Mf = {}, $f = {}, kf = {}, Af = {}, Tf = {}, Ef = {}, Vf = {}, _f = {}, Bf = {
  label: {
    "&$disabled": {
      color: m.neutralLight
    }
  }
}, Nf = {}, Lf = {}, Of = {}, zf = {
  root: {
    "&$disabled": {
      color: m.textHint
    },
    color: m.textHint
  },
  contained: {
    marginLeft: X(0.25),
    marginRight: 0
  }
}, Hf = {}, Gf = {
  root: {
    color: m.textPrimary,
    fontSize: "0.875rem",
    "&$error": {
      color: m.textPrimary
    },
    "&$focused": {
      color: m.textPrimary
    },
    "&$disabled": {
      color: m.neutralBase
    }
  }
}, jf = {}, Wf = {}, Uf = {}, qf = {}, Kf = {}, Yf = {}, Jf = {
  color: "inherit"
}, Xf = {
  root: {
    "&.Mui-disabled svg": {
      fill: "currentColor"
    },
    borderRadius: X(0.5),
    color: m.textPrimary,
    "&:hover": {
      backgroundColor: Kn(m.blue1000, 0.1),
      color: m.blue1000
    },
    "&:disabled": {
      color: m.gray300
    }
  },
  colorPrimary: {
    "&:hover": {
      backgroundColor: Kn(m.blue1000, 0.1),
      color: m.blue1400
    }
  }
}, Zf = {
  color: "inherit"
}, Qf = {}, em = {}, tm = {
  input: {
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: "1.5rem",
    "&::placeholder": {
      color: m.textHint,
      fontWeight: 400,
      opacity: 1
    }
  },
  underline: {
    "&$disabled::before": {
      borderBottomStyle: "solid",
      borderBottomColor: m.neutralBase
    }
  }
}, nm = {}, rm = {
  outlined: {
    transform: "none",
    marginBottom: X(0.75),
    marginLeft: X(0.25),
    fontSize: "0.75rem",
    color: m.textPrimary
  },
  shrink: {
    "&&&": {
      transform: "none"
    }
  },
  formControl: {
    position: "relative",
    top: "auto",
    left: "auto"
  }
}, om = {
  color: "primary",
  disableAnimation: !0,
  shrink: !0
}, im = {
  root: {},
  underlineAlways: {
    cursor: "pointer"
  }
}, am = {
  color: "primary",
  underline: "hover"
}, lm = {}, sm = {}, um = {}, cm = {}, dm = {}, gm = {}, pm = {}, fm = {}, mm = {}, hm = {}, vm = {
  paper: {
    borderRadius: "8px",
    boxShadow: Tt.medium
  }
}, ym = {}, Sm = {}, Cm = {}, bm = {
  root: {
    height: "32px",
    backgroundColor: m.white,
    lineHeight: "1.5rem",
    "&$disabled": {
      backgroundColor: m.neutralLighter,
      color: m.textPrimary
    },
    "&$disabled $notchedOutline": {
      borderColor: m.neutralLight
    },
    "&:hover $notchedOutline": {
      borderColor: m.primaryLight
    },
    "&$focused $notchedOutline": {
      borderWidth: "1px",
      borderColor: m.primaryMain,
      boxShadow: "0px 2px 8px -1px rgba(0, 0, 0, 0.15)"
    },
    "&$error $notchedOutline": {
      borderWidth: "2px"
    }
  },
  multiline: {
    height: "auto",
    padding: X(1),
    minHeight: "32px"
  },
  adornedStart: {
    paddingLeft: X(1),
    "& button:has(svg)": {
      marginLeft: X(-1)
    }
  },
  adornedEnd: {
    paddingRight: X(1),
    "& button:last-of-type:has(svg)": {
      marginRight: X(-1)
    }
  },
  input: {
    padding: X(1),
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: "1.5rem",
    "&::placeholder": {
      color: m.textHint,
      fontWeight: 400,
      opacity: 1
    }
  },
  inputMarginDense: {
    fontSize: "0.875rem",
    paddingTop: X(1),
    paddingBottom: X(1)
  },
  notchedOutline: {
    borderColor: m.neutralLight
  }
}, wm = {
  color: "primary",
  type: "text",
  notched: !1
}, xm = {}, Rm = {}, Pm = {
  root: {
    padding: X(1),
    paddingRight: X(0.75),
    color: m.neutralBase
  },
  colorPrimary: {
    "&$disabled": {
      color: m.neutralLight
    }
  }
}, Fm = {
  color: "primary",
  size: "small"
}, Dm = {
  iconOutlined: {
    position: "absolute",
    right: X(1),
    pointerEvents: "none",
    color: m.black
  },
  outlined: {
    "&&": {
      paddingRight: X(8)
    }
  },
  select: {
    "&:focus": {
      backgroundColor: "transparent"
    }
  },
  icon: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  iconOpen: {
    transform: "translateY(-50%) rotate(180deg)"
  }
}, Im = {
  displayEmpty: !1,
  variant: "outlined",
  IconComponent: (e) => /* @__PURE__ */ g(st, { fontSize: "small", ...e })
}, Mm = {}, $m = {}, Gr = {}, km = {}, Am = {}, Tm = {}, Em = {}, Vm = {}, _m = {}, Bm = {}, Nm = {}, Lm = {}, Om = {
  fontSizeLarge: {
    fontSize: "2rem"
  },
  fontSizeSmall: {
    fontSize: "1rem"
  }
}, zm = {}, Hm = {
  root: {
    width: 34,
    height: 20,
    padding: 0,
    margin: X(1)
  },
  colorPrimary: {
    "&$disabled": {
      "& + $track": {
        backgroundColor: m.neutralLighter
      }
    }
  },
  switchBase: {
    padding: 4,
    "&$disabled": {
      "& + $track": {
        color: m.neutralLight,
        border: `1px solid ${m.neutralLight}`,
        opacity: 1
      },
      "& $thumb": {
        backgroundColor: m.neutralLight
      }
    },
    "&$checked": {
      transform: "translateX(14px)",
      color: m.white,
      padding: 2,
      "&$disabled": {
        "& + $track": {
          backgroundColor: m.neutralLight
        },
        "& $thumb": {
          backgroundColor: m.white
        }
      },
      "& + $track": {
        backgroundColor: m.primaryMain,
        opacity: 1,
        border: "none"
      },
      "& $thumb": {
        backgroundColor: m.white,
        width: 16,
        height: 16
      }
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  sizeSmall: {
    width: 30,
    height: 16,
    padding: 0,
    "& $thumb": {
      width: 8,
      height: 8
    },
    "& $track": {
      borderRadius: 16 / 2
    },
    "& $switchBase": {
      "&$checked": {
        transform: "translateX(14px)",
        padding: 2,
        "& $thumb": {
          width: 12,
          height: 12
        }
      }
    }
  },
  thumb: {
    backgroundColor: m.neutralBase,
    opacity: 1,
    width: 12,
    height: 12
  },
  track: {
    borderRadius: 24 / 2,
    border: `1px solid ${m.neutralBase}`,
    backgroundColor: m.white,
    opacity: 1
  },
  disabled: {},
  checked: {}
}, Gm = {
  color: "primary",
  size: "medium"
}, jm = {
  textColorPrimary: {
    color: m.textPrimary
  }
}, Wm = {}, Um = {}, qm = {}, Km = {}, Ym = {};
var jr;
const Jm = {
  root: {
    lineHeight: "1.2"
  },
  head: {
    color: (jr = qn == null ? void 0 : qn.text) == null ? void 0 : jr.primary,
    lineHeight: "1.2",
    fontSize: "0.75rem",
    fontWeight: "normal"
  }
}, Xm = {}, Zm = {}, Qm = {}, eh = {}, th = {}, nh = {}, rh = {}, oh = {
  root: {
    "&:last-child td": {
      borderBottom: 0
    },
    "&.disabled": {
      opacity: 0.5
    }
  }
}, ih = {}, ah = {}, lh = {}, sh = {}, uh = {}, ch = {}, dh = {
  textColor: "primary",
  indicatorColor: "primary",
  variant: "standard",
  scrollButtons: "auto",
  centered: !1
}, gh = {}, ph = {
  variant: "outlined",
  SelectProps: {
    IconComponent: (e) => /* @__PURE__ */ g(st, { fontSize: "small", ...e }),
    MenuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }
  }
}, fh = {}, mh = {}, hh = {}, vh = {}, yh = {}, Sh = {
  color: "primary"
}, Ch = {
  tooltip: {
    backgroundColor: m.white,
    color: m.black,
    borderRadius: X(1),
    maxWidth: "460px",
    padding: X(1),
    display: "flex",
    alignItems: "flex-start",
    gap: X(1),
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
  },
  tooltipArrow: {
    color: m.white
  }
}, bh = {
  color: "primary",
  arrow: !1
}, wh = {}, xh = {}, Rh = {}, Ph = {}, Fh = {
  // MUI components
  MuiAccordion: Hg,
  MuiAccordionActions: jg,
  MuiAccordionDetails: Wg,
  MuiAccordionSummary: Ug,
  MuiAlert: Kg,
  MuiAlertTitle: Jg,
  MuiAppBar: Zg,
  MuiAvatar: np,
  MuiAutocomplete: ep,
  MuiBackdrop: sp,
  MuiBadge: zr,
  MuiBreadcrumbs: Sp,
  MuiButton: Cp,
  MuiButtonGroup: wp,
  MuiCard: Rp,
  MuiCardActionArea: Hr,
  MuiCardActions: Hr,
  MuiCardContent: Dp,
  MuiCardHeader: Mp,
  MuiCardMedia: kp,
  MuiCheckbox: Tp,
  MuiChip: Vp,
  MuiCircularProgress: Gp,
  MuiContainer: Wp,
  MuiDialog: mf,
  MuiDialogActions: vf,
  MuiDialogContent: Sf,
  MuiDialogTitle: bf,
  MuiDivider: xf,
  MuiDrawer: Pf,
  MuiFormControl: Vf,
  MuiFormControlLabel: Bf,
  MuiFormGroup: Lf,
  MuiFormHelperText: zf,
  MuiFormLabel: Gf,
  MuiGrid: Wf,
  MuiIcon: Yf,
  MuiIconButton: Xf,
  MuiInput: tm,
  MuiInputLabel: rm,
  MuiLink: im,
  MuiList: lm,
  MuiListItem: um,
  MuiListItemIcon: dm,
  MuiListItemSecondaryAction: pm,
  MuiListItemText: mm,
  MuiMenu: vm,
  MuiMenuItem: Sm,
  MuiOutlinedInput: bm,
  MuiPaper: xm,
  MuiRadio: Pm,
  MuiSelect: Dm,
  MuiSnackbar: Mm,
  MuiSnackbarContent: Em,
  MuiSvgIcon: Om,
  MuiSwitch: Hm,
  MuiTable: Um,
  MuiTableBody: Km,
  MuiTableCell: Jm,
  MuiTableContainer: Zm,
  MuiTableHead: eh,
  MuiTablePagination: nh,
  MuiTableRow: oh,
  MuiTableSortLabel: ah,
  MuiTab: jm,
  MuiTabPanel: sh,
  MuiTabs: ch,
  MuiTextField: gh,
  MuiToggleButton: fh,
  MuiToggleButtonGroup: hh,
  MuiToolbar: yh,
  MuiTooltip: Ch,
  MuiTypography: Rh,
  // Global components
  gBanner: dp,
  gBannerActions: pp,
  gBannerContent: mp,
  gBannerTitle: vp,
  gGlobalChip: Bp,
  gChipBreadcrumbs: Lp,
  gChipIcon: zp,
  gCalendar: qp,
  gFileDropzone: Df,
  gFileList: Mf,
  gFileUploadProps: kf,
  gFooter: Tf,
  gHeader: qf,
  gImagePage: Qf,
  gSnackbarAlert: Gr,
  gSnackbarAlertAction: Gr,
  gSplitButton: _m,
  gStatusWrapper: Nm,
  gRangeCalendar: cf,
  gTabLabelWithBadge: zr,
  gTruncatedChips: wh
}, Dh = {}, Ih = {}, Mh = {}, Wr = {}, $h = {}, kh = {}, Ah = {}, Th = {
  // MUI components
  MuiAccordion: Gg,
  MuiAccordionActions: Or,
  MuiAccordionDetails: Or,
  MuiAccordionSummary: qg,
  MuiAlert: Yg,
  MuiAlertTitle: Xg,
  MuiAppBar: Qg,
  MuiAvatar: rp,
  MuiAutocomplete: tp,
  MuiBackdrop: up,
  MuiBadge: cp,
  MuiButton: bp,
  MuiButtonGroup: xp,
  MuiCard: Pp,
  MuiCardActionArea: Fp,
  MuiCardActions: Dh,
  MuiCardContent: Ip,
  MuiCardHeader: $p,
  MuiCardMedia: Ap,
  MuiCheckbox: Ep,
  MuiChip: _p,
  MuiCircularProgress: jp,
  MuiContainer: Up,
  MuiDialog: hf,
  MuiDialogActions: yf,
  MuiDialogContent: Cf,
  MuiDialogTitle: wf,
  MuiDivider: Rf,
  MuiDrawer: Ff,
  MuiFormControl: _f,
  MuiFormControlLabel: Nf,
  MuiFormGroup: Of,
  MuiFormHelperText: Hf,
  MuiFormLabel: jf,
  MuiGrid: Uf,
  MuiIcon: Jf,
  MuiIconButton: Zf,
  MuiInput: nm,
  MuiInputLabel: om,
  MuiLink: am,
  MuiList: sm,
  MuiListItem: cm,
  MuiListItemIcon: gm,
  MuiListItemSecondaryAction: fm,
  MuiListItemText: hm,
  MuiMenu: ym,
  MuiMenuItem: Cm,
  MuiMenuList: Ih,
  MuiOutlinedInput: wm,
  MuiPaper: Rm,
  MuiRadio: Fm,
  MuiRadioGroup: Wr,
  MuiSelect: Im,
  MuiSnackbar: $m,
  MuiSnackbarContent: Vm,
  MuiSvgIcon: zm,
  MuiSwitch: Gm,
  MuiTable: qm,
  MuiTableBody: Ym,
  MuiTableCell: Xm,
  MuiTableContainer: Qm,
  MuiTableHead: th,
  MuiTablePagination: rh,
  MuiTableRow: ih,
  MuiTableSortLabel: lh,
  MuiTab: Wm,
  MuiTabPanel: uh,
  MuiTabs: dh,
  MuiTextField: ph,
  MuiToggleButton: mh,
  MuiToggleButtonGroup: vh,
  MuiToolbar: Sh,
  MuiTooltip: bh,
  MuiTypography: Ph,
  // Global components
  gBanner: gp,
  gBannerActions: fp,
  gBannerContent: hp,
  gBannerTitle: yp,
  gCalendar: Kp,
  gGlobalChip: Np,
  gChipBreadcrumbs: Op,
  gChipIcon: Hp,
  gDateCalendar: Yp,
  gDateField: Jp,
  gDateFormat: Xp,
  gDateInput: Zp,
  gDatePicker: Qp,
  gDateRangeField: ef,
  gDateRangeInput: tf,
  gDateRangePicker: nf,
  gDateTimeField: rf,
  gDateTimeInput: of,
  gDateTimePicker: af,
  gDateTimeRangeField: lf,
  gDateTimeRangeInput: sf,
  gDateTimeRangePicker: uf,
  gFileDropzone: If,
  gFileList: $f,
  gFileUpload: Af,
  gFooter: Ef,
  gHeader: Kf,
  gImagePane: em,
  gNumberField: Mh,
  gRadioGroup: Wr,
  gSnackbarAlert: km,
  gSnackbarAlertAction: Am,
  gSnackbarAlertDismiss: Tm,
  gSplitButton: Bm,
  gStatusWrapper: Lm,
  gSwitchGroup: $h,
  gTabLabelWithBadge: kh,
  gTimeField: df,
  gTimeInput: gf,
  gTimeRangeField: pf,
  gTimeRangeInput: ff,
  gTooltipTitle: Ah,
  gTruncatedChips: xh
}, Eh = {
  fontFamily: ["Inter", "-apple-system", "Arial", "sans-serif"].join(","),
  htmlFontSize: 16,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    color: m.textPrimary,
    lineHeight: "2.5rem",
    fontSize: "2rem",
    fontWeight: 400
  },
  h2: {
    color: m.textPrimary,
    lineHeight: "2rem",
    fontSize: "1.5rem",
    fontWeight: 400
  },
  h3: {
    color: m.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1.25rem",
    fontWeight: 400
  },
  h4: {
    color: m.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1.125rem",
    fontWeight: 400
  },
  h5: {
    color: m.textPrimary,
    lineHeight: "1.25rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  h6: {
    color: m.textPrimary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  body1: {
    color: m.textPrimary,
    lineHeight: "1.5rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  body2: {
    color: m.textPrimary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  subtitle1: {
    color: m.textSecondary,
    lineHeight: "1.25rem",
    fontSize: "1rem",
    fontWeight: 400
  },
  subtitle2: {
    color: m.textSecondary,
    lineHeight: "1.125rem",
    fontSize: "0.875rem",
    fontWeight: 400
  },
  caption: {
    color: m.textPrimary,
    lineHeight: "1rem",
    fontSize: "0.75rem",
    fontWeight: 400
  },
  label: {
    color: m.textPrimary,
    lineHeight: "1rem",
    fontSize: "0.75rem",
    fontWeight: 400
  },
  button: {
    lineHeight: "1rem",
    fontSize: "0.875rem",
    fontWeight: 500,
    textTransform: "none"
  },
  display1: {
    fontFamily: "AvantGarde",
    lineHeight: "2.25rem",
    fontSize: "2rem",
    fontWeight: 600
  },
  display2: {
    fontFamily: "AvantGarde",
    lineHeight: "1.875rem",
    fontSize: "1.5rem",
    fontWeight: 600
  },
  tableHeading: {
    color: m.neutralBase,
    fontSize: "0.625rem",
    fontWeight: 600,
    lineHeight: "1rem",
    textTransform: "uppercase"
  }
}, Vh = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, _h = {
  breakpoints: mu,
  palette: qn,
  props: Th,
  spacing: X,
  typography: Eh,
  overrides: Fh,
  shape: Ni,
  zIndex: Vh
};
Ca(_h);
const Li = (e) => {
  var n, t, r;
  return {
    root: {
      boxShadow: Tt.medium,
      borderRadius: e.spacing(1),
      padding: `${e.spacing(1)} ${e.spacing(2)}`,
      backgroundColor: e.palette.common.white,
      zIndex: 99,
      marginTop: e.spacing(0.5)
    },
    navigationBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    navigationButton: {},
    navigationLabel: {},
    calendarBox: {
      display: "flex",
      marginBottom: e.spacing(1)
    },
    dayLabelsBox: {
      display: "flex"
    },
    dayLabelBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.875rem",
      width: "100%",
      height: "2.5rem"
    },
    monthBox: {
      display: "flex"
    },
    weeksBox: {
      display: "flex"
    },
    dayBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "2.25rem",
      border: 0,
      borderRadius: "8px",
      background: "none",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: (n = e.palette.blue) == null ? void 0 : n[50]
      },
      "&--selected": {
        backgroundColor: e.palette.primary.main,
        color: e.palette.common.white,
        "&:hover": {
          backgroundColor: (t = e.palette.blue) == null ? void 0 : t[1200]
        }
      },
      "&--today": {
        border: `1px solid ${(r = e.palette.neutral) == null ? void 0 : r.main}`
      },
      "&--outsideRange": {
        visibility: "hidden"
      }
    }
  };
}, Bh = Z(
  (e) => {
    const {
      root: n,
      navigationBox: t,
      navigationButton: r,
      navigationLabel: o,
      calendarBox: i,
      monthBox: a,
      weeksBox: l,
      dayLabelsBox: u,
      dayLabelBox: s,
      dayBox: d
    } = Li(e);
    return te({
      root: ({ externalToggle: f }) => ({
        ...n,
        position: f ? "absolute" : "relative",
        width: "290px"
      }),
      navigationBox: t,
      navigationButton: r,
      navigationLabel: o,
      calendarBox: {
        ...i,
        flexDirection: "column"
      },
      dayLabelsBox: u,
      dayLabelBox: s,
      monthBox: {
        ...a,
        flexDirection: "column"
      },
      weeksBox: l,
      dayBox: {
        ...d,
        "&--disabled": {
          cursor: "not-allowed"
        },
        "&--hasError": {
          opacity: 0.5,
          backgroundColor: e.palette.error.main,
          color: e.palette.common.white
        }
      }
    });
  },
  { name: "gCalendar" }
), mr = (e) => {
  const n = j(), t = W({ name: "gCalendar", props: { ...e }, theme: n }), {
    open: r,
    calendar: o,
    inRange: i,
    isSelectable: a,
    viewing: l,
    isSelected: u,
    isSelectedDay: s,
    hasError: d,
    value: f,
    viewPreviousMonth: p,
    viewNextMonth: c,
    getCalendarButtonProps: h,
    setOpen: v
  } = De(), {
    externalToggle: S = !1,
    onDateChange: C,
    classes: P = {},
    innerRef: F,
    offset: E,
    closeCalendarOnAccept: w
  } = t, I = pe(null), B = Jo(I, F), A = E || { vertical: 32, horizontal: 0 }, { setPositioningStyles: Y } = Xo({ offset: A }), O = ie(Bh(t), P);
  return J(() => {
    w && v(!1);
  }, [f, w]), J(() => {
    C && C(f.length > 0 ? f[0] : null);
  }, [C, f]), J(() => {
    r && Y(I == null ? void 0 : I.current);
  }, [r, Y]), !r && S ? null : /* @__PURE__ */ g(ge, { position: "relative", children: /* @__PURE__ */ K(
    "div",
    {
      className: O.root,
      ref: B,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Choose Date",
      children: [
        /* @__PURE__ */ K(ge, { className: O.navigationBox, children: [
          /* @__PURE__ */ g(
            he,
            {
              "aria-label": "Previous Month",
              onClick: p,
              className: O.navigationButton,
              "data-tc": "monthDecrementButton",
              children: /* @__PURE__ */ g(po, {})
            }
          ),
          /* @__PURE__ */ g(
            ke,
            {
              className: O.navigationLabel,
              variant: "body1",
              variantMapping: { body1: "span" },
              "aria-live": "polite",
              "data-tc": "selectedMonthAndYear",
              children: Ke(l, "MMMM yyyy")
            }
          ),
          /* @__PURE__ */ g(
            he,
            {
              "aria-label": "Next Month",
              onClick: c,
              className: O.navigationButton,
              "data-tc": "monthIncrementButton",
              children: /* @__PURE__ */ g(fo, {})
            }
          )
        ] }),
        /* @__PURE__ */ K(ge, { className: O.calendarBox, role: "grid", children: [
          /* @__PURE__ */ g(ge, { className: O.dayLabelsBox, children: o[0][0].map((M) => /* @__PURE__ */ g(ge, { className: O.dayLabelBox, children: /* @__PURE__ */ g(ke, { variant: "caption", color: "textSecondary", children: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][Co(M)] }) }, `${M}`)) }),
          /* @__PURE__ */ g(ge, { className: O.monthBox, children: o[0].map((M) => /* @__PURE__ */ g(ge, { className: O.weeksBox, children: M.map((q) => {
            const { key: V, ...G } = h({
              day: q,
              className: de([
                O.dayBox,
                {
                  [`${O.dayBox}--selected`]: s(q),
                  [`${O.dayBox}--today`]: bo(q),
                  [`${O.dayBox}--outsideRange`]: !i(
                    q,
                    kn(l),
                    An(l)
                  ),
                  [`${O.dayBox}--disabled`]: !a(q) && !u(q),
                  [`${O.dayBox}--hasError`]: d(q) && u(q)
                }
              ])
            });
            return /* @__PURE__ */ g("button", { ...G, children: /* @__PURE__ */ g(
              ke,
              {
                color: "inherit",
                variant: "body2",
                variantMapping: { body2: "span" },
                ...s(q) ? { "aria-selected": !0 } : {},
                children: Ke(q, "dd")
              }
            ) }, V);
          }) }, `week-${M[0]}`)) })
        ] })
      ]
    }
  ) });
}, pt = (e) => {
  const n = j(), t = W({ name: "gDateFormat", props: { ...e }, theme: n }), { onChange: r, inputRef: o, format: i, ...a } = t, {
    format: l,
    getCaretBoundary: u,
    ...s
  } = cu({
    ...a,
    onChange: r,
    format: i,
    mask: t.mask ?? "_"
  });
  return /* @__PURE__ */ g(
    Wo,
    {
      format: (p) => l ? l(p) : p,
      getCaretBoundary: (p) => Array.from({ length: p.length + 1 }).map(() => !0),
      ...s,
      ...a,
      getInputRef: o,
      onValueChange: (p) => {
        r({ target: { name: t.name, value: p.formattedValue } });
      }
    }
  );
}, hr = (e) => yo(e, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }), Oi = (e) => {
  const n = e == null ? void 0 : e.map(hr);
  return n && n.length > 0 ? tt({
    start: n[0],
    end: n[n.length - 1]
  }) : void 0;
}, vr = (e) => {
  if (e && e.length > 1) {
    const n = e[0], t = e[e.length - 1], r = tt({ start: n, end: t });
    return Ge(n, t) ? r : [n, ...r.slice(1, -1), t];
  }
}, Yn = (e, n = "dd/MM/yyyy", t) => Ke(e, n, t), Jn = (e, n = "dd/MM/yyyy HH:mm", t) => Ke(e, n, t), Xn = (e, n = "HH:mm") => Ke(e, n), rn = ({ disabled: e }) => {
  const { setOpen: n } = De();
  return /* @__PURE__ */ g(qe, { position: "end", onClick: (r) => {
    r.stopPropagation(), n((o) => !o);
  }, children: /* @__PURE__ */ g(he, { disabled: e, size: "small", disableRipple: !0, children: /* @__PURE__ */ g(qa, { fontSize: "small", titleAccess: "Calendar Icon" }) }) });
}, Nh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##/##/####" }), zi = (e) => {
  const {
    viewing: n,
    setViewing: t,
    value: r,
    setValue: o,
    hasError: i,
    error: a,
    setError: l,
    getDateInputProps: u,
    open: s
  } = De(), d = j(), f = W({ name: "gDateInput", props: { ...e }, theme: d }), {
    disabled: p,
    onDateError: c,
    onDateAccept: h,
    disableOpenPicker: v = !1,
    getErrorMessage: S = dt,
    InputProps: C,
    onChange: P,
    onBlur: F,
    dateInputRef: E,
    ...w
  } = f, [I, B] = oe(""), A = pe(n), Y = (M) => {
    B(M.target.value), P && P(M);
  }, O = (M) => {
    F && F(M);
  };
  return Me(E, () => ({
    clear: () => o([]),
    view: (M) => t(M)
  })), J(() => {
    l(null), B(r.length > 0 ? Yn(r[0]) : ""), r.length > 0 && i(r[0]) && l({ reason: "invalidSelection" });
  }, [i, r, l, B]), J(() => {
    a && c && c(a);
  }, [a, c]), J(() => {
    h && h(r.length > 0 ? r[0] : null);
  }, [r, h]), J(() => {
    r.length ? !s && t(r[0]) : t(A.current);
  }, [s]), /* @__PURE__ */ g(
    Te,
    {
      ...u({ inputValue: I, onChange: Y, onBlur: O, disabled: p }),
      value: I,
      ...a ? { helperText: S(a) } : {},
      ...w,
      InputProps: {
        ...C,
        inputComponent: Nh,
        ...v ? {} : {
          endAdornment: /* @__PURE__ */ g(rn, { disabled: p })
        }
      }
    }
  );
}, Lh = Z(
  () => te({
    root: ({ fullWidth: e }) => ({
      width: e ? "270px" : "auto"
    })
  }),
  { name: "gDateRangeInput" }
), Oh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##/##/#### - ##/##/####" }), Hi = (e) => {
  const {
    error: n,
    setError: t,
    setViewing: r,
    viewing: o,
    value: i,
    setValue: a,
    hasRangeError: l,
    getDateRangeInputProps: u,
    open: s
  } = De(), d = j(), f = W({ name: "gDateRangeInput", props: { ...e }, theme: d }), {
    disabled: p,
    disableOpenPicker: c,
    onDateRangeAccept: h,
    onDateRangeError: v,
    classes: S = {},
    getErrorMessage: C = dt,
    InputProps: P,
    onChange: F,
    onBlur: E,
    fullWidth: w = !1,
    dateRangeInputRef: I,
    ...B
  } = f, [A, Y] = oe(""), O = ie(Lh({ fullWidth: w }), S), M = pe(o), q = (G) => {
    Y(G.target.value), F && F(G);
  }, V = (G) => {
    E && E(G);
  };
  return J(() => {
    const G = i.length > 1;
    t(null), Y(
      G ? `${Yn(i[0])} - ${Yn(i[i.length - 1])}` : ""
    ), G && l([i[0], i[i.length - 1]]) && t({ reason: "invalidRangeSelection" });
  }, [l, i, t]), J(() => {
    i.length ? !s && r(i[0]) : r(M.current);
  }, [s]), J(() => {
    h && h(i.length > 1 ? [i[0], i[i.length - 1]] : null);
  }, [i, h]), J(() => {
    n && v && v(n);
  }, [n, v]), Me(I, () => ({
    clear: () => a([])
  })), /* @__PURE__ */ g(
    Te,
    {
      ...u({
        inputValue: A,
        onChange: q,
        onBlur: V,
        disabled: p
      }),
      value: A,
      ...n ? { helperText: C(n) } : {},
      ...B,
      classes: O,
      InputProps: {
        ...P,
        inputComponent: Oh,
        ...c ? {} : {
          endAdornment: /* @__PURE__ */ g(rn, { disabled: p })
        }
      }
    }
  );
}, zh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##/##/#### ##:##" }), Gi = (e) => {
  const {
    viewing: n,
    setViewing: t,
    value: r,
    setValue: o,
    hasError: i,
    error: a,
    setError: l,
    getDateTimeInputProps: u,
    open: s
  } = De(), d = j(), f = W({ name: "gDateTimeInput", props: { ...e }, theme: d }), {
    disabled: p,
    disableOpenPicker: c,
    onDateTimeAccept: h,
    onDateTimeError: v,
    getErrorMessage: S = dt,
    InputProps: C,
    onChange: P,
    onBlur: F,
    dateTimeInputRef: E,
    ...w
  } = f, [I, B] = oe(""), A = pe(n), Y = (M) => {
    B(M.target.value), P && P(M);
  }, O = (M) => {
    F && F(M);
  };
  return J(() => {
    l(null), B(r.length > 0 ? Jn(r[0]) : ""), r.length > 0 && i(r[0], !1) && l({ reason: "invalidSelection" });
  }, [i, r, l]), J(() => {
    h && h(r.length > 0 ? r[0] : null);
  }, [h, r]), J(() => {
    a && v && v(a);
  }, [a, v]), J(() => {
    r.length ? !s && t(r[0]) : t(A.current);
  }, [s]), Me(E, () => ({
    clear: () => o([]),
    view: (M) => t(M)
  })), /* @__PURE__ */ g(
    Te,
    {
      ...u({
        inputValue: I,
        onChange: Y,
        onBlur: O,
        disabled: p
      }),
      value: I,
      ...a ? { helperText: S(a) } : {},
      ...w,
      InputProps: {
        ...C,
        inputComponent: zh,
        ...c ? {} : {
          endAdornment: /* @__PURE__ */ g(rn, { disabled: p })
        }
      }
    }
  );
}, Hh = Z(
  () => te({
    root: {
      width: "370px"
    }
  }),
  { name: "gDateTimeRangeInput" }
), Gh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##/##/#### ##:## - ##/##/#### ##:##" }), ji = (e) => {
  const {
    error: n,
    setError: t,
    viewing: r,
    setViewing: o,
    value: i,
    setValue: a,
    hasRangeError: l,
    getDateTimeRangeInputProps: u,
    open: s
  } = De(), d = j(), f = W({ name: "gDateTimeRangeInput", props: { ...e }, theme: d }), {
    disabled: p,
    disableOpenPicker: c,
    onDateTimeRangeError: h,
    onDateTimeRangeAccept: v,
    classes: S = {},
    getErrorMessage: C = dt,
    InputProps: P,
    onChange: F,
    onBlur: E,
    dateTimeRangeInputRef: w,
    ...I
  } = f, [B, A] = oe(""), Y = pe(r), O = ie(Hh(), S), M = (V) => {
    A(V.target.value), F && F(V);
  }, q = (V) => {
    E && E(V);
  };
  return J(() => {
    const V = i.length > 1;
    t(null), A(
      V ? `${Jn(i[0])} - ${Jn(i[i.length - 1])}` : ""
    ), V && l([i[0], i[i.length - 1]], !1) && t({ reason: "invalidRangeSelection" });
  }, [i, l, t]), J(() => {
    i.length ? !s && o(i[0]) : o(Y.current);
  }, [s]), J(() => {
    v && v(i.length > 1 ? [i[0], i[i.length - 1]] : null);
  }, [i, v]), J(() => {
    n && h && h(n);
  }, [n, h]), Me(w, () => ({
    clear: () => a([])
  })), /* @__PURE__ */ g(
    Te,
    {
      ...u({
        inputValue: B,
        onChange: M,
        onBlur: q,
        disabled: p
      }),
      value: B,
      ...n ? { helperText: C(n) } : {},
      ...I,
      classes: O,
      InputProps: {
        ...P,
        inputComponent: Gh,
        ...c ? {} : {
          endAdornment: /* @__PURE__ */ g(rn, { disabled: p })
        }
      }
    }
  );
}, jh = Z(
  (e) => {
    var f, p, c;
    const {
      root: n,
      navigationBox: t,
      navigationButton: r,
      navigationLabel: o,
      calendarBox: i,
      dayLabelsBox: a,
      dayLabelBox: l,
      monthBox: u,
      weeksBox: s,
      dayBox: d
    } = Li(e);
    return te({
      root: {
        ...n,
        width: "575px",
        position: "absolute"
      },
      navigationBox: t,
      navigationButton: r,
      navigationLabel: {
        ...o,
        "&:first-of-type": {
          paddingRight: e.spacing(6)
        },
        "&:last-of-type": {
          paddingLeft: e.spacing(6)
        }
      },
      calendarsBox: {
        display: "flex",
        flexDirection: "row",
        "& > div:first-child": {
          paddingRight: e.spacing(2)
        },
        "& > div:last-child": {
          paddingLeft: e.spacing(2)
        }
      },
      calendarBox: {
        ...i,
        flexDirection: "column",
        width: "50%"
      },
      dayLabelsBox: a,
      dayLabelBox: l,
      monthBox: {
        ...u,
        flexDirection: "column"
      },
      weeksBox: s,
      dayBox: {
        ...d,
        "&--start": {
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0
        },
        "&--end": {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0
        },
        "&--inHoverRange": {
          backgroundColor: (f = e.palette.blue) == null ? void 0 : f[50],
          borderRadius: 0
        },
        "&--inRange": {
          backgroundColor: (p = e.palette.blue) == null ? void 0 : p[50],
          color: e.palette.common.black,
          borderRadius: 0,
          "&:hover": {
            backgroundColor: (c = e.palette.blue) == null ? void 0 : c[100]
          }
        },
        "&--disabled": {
          cursor: "not-allowed"
        },
        "&--hasError": {
          opacity: 0.5,
          backgroundColor: e.palette.error.main,
          color: e.palette.common.white
        }
      }
    });
  },
  { name: "gRangeCalendar" }
), Wi = (e) => {
  const {
    open: n,
    calendar: t,
    isSelected: r,
    value: o,
    hasError: i,
    isSelectable: a,
    viewPreviousMonth: l,
    viewNextMonth: u,
    getRangeCalendarButtonProps: s,
    setOpen: d
  } = De(), f = j(), p = W({ name: "gRangeCalendar", props: { ...e }, theme: f }), {
    onDateRangeChange: c,
    classes: h = {},
    innerRef: v,
    offset: S,
    closeCalendarOnAccept: C
  } = p, P = pe(null), F = Jo(P, v), E = S || { vertical: 32, horizontal: 0 }, { setPositioningStyles: w } = Xo({ offset: E }), I = ie(jh(), h), [B, A] = oe([]);
  if (J(() => {
    const M = !!B.length && o.length > 1;
    C && M && d(!1);
  }, [o, C]), J(() => {
    c && c(o.length > 1 ? [o[0], o[o.length - 1]] : null);
  }, [c, o]), J(() => {
    A([]);
  }, [o, n]), J(() => {
    n && w(P.current);
  }, [n, w]), !n)
    return null;
  const Y = (M) => {
    const q = tt({
      start: ho([M, o[0]]),
      end: vo([M, o[0]])
    });
    A(q);
  }, O = (M) => B.findIndex((q) => Ge(q, M)) > -1;
  return /* @__PURE__ */ g(ge, { position: "relative", children: /* @__PURE__ */ K(
    "div",
    {
      className: I.root,
      ref: F,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Choose Date Range",
      children: [
        /* @__PURE__ */ K(ge, { className: I.navigationBox, children: [
          /* @__PURE__ */ g(
            he,
            {
              "aria-label": "Previous Month",
              onClick: l,
              className: I.navigationButton,
              "data-tc": "monthDecrementButton",
              children: /* @__PURE__ */ g(po, {})
            }
          ),
          t.map(([[M]]) => /* @__PURE__ */ g(
            ke,
            {
              className: I.navigationLabel,
              variant: "body1",
              variantMapping: { body1: "span" },
              "aria-live": "polite",
              "data-tc": "selectedMonthAndYear",
              children: Ke(br(M, 15), "MMMM yyyy")
            },
            M.toDateString()
          )),
          /* @__PURE__ */ g(
            he,
            {
              "aria-label": "Next Month",
              onClick: u,
              className: I.navigationButton,
              "data-tc": "monthIncrementButton",
              children: /* @__PURE__ */ g(fo, {})
            }
          )
        ] }),
        /* @__PURE__ */ g(ge, { className: I.calendarsBox, role: "grid", children: t.map((M) => /* @__PURE__ */ K(ge, { className: I.calendarBox, children: [
          /* @__PURE__ */ g(ge, { className: I.dayLabelsBox, children: M[0].map((q) => /* @__PURE__ */ g(ge, { className: I.dayLabelBox, children: /* @__PURE__ */ g(ke, { variant: "caption", color: "textSecondary", children: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][Co(q)] }) }, `${q}`)) }),
          M.map((q) => /* @__PURE__ */ g(
            ge,
            {
              className: I.weeksBox,
              children: q.map((V) => {
                const G = nt(V, o[0]), me = nt(V, o[o.length - 1]), { key: k, ...N } = s({
                  day: V,
                  className: de([
                    I.dayBox,
                    {
                      [`${I.dayBox}--selected`]: G || me,
                      [`${I.dayBox}--today`]: bo(V),
                      [`${I.dayBox}--outsideRange`]: !cl(
                        V,
                        br(M[0][0], 15)
                      ),
                      [`${I.dayBox}--start`]: B.length > 1 && nt(V, B[0]) || o.length > 1 && G,
                      [`${I.dayBox}--end`]: B.length > 1 && nt(V, B[B.length - 1]) || o.length > 1 && me,
                      [`${I.dayBox}--inHoverRange`]: !r(V) && O(V),
                      [`${I.dayBox}--inRange`]: r(V) && !G && !me,
                      [`${I.dayBox}--disabled`]: !a(V) && !r(V),
                      [`${I.dayBox}--hasError`]: r(V) && i(V)
                    }
                  ])
                });
                return /* @__PURE__ */ g(
                  "button",
                  {
                    onFocus: () => {
                      o.length === 1 && Y(V);
                    },
                    onMouseOver: () => {
                      o.length === 1 && Y(V);
                    },
                    ...N,
                    children: /* @__PURE__ */ g(
                      ke,
                      {
                        color: "inherit",
                        variant: "body2",
                        variantMapping: { body2: "span" },
                        children: Ke(V, "dd")
                      }
                    )
                  },
                  k
                );
              })
            },
            `month-${M[0][0].toDateString()}-week-${q[0]}`
          ))
        ] }, M[0][0].toDateString())) })
      ]
    }
  ) });
}, Wh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##:##" }), Uh = (e) => {
  const { value: n, setValue: t, hasError: r, error: o, setError: i, getTimeInputProps: a } = De(), [l, u] = oe(""), s = j(), d = W({ name: "gTimeInput", props: { ...e }, theme: s }), {
    onTimeAccept: f,
    onTimeError: p,
    getErrorMessage: c = dt,
    InputProps: h,
    onChange: v,
    onBlur: S,
    timeInputRef: C,
    ...P
  } = d, F = (w) => {
    u(w.target.value), v && v(w);
  }, E = (w) => {
    S && S(w);
  };
  return J(() => {
    i(null), u(n.length > 0 ? Xn(n[0]) : ""), n.length > 0 && r(n[0], !1) && i({ reason: "invalidTimeSelection" });
  }, [r, n, i]), J(() => {
    f && f(n.length > 0 ? n[0] : null);
  }, [n, f]), J(() => {
    o && p && p(o);
  }, [p, o]), Me(C, () => ({
    clear: () => t([])
  })), /* @__PURE__ */ g(
    Te,
    {
      ...a({ inputValue: l, onChange: F, onBlur: E }),
      value: l,
      ...o ? { helperText: c(o) } : {},
      ...P,
      InputProps: {
        ...h,
        inputComponent: Wh,
        endAdornment: /* @__PURE__ */ g(qe, { position: "end", children: /* @__PURE__ */ g(mo, {}) })
      }
    }
  );
}, qh = Z(
  () => te({
    root: {
      width: "270px"
    }
  }),
  { name: "gTimeRangeInput" }
), Kh = (e) => /* @__PURE__ */ g(pt, { ...e, format: "##:## - ##:##" }), Yh = (e) => {
  const { error: n, setError: t, setViewing: r, value: o, setValue: i, hasRangeError: a, getTimeRangeInputProps: l } = De(), [u, s] = oe(""), d = j(), f = W({ name: "gTimeRangeInput", props: { ...e }, theme: d }), {
    onTimeRangeAccept: p,
    onTimeRangeError: c,
    classes: h = {},
    getErrorMessage: v = dt,
    InputProps: S,
    onChange: C,
    onBlur: P,
    timeRangeInputRef: F,
    ...E
  } = f, w = ie(qh(), h), I = (A) => {
    s(A.target.value), C && C(A);
  }, B = (A) => {
    P && P(A);
  };
  return J(() => {
    t(null), s(
      o.length > 1 ? `${Xn(o[0])} - ${Xn(o[o.length - 1])}` : ""
    ), o.length > 1 && a([o[0], o[o.length - 1]], !1) && t({ reason: "invalidTimeRangeSelection" }), o.length > 1 && !nt(o[0], o[o.length - 1]) && t({ reason: "invalidTimeRange" });
  }, [a, o, t, r]), J(() => {
    p && p(o.length > 1 ? [o[0], o[o.length - 1]] : null);
  }, [o, p]), J(() => {
    n && c && c(n);
  }, [n, c]), Me(F, () => ({
    clear: () => i([])
  })), /* @__PURE__ */ g(
    Te,
    {
      ...l({ inputValue: u, onChange: I, onBlur: B }),
      value: u,
      ...n ? { helperText: v(n) } : {},
      ...E,
      classes: w,
      InputProps: {
        ...S,
        inputComponent: Kh,
        endAdornment: /* @__PURE__ */ g(qe, { position: "end", children: /* @__PURE__ */ g(mo, {}) })
      }
    }
  );
}, Jh = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gDateCalendar", props: { ...e }, theme: t }), { onDateChange: o, CalendarProps: i, value: a, ...l } = r, u = { ...l, value: a ? [a] : void 0 };
    return /* @__PURE__ */ g(Ee, { options: u, children: /* @__PURE__ */ g(mr, { ...i, onDateChange: o, ref: n }) });
  }
);
Jh.displayName = "DateCalendar";
const Av = (e) => {
  const n = j(), t = W({ name: "gDateField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t, l = { selectivity: r, value: o ? [hr(o)] : void 0, disabled: i };
  return /* @__PURE__ */ g(Ee, { options: l, children: /* @__PURE__ */ g(zi, { ...a, disabled: i, disableOpenPicker: !0 }) });
}, Ui = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gDatePicker", props: { ...e }, theme: t }), {
      DateFieldProps: o,
      CalendarProps: i,
      label: a,
      placeholder: l,
      disabled: u,
      onDateAccept: s,
      onDateError: d,
      onClose: f,
      getErrorMessage: p
    } = r, { setOpen: c, open: h } = De(), v = () => {
      h && f && f(), c(!1);
    };
    return Me(n, () => ({
      close: () => c(!1)
    })), /* @__PURE__ */ g(
      ct,
      {
        onClickAway: v,
        mouseEvent: "onMouseDown",
        touchEvent: "onTouchStart",
        children: /* @__PURE__ */ K("div", { children: [
          /* @__PURE__ */ g(
            zi,
            {
              ...o,
              label: a,
              placeholder: l,
              disabled: u,
              onDateAccept: s,
              onDateError: d,
              getErrorMessage: p
            }
          ),
          /* @__PURE__ */ g(mr, { ...i, externalToggle: !0 })
        ] })
      }
    );
  }
);
Ui.displayName = "DatePickerInner";
const qi = ue((e, n) => {
  const { DateFieldProps: t, label: r, placeholder: o, disabled: i, value: a, ...l } = e, u = { ...l, value: a ? [hr(a)] : void 0 };
  return /* @__PURE__ */ g(Ee, { options: u, children: /* @__PURE__ */ g(Ui, { ...e, ref: n }) });
});
qi.displayName = "DatePicker";
const Tv = (e) => {
  const n = j(), t = W({ name: "gDateRangeField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t, l = { selectivity: r, value: Oi(o), disabled: i };
  return /* @__PURE__ */ g(Ee, { options: l, children: /* @__PURE__ */ g(Hi, { ...a, disabled: i, disableOpenPicker: !0 }) });
}, Ki = ue((e, n) => {
  const {
    DateRangeFieldProps: t,
    RangeCalendarProps: r,
    disabled: o,
    label: i,
    placeholder: a,
    onDateRangeAccept: l,
    onDateRangeError: u,
    onClose: s,
    getErrorMessage: d
  } = e, { setOpen: f, open: p } = De(), c = () => {
    p && s && s(), f(!1);
  };
  return Me(n, () => ({
    close: () => f(!1)
  })), /* @__PURE__ */ g(
    ct,
    {
      onClickAway: c,
      mouseEvent: "onMouseDown",
      touchEvent: "onTouchStart",
      children: /* @__PURE__ */ K("div", { children: [
        /* @__PURE__ */ g(
          Hi,
          {
            ...t,
            disabled: o,
            label: i,
            placeholder: a,
            onDateRangeAccept: l,
            onDateRangeError: u,
            getErrorMessage: d
          }
        ),
        /* @__PURE__ */ g(Wi, { ...r })
      ] })
    }
  );
});
Ki.displayName = "DateRangePickerInner";
const Yi = ue((e, n) => {
  const t = j(), r = W({ name: "gDateRangePicker", props: { ...e }, theme: t }), { DateRangeFieldProps: o, disabled: i, label: a, placeholder: l, value: u, ...s } = r, d = Oi(u);
  return /* @__PURE__ */ g(Ee, { options: { ...s, numberOfMonths: 2, value: d }, children: /* @__PURE__ */ g(Ki, { ...r, ref: n }) });
});
Yi.displayName = "DateRangePicker";
const Ev = (e) => {
  const n = j(), t = W({ name: "gDateTimeField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t;
  return /* @__PURE__ */ g(Ee, { options: { selectivity: r, value: o ? [o] : void 0, disabled: i }, children: /* @__PURE__ */ g(Gi, { ...a, disabled: i, disableOpenPicker: !0 }) });
}, Ji = ue((e, n) => {
  const {
    DateTimeFieldProps: t,
    CalendarProps: r,
    label: o,
    placeholder: i,
    disabled: a,
    onDateTimeAccept: l,
    onDateTimeError: u,
    onClose: s,
    getErrorMessage: d
  } = e, { setOpen: f, open: p } = De(), c = () => {
    p && s && s(), f(!1);
  };
  return Me(n, () => ({
    close: () => f(!1)
  })), /* @__PURE__ */ g(
    ct,
    {
      onClickAway: c,
      mouseEvent: "onMouseDown",
      touchEvent: "onTouchStart",
      children: /* @__PURE__ */ K("div", { children: [
        /* @__PURE__ */ g(
          Gi,
          {
            ...t,
            label: o,
            placeholder: i,
            disabled: a,
            onDateTimeAccept: l,
            onDateTimeError: u,
            getErrorMessage: d
          }
        ),
        /* @__PURE__ */ g(mr, { ...r, externalToggle: !0 })
      ] })
    }
  );
});
Ji.displayName = "DateTimePickerInner";
const Xi = ue((e, n) => {
  const t = j(), r = W({ name: "gDateTimePicker", props: { ...e }, theme: t }), { DateTimeFieldProps: o, CalendarProps: i, label: a, placeholder: l, disabled: u, value: s, ...d } = r, f = { ...d, value: s ? [s] : void 0 };
  return /* @__PURE__ */ g(Ee, { options: f, children: /* @__PURE__ */ g(Ji, { ...r, ref: n }) });
});
Xi.displayName = "DateTimePicker";
const Vv = (e) => {
  const n = j(), t = W({ name: "gDateTimeRangeField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t, l = { selectivity: r, value: vr(o), disabled: i };
  return /* @__PURE__ */ g(Ee, { options: l, children: /* @__PURE__ */ g(ji, { ...a, disabled: i, disableOpenPicker: !0 }) });
}, Zi = ue(
  (e, n) => {
    const {
      DateTimeRangeFieldProps: t,
      RangeCalendarProps: r,
      label: o,
      placeholder: i,
      disabled: a,
      onDateTimeRangeAccept: l,
      onDateTimeRangeError: u,
      getErrorMessage: s,
      onClose: d
    } = e, { setOpen: f, open: p } = De(), c = () => {
      p && d && d(), f(!1);
    };
    return Me(n, () => ({
      close: () => f(!1)
    })), /* @__PURE__ */ g(
      ct,
      {
        onClickAway: c,
        mouseEvent: "onMouseDown",
        touchEvent: "onTouchStart",
        children: /* @__PURE__ */ K("div", { children: [
          /* @__PURE__ */ g(
            ji,
            {
              ...t,
              label: o,
              placeholder: i,
              disabled: a,
              onDateTimeRangeAccept: l,
              onDateTimeRangeError: u,
              getErrorMessage: s
            }
          ),
          /* @__PURE__ */ g(Wi, { ...r })
        ] })
      }
    );
  }
);
Zi.displayName = "DateTimeRangePickerInner";
const Xh = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gDateTimeRangePicker", props: { ...e }, theme: t }), {
      DateTimeRangeFieldProps: o,
      RangeCalendarProps: i,
      label: a,
      placeholder: l,
      disabled: u,
      value: s,
      ...d
    } = r, f = { ...d, value: vr(s), numberOfMonths: 2 };
    return /* @__PURE__ */ g(Ee, { options: f, children: /* @__PURE__ */ g(Zi, { ...r, ref: n }) });
  }
);
Xh.displayName = "DateTimeRangePicker";
const _v = (e) => {
  const n = j(), t = W({ name: "gTimeField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t;
  return /* @__PURE__ */ g(Ee, { options: { selectivity: r, value: o ? [o] : void 0, disabled: i }, children: /* @__PURE__ */ g(Uh, { ...a, disabled: i }) });
}, Bv = (e) => {
  const n = j(), t = W({ name: "gTimeRangeField", props: { ...e }, theme: n }), { selectivity: r, value: o, disabled: i, ...a } = t, l = { selectivity: r, value: vr(o), disabled: i };
  return /* @__PURE__ */ g(Ee, { options: l, children: /* @__PURE__ */ g(Yh, { ...a, disabled: i }) });
}, Nv = ({
  column: e
}) => {
  const { id: n, setFilterValue: t, getFilterValue: r } = e, o = pe(t), i = r(), [a, l] = i && i.length ? [ot(i[0]), ot(i[1])] : [], u = L((s) => {
    o.current(
      s && s[0] && s[1] ? [
        Wt(s[0], { representation: "date" }),
        Wt(s[1], { representation: "date" })
      ] : void 0
    );
  }, []);
  return /* @__PURE__ */ g(
    Yi,
    {
      value: a && l ? [a, l] : [],
      viewing: a,
      onDateRangeAccept: u,
      DateRangeFieldProps: {
        InputLabelProps: { htmlFor: n },
        fullWidth: !1
      }
    }
  );
}, Lv = ({ column: e }) => {
  const { id: n, getFilterValue: t, setFilterValue: r } = e, o = pe(r), i = t(), a = i ? ot(i) : void 0, l = _o(), u = L((s) => {
    o.current(s ? Wt(s, { representation: "date" }) : void 0);
  }, []);
  return /* @__PURE__ */ g(
    qi,
    {
      value: a,
      viewing: a,
      onDateAccept: u,
      DateFieldProps: { InputLabelProps: { htmlFor: n }, classes: { root: l.input } }
    }
  );
}, Ov = ({
  column: e
}) => {
  const { id: n, getFilterValue: t, setFilterValue: r } = e, o = pe(r), i = t(), a = i ? ot(i) : void 0, l = _o(), u = L((s) => {
    o.current(s ? Wt(s, { representation: "complete" }) : void 0);
  }, []);
  return /* @__PURE__ */ g(
    Xi,
    {
      value: a,
      viewing: a,
      onDateTimeAccept: u,
      DateTimeFieldProps: { InputLabelProps: { htmlFor: n }, classes: { root: l.input } }
    }
  );
};
function qt(e, n) {
  return Object.entries(e).reduce((t, [r, o]) => (n.includes(r) || (t[r] = o), t), {});
}
const Ht = (e, n) => {
  var o, i, a, l, u, s;
  const { disabled: t, color: r } = n;
  if (t)
    return (o = e.palette.gray) == null ? void 0 : o[1e3];
  switch (r) {
    case "primary":
      return (i = e.palette.blue) == null ? void 0 : i[1400];
    case "success":
      return (a = e.palette.green) == null ? void 0 : a[700];
    case "warning":
      return (l = e.palette.orange) == null ? void 0 : l[1400];
    case "error":
      return (u = e.palette.red) == null ? void 0 : u[700];
    default:
      return (s = e.palette.gray) == null ? void 0 : s[1e3];
  }
}, Zn = (e, n) => {
  var o, i, a, l, u, s;
  const { disabled: t, color: r } = n;
  if (t)
    return (o = e.palette.gray) == null ? void 0 : o[100];
  switch (r) {
    case "primary":
      return (i = e.palette.blue) == null ? void 0 : i[100];
    case "success":
      return (a = e.palette.green) == null ? void 0 : a[100];
    case "warning":
      return (l = e.palette.orange) == null ? void 0 : l[100];
    case "error":
      return (u = e.palette.red) == null ? void 0 : u[100];
    default:
      return (s = e.palette.gray) == null ? void 0 : s[100];
  }
}, Zh = (e, n, t) => ({
  background: Zn(e, { color: n, disabled: t }),
  color: Ht(e, { color: n, disabled: t })
}), Qh = Z(
  (e) => te({
    root: ({ color: n, disabled: t }) => ({
      padding: e.spacing(0, 0.75),
      "&.Mui-disabled": {
        extend: Zh(e, n, t),
        opacity: 1
      },
      color: Ht(e, { color: n, disabled: t }),
      background: Zn(e, { color: n, disabled: t })
    }),
    deletable: ({ color: n, disabled: t }) => ({
      "&:focus": {
        backgroundColor: Zn(e, { color: n, disabled: t })
      }
    }),
    deleteIcon: ({ size: n, color: t, disabled: r }) => ({
      margin: 0,
      width: n === "medium" ? "1.25rem" : "1rem",
      height: n === "medium" ? "1.25rem" : "1rem",
      color: Ht(e, { color: t, disabled: r }),
      "&:hover": {
        color: Ht(e, { color: t, disabled: r })
      }
    }),
    label: ({ size: n }) => ({
      fontWeight: 600,
      fontSize: n === "medium" ? "1rem" : "0.875rem",
      padding: 0,
      "&:not(:first-child)": {
        marginLeft: e.spacing(0.5)
      },
      "&:not(:last-child)": {
        marginRight: e.spacing(0.5)
      }
    }),
    labelSmall: {
      lineHeight: "1.5rem"
    },
    labelBreadcrumbs: {
      display: "flex",
      alignItems: "center"
    }
  }),
  { name: "gGlobalChip" }
), e0 = Z(
  () => te({
    root: ({ size: e }) => ({
      width: e === "medium" ? "1.25rem" : "1rem",
      height: e === "medium" ? "1.25rem" : "1rem"
    })
  }),
  { name: "gChipIcon" }
), t0 = Z(
  (e) => te({
    container: () => ({
      fontWeight: 400,
      fontSize: "0.875rem",
      display: "flex",
      marginLeft: e.spacing(0.5),
      alignItems: "center",
      opacity: 0.8
    }),
    root: {
      color: "inherit",
      fontSize: "inherit"
    },
    separator: {
      marginLeft: e.spacing(0.5),
      marginRight: e.spacing(0.5)
    },
    defaultPrimary: ({ disabled: n }) => {
      var t;
      return {
        color: n ? (t = e.palette.gray) == null ? void 0 : t[1e3] : e.palette.primary.dark
      };
    },
    defaultSuccess: ({ disabled: n }) => {
      var t, r;
      return {
        color: n ? (t = e.palette.gray) == null ? void 0 : t[1e3] : (r = e.palette.green) == null ? void 0 : r[700]
      };
    },
    defaultWarning: ({ disabled: n }) => {
      var t, r;
      return {
        color: n ? (t = e.palette.gray) == null ? void 0 : t[1e3] : (r = e.palette.orange) == null ? void 0 : r[1600]
      };
    },
    defaultError: ({ disabled: n }) => {
      var t, r;
      return {
        color: n ? (t = e.palette.gray) == null ? void 0 : t[1e3] : (r = e.palette.red) == null ? void 0 : r[700]
      };
    }
  }),
  { name: "gChipBreadcrumbs" }
), n0 = (e) => {
  const { label: n, className: t, children: r } = e;
  return /* @__PURE__ */ K(ge, { className: t, children: [
    n,
    r
  ] });
}, Qi = ue((e, n) => {
  const t = j(), r = W({ name: "gGlobalChip", props: { ...e }, theme: t }), {
    classes: o = {},
    size: i,
    color: a = "primary",
    label: l,
    disabled: u,
    Icon: s,
    IconProps: d,
    Breadcrumbs: f,
    BreadcrumbsProps: p,
    ...c
  } = r, h = "default", v = Qh({ size: i, color: a, disabled: u }), S = ie(
    qt(v, ["labelBreadcrumbs"]),
    qt(o, ["labelBreadcrumbs"])
  );
  return /* @__PURE__ */ g(
    ba,
    {
      ref: n,
      classes: S,
      ...c,
      size: i,
      disabled: u,
      variant: h,
      ...s ? {
        icon: /* @__PURE__ */ g(s, { ...d, size: i })
      } : {},
      ...f ? {
        label: /* @__PURE__ */ g(n0, { label: l, className: v.labelBreadcrumbs, children: /* @__PURE__ */ g(f, { ...d, variant: h, color: a, disabled: u }) })
      } : { label: l }
    }
  );
});
Qi.displayName = "Chip";
const zv = (e) => {
  const n = j(), t = W({ name: "gChipBreadcrumbs", props: { ...e }, theme: n }), {
    children: r,
    disabled: o,
    separator: i = ">",
    variant: a,
    color: l,
    classes: u = {},
    ...s
  } = t, d = t0({ disabled: o }), f = ie(
    qt(d, [
      "defaultPrimary",
      "defaultSuccess",
      "defaultError",
      "defaultWarning"
    ]),
    qt(u, ["defaultPrimary", "defaultSuccess", "defaultError", "defaultWarning"])
  ), { container: p, ...c } = f || {}, h = d == null ? void 0 : d[`${a}${gl(l)}`];
  return /* @__PURE__ */ K(ge, { className: de(f.container, h), children: [
    /* @__PURE__ */ g("span", { children: "(" }),
    /* @__PURE__ */ g(Ba, { ...s, classes: c, separator: i, children: r }),
    /* @__PURE__ */ g("span", { children: ")" })
  ] });
}, Hv = (e) => {
  const n = j(), t = W({ name: "gChipIcon", props: { ...e }, theme: n }), { children: r, size: o, classes: i } = t, a = ie(e0({ size: o }), i);
  return Pn.map(r, (l) => {
    if (!Fa(l))
      return l;
    const u = { className: de(a.root, l.props.className) };
    return Da(l, u);
  });
};
function ft(e, n, t, r) {
  function o(i) {
    return i instanceof t ? i : new t(function(a) {
      a(i);
    });
  }
  return new (t || (t = Promise))(function(i, a) {
    function l(d) {
      try {
        s(r.next(d));
      } catch (f) {
        a(f);
      }
    }
    function u(d) {
      try {
        s(r.throw(d));
      } catch (f) {
        a(f);
      }
    }
    function s(d) {
      d.done ? i(d.value) : o(d.value).then(l, u);
    }
    s((r = r.apply(e, n || [])).next());
  });
}
function mt(e, n) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function l(s) {
    return function(d) {
      return u([s, d]);
    };
  }
  function u(s) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, s[0] && (t = 0)), t; )
      try {
        if (r = 1, o && (i = s[0] & 2 ? o.return : s[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, s[1])).done)
          return i;
        switch (o = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
          case 0:
          case 1:
            i = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = s;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(s);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = n.call(e, t);
      } catch (d) {
        s = [6, d], o = 0;
      } finally {
        r = i = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
function Ur(e, n) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var r = t.call(e), o, i = [], a;
  try {
    for (; (n === void 0 || n-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (l) {
    a = { error: l };
  } finally {
    try {
      o && !o.done && (t = r.return) && t.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function qr(e, n, t) {
  if (t || arguments.length === 2)
    for (var r = 0, o = n.length, i; r < o; r++)
      (i || !(r in n)) && (i || (i = Array.prototype.slice.call(n, 0, r)), i[r] = n[r]);
  return e.concat(i || Array.prototype.slice.call(n));
}
var r0 = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Et(e, n) {
  var t = o0(e);
  if (typeof t.path != "string") {
    var r = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof n == "string" ? n : typeof r == "string" && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function o0(e) {
  var n = e.name, t = n && n.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var r = n.split(".").pop().toLowerCase(), o = r0.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var i0 = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function a0(e) {
  return ft(this, void 0, void 0, function() {
    return mt(this, function(n) {
      return Kt(e) && l0(e.dataTransfer) ? [2, d0(e.dataTransfer, e.type)] : s0(e) ? [2, u0(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, c0(e)] : [2, []];
    });
  });
}
function l0(e) {
  return Kt(e);
}
function s0(e) {
  return Kt(e) && Kt(e.target);
}
function Kt(e) {
  return typeof e == "object" && e !== null;
}
function u0(e) {
  return Qn(e.target.files).map(function(n) {
    return Et(n);
  });
}
function c0(e) {
  return ft(this, void 0, void 0, function() {
    var n;
    return mt(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(r) {
            return r.getFile();
          }))];
        case 1:
          return n = t.sent(), [2, n.map(function(r) {
            return Et(r);
          })];
      }
    });
  });
}
function d0(e, n) {
  return ft(this, void 0, void 0, function() {
    var t, r;
    return mt(this, function(o) {
      switch (o.label) {
        case 0:
          return e.items ? (t = Qn(e.items).filter(function(i) {
            return i.kind === "file";
          }), n !== "drop" ? [2, t] : [4, Promise.all(t.map(g0))]) : [3, 2];
        case 1:
          return r = o.sent(), [2, Kr(ea(r))];
        case 2:
          return [2, Kr(Qn(e.files).map(function(i) {
            return Et(i);
          }))];
      }
    });
  });
}
function Kr(e) {
  return e.filter(function(n) {
    return i0.indexOf(n.name) === -1;
  });
}
function Qn(e) {
  if (e === null)
    return [];
  for (var n = [], t = 0; t < e.length; t++) {
    var r = e[t];
    n.push(r);
  }
  return n;
}
function g0(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Yr(e);
  var n = e.webkitGetAsEntry();
  return n && n.isDirectory ? ta(n) : Yr(e);
}
function ea(e) {
  return e.reduce(function(n, t) {
    return qr(qr([], Ur(n), !1), Ur(Array.isArray(t) ? ea(t) : [t]), !1);
  }, []);
}
function Yr(e) {
  var n = e.getAsFile();
  if (!n)
    return Promise.reject("".concat(e, " is not a File"));
  var t = Et(n);
  return Promise.resolve(t);
}
function p0(e) {
  return ft(this, void 0, void 0, function() {
    return mt(this, function(n) {
      return [2, e.isDirectory ? ta(e) : f0(e)];
    });
  });
}
function ta(e) {
  var n = e.createReader();
  return new Promise(function(t, r) {
    var o = [];
    function i() {
      var a = this;
      n.readEntries(function(l) {
        return ft(a, void 0, void 0, function() {
          var u, s, d;
          return mt(this, function(f) {
            switch (f.label) {
              case 0:
                if (l.length)
                  return [3, 5];
                f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, Promise.all(o)];
              case 2:
                return u = f.sent(), t(u), [3, 4];
              case 3:
                return s = f.sent(), r(s), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                d = Promise.all(l.map(p0)), o.push(d), i(), f.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        r(l);
      });
    }
    i();
  });
}
function f0(e) {
  return ft(this, void 0, void 0, function() {
    return mt(this, function(n) {
      return [2, new Promise(function(t, r) {
        e.file(function(o) {
          var i = Et(o, e.fullPath);
          t(i);
        }, function(o) {
          r(o);
        });
      })];
    });
  });
}
var xn = function(e, n) {
  if (e && n) {
    var t = Array.isArray(n) ? n : n.split(","), r = e.name || "", o = (e.type || "").toLowerCase(), i = o.replace(/\/.*$/, "");
    return t.some(function(a) {
      var l = a.trim().toLowerCase();
      return l.charAt(0) === "." ? r.toLowerCase().endsWith(l) : l.endsWith("/*") ? i === l.replace(/\/.*$/, "") : o === l;
    });
  }
  return !0;
};
const m0 = typeof xn == "function" ? xn : xn.default, h0 = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], na = (e) => {
  let n = 0, t = parseInt(e, 10) || 0;
  for (; t >= 1024 && ++n; )
    t = t / 1024;
  return t.toFixed(t < 10 && n > 0 ? 1 : 0) + " " + h0[n];
}, v0 = "file-invalid-type", y0 = "file-too-large", S0 = "file-too-small", C0 = "too-many-files", b0 = (e) => {
  e = Array.isArray(e) && e.length === 1 ? e[0] : e;
  const n = Array.isArray(e) ? `one of ${e.join(", ")}` : e;
  return {
    code: v0,
    message: `File type must be ${n}`
  };
}, Jr = (e) => ({
  code: y0,
  message: `File is larger than ${e === 1 ? "1 byte" : na(e)}`
}), Xr = (e) => ({
  code: S0,
  message: `File is smaller than ${e === 1 ? "1 byte" : na(e)}`
}), w0 = {
  code: C0,
  message: "Too many files"
};
function ra(e, n) {
  const t = e.type === "application/x-moz-file" || m0(e, n);
  return [t, t ? null : b0(n)];
}
function oa(e, n, t) {
  if (et(e.size))
    if (et(n) && et(t)) {
      if (e.size > t)
        return [!1, Jr(t)];
      if (e.size < n)
        return [!1, Xr(n)];
    } else {
      if (et(n) && e.size < n)
        return [!1, Xr(n)];
      if (et(t) && e.size > t)
        return [!1, Jr(t)];
    }
  return [!0, null];
}
function et(e) {
  return e != null;
}
function x0({
  files: e,
  accept: n,
  minSize: t,
  maxSize: r,
  multiple: o,
  maxFiles: i,
  validator: a
}) {
  return !o && e.length > 1 || o && i >= 1 && e.length > i ? !1 : e.every((l) => {
    const [u] = ra(l, n), [s] = oa(l, t, r), d = a ? a(l) : null;
    return u && s && !d;
  });
}
function Yt(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Lt(e) {
  return e.dataTransfer ? Array.prototype.some.call(
    e.dataTransfer.types,
    (n) => n === "Files" || n === "application/x-moz-file"
  ) : !!e.target && !!e.target.files;
}
function Zr(e) {
  e.preventDefault();
}
function R0(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function P0(e) {
  return e.indexOf("Edge/") !== -1;
}
function F0(e = window.navigator.userAgent) {
  return R0(e) || P0(e);
}
function Ne(...e) {
  return (n, ...t) => e.some((r) => (!Yt(n) && r && r(n, ...t), Yt(n)));
}
function D0() {
  return "showOpenFilePicker" in window;
}
function I0(e) {
  return et(e) ? [
    {
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: Object.entries(e).filter(([n, t]) => {
        let r = !0;
        return ia(n) || (console.warn(
          `Skipped "${n}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`
        ), r = !1), (!Array.isArray(t) || !t.every(aa)) && (console.warn(`Skipped "${n}" because an invalid file extension was provided.`), r = !1), r;
      }).reduce(
        (n, [t, r]) => ({
          ...n,
          [t]: r
        }),
        {}
      )
    }
  ] : e;
}
function M0(e) {
  if (et(e))
    return Object.entries(e).reduce((n, [t, r]) => [...n, t, ...r], []).filter((n) => ia(n) || aa(n)).join(",");
}
function $0(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function k0(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function ia(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function aa(e) {
  return /^.*\.[\w]+$/.test(e);
}
const A0 = ue(({ children: e, ...n }, t) => {
  const { open: r, ...o } = la(n);
  return Me(t, () => ({ open: r }), [r]), /* @__PURE__ */ g(tr, { children: e({ ...o, open: r }) });
});
A0.displayName = "Dropzone";
const T0 = {
  disabled: !1,
  getFilesFromEvent: a0,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: void 0,
  useFsAccessApi: !0,
  autoFocus: !1
}, er = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function la(e = {}) {
  const {
    accept: n,
    disabled: t,
    getFilesFromEvent: r,
    maxSize: o,
    minSize: i,
    multiple: a,
    maxFiles: l,
    onDragEnter: u,
    onDragLeave: s,
    onDragOver: d,
    onDrop: f,
    onDropAccepted: p,
    onDropRejected: c,
    onFileDialogCancel: h,
    onFileDialogOpen: v,
    useFsAccessApi: S,
    autoFocus: C,
    preventDropOnDocument: P,
    noClick: F,
    noKeyboard: E,
    noDrag: w,
    noDragEventsBubbling: I,
    onError: B,
    validator: A
  } = {
    ...T0,
    ...e
  }, Y = ye(() => M0(n), [n]), O = ye(() => I0(n), [n]), M = ye(
    () => typeof v == "function" ? v : Qr,
    [v]
  ), q = ye(
    () => typeof h == "function" ? h : Qr,
    [h]
  ), V = pe(null), G = pe(null), [me, k] = Ia(E0, er), { isFocused: N, isFileDialogActive: ne } = me, ee = pe(
    typeof window < "u" && window.isSecureContext && S && D0()
  ), re = () => {
    !ee.current && ne && setTimeout(() => {
      if (G.current) {
        const { files: y } = G.current;
        y.length || (k({ type: "closeDialog" }), q());
      }
    }, 300);
  };
  J(() => (window.addEventListener("focus", re, !1), () => {
    window.removeEventListener("focus", re, !1);
  }), [G, ne, q, ee]);
  const Q = pe([]), ae = (y) => {
    V.current && V.current.contains(y.target) || (y.preventDefault(), Q.current = []);
  };
  J(() => (P && (document.addEventListener("dragover", Zr, !1), document.addEventListener("drop", ae, !1)), () => {
    P && (document.removeEventListener("dragover", Zr), document.removeEventListener("drop", ae));
  }), [V, P]), J(() => (!t && C && V.current && V.current.focus(), () => {
  }), [V, C, t]);
  const le = L(
    (y) => {
      B ? B(y) : console.error(y);
    },
    [B]
  ), Ie = L(
    (y) => {
      y.preventDefault(), y.persist(), U(y), Q.current = [...Q.current, y.target], Lt(y) && r && Promise.resolve(r(y)).then((x) => {
        if (Yt(y) && !I)
          return;
        const $ = x.length, ce = $ > 0 && x0({
          files: x,
          accept: Y,
          minSize: i,
          maxSize: o,
          multiple: a,
          maxFiles: l,
          validator: A
        }), Re = $ > 0 && !ce;
        k({
          isDragAccept: ce,
          isDragReject: Re,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(y);
      }).catch((x) => le(x));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      u,
      le,
      I,
      Y,
      i,
      o,
      a,
      l,
      A
    ]
  ), Se = L(
    (y) => {
      y.preventDefault(), y.persist(), U(y);
      const x = Lt(y);
      if (x && y.dataTransfer)
        try {
          y.dataTransfer.dropEffect = "copy";
        } catch {
        }
      return x && d && d(y), !1;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, I]
  ), Ve = L(
    (y) => {
      y.preventDefault(), y.persist(), U(y);
      const x = Q.current.filter(
        (ce) => V.current && V.current.contains(ce)
      ), $ = x.indexOf(y.target);
      $ !== -1 && x.splice($, 1), Q.current = x, !(x.length > 0) && (k({
        type: "setDraggedFiles",
        isDragActive: !1,
        isDragAccept: !1,
        isDragReject: !1
      }), Lt(y) && s && s(y));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [V, s, I]
  ), Ce = L(
    (y, x) => {
      const $ = [], ce = [];
      y.forEach((Re) => {
        const [ht, vt] = ra(Re, Y), [yt, St] = oa(Re, i, o), Xe = A ? A(Re) : null;
        if (ht && yt && !Xe)
          $.push(Re);
        else {
          let Ze = [vt, St];
          Xe && (Ze = Ze.concat(Xe)), ce.push({ file: Re, errors: Ze.filter((Vt) => Vt) });
        }
      }), (!a && $.length > 1 || a && typeof l == "number" && l >= 1 && $.length > l) && ($.forEach((Re) => {
        ce.push({ file: Re, errors: [w0] });
      }), $.splice(0)), k({
        acceptedFiles: $,
        fileRejections: ce,
        type: "setFiles"
      }), f && f($, ce, x), ce.length > 0 && c && c(ce, x), $.length > 0 && p && p($, x);
    },
    [
      k,
      a,
      Y,
      i,
      o,
      l,
      f,
      p,
      c,
      A
    ]
  ), we = L(
    (y) => {
      y.preventDefault(), y.persist(), U(y), Q.current = [], Lt(y) && r && Promise.resolve(r(y)).then((x) => {
        Yt(y) && !I || Ce(x, y);
      }).catch((x) => le(x)), k({ type: "reset" });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, Ce, le, I]
  ), xe = L(() => {
    if (ee.current && r) {
      k({ type: "openDialog" }), M();
      const y = {
        multiple: a,
        types: O
      };
      window.showOpenFilePicker(y).then((x) => r(x)).then((x) => {
        Ce(x, null), k({ type: "closeDialog" });
      }).catch((x) => {
        $0(x) ? (q(x), k({ type: "closeDialog" })) : k0(x) ? (ee.current = !1, G.current ? (G.current.value = null, G.current.click()) : le(
          new Error(
            "Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."
          )
        )) : le(x);
      });
      return;
    }
    G.current && (k({ type: "openDialog" }), M(), G.current.value = null, G.current.click());
  }, [
    k,
    M,
    q,
    S,
    Ce,
    le,
    O,
    a
  ]), $e = L(
    (y) => {
      !V.current || !V.current.isEqualNode(y.target) || (y.key === " " || y.key === "Enter" || y.keyCode === 32 || y.keyCode === 13) && (y.preventDefault(), xe());
    },
    [V, xe]
  ), Le = L(() => {
    k({ type: "focus" });
  }, []), _e = L(() => {
    k({ type: "blur" });
  }, []), Be = L(() => {
    F || (F0() ? setTimeout(xe, 0) : xe());
  }, [F, xe]), be = (y) => t ? null : y, T = (y) => E ? null : be(y), _ = (y) => w ? null : be(y), U = (y) => {
    I && y.stopPropagation();
  }, b = ye(
    () => ({
      refKey: y = "ref",
      role: x,
      onKeyDown: $,
      onFocus: ce,
      onBlur: Re,
      onClick: ht,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onDragEnter: vt,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onDragOver: yt,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onDragLeave: St,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onDrop: Xe,
      ...Ze
    } = {}) => ({
      onKeyDown: T(
        //@ts-ignore
        Ne($, $e)
      ),
      onFocus: T(
        //@ts-ignore
        Ne(ce, Le)
      ),
      //@ts-ignore
      onBlur: T(Ne(Re, _e)),
      //@ts-ignore
      onClick: be(Ne(ht, Be)),
      onDragEnter: _(
        //@ts-ignore
        Ne(vt, Ie)
      ),
      onDragOver: _(
        //@ts-ignore
        Ne(yt, Se)
      ),
      onDragLeave: _(
        //@ts-ignore
        Ne(St, Ve)
      ),
      //@ts-ignore
      onDrop: _(Ne(Xe, we)),
      role: typeof x == "string" && x !== "" ? x : "presentation",
      [y]: V,
      ...!t && !E ? { tabIndex: 0 } : {},
      ...Ze
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      V,
      $e,
      Le,
      _e,
      Be,
      Ie,
      Se,
      Ve,
      we,
      E,
      w,
      t
    ]
  ), R = L((y) => {
    y.stopPropagation();
  }, []), D = ye(
    () => ({ refKey: y = "ref", onChange: x, onClick: $, ...ce } = {}) => ({
      accept: Y,
      multiple: a,
      type: "file",
      style: { display: "none" },
      //@ts-ignore
      onChange: be(Ne(x, we)),
      onClick: be(
        //@ts-ignore
        Ne($, R)
      ),
      tabIndex: -1,
      [y]: G,
      ...ce
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [G, n, a, we, t]
  );
  return {
    ...me,
    isFocused: N && !t,
    getRootProps: b,
    getInputProps: D,
    rootRef: V,
    inputRef: G,
    open: be(xe)
  };
}
function E0(e, n) {
  switch (n.type) {
    case "focus":
      return {
        ...e,
        isFocused: !0
      };
    case "blur":
      return {
        ...e,
        isFocused: !1
      };
    case "openDialog":
      return {
        ...er,
        isFileDialogActive: !0
      };
    case "closeDialog":
      return {
        ...e,
        isFileDialogActive: !1
      };
    case "setDraggedFiles":
      return {
        ...e,
        isDragActive: n.isDragActive,
        isDragAccept: n.isDragAccept,
        isDragReject: n.isDragReject
      };
    case "setFiles":
      return {
        ...e,
        acceptedFiles: n.acceptedFiles,
        fileRejections: n.fileRejections
      };
    case "reset":
      return {
        ...er
      };
    default:
      return e;
  }
}
function Qr() {
}
const sa = ro(void 0), eo = (e) => `${e}-${Math.floor(Date.now() / 1e3)}`, to = (e, n) => !n.find((t) => t.name === e.name && t.type === e.type), V0 = ({
  children: e,
  options: n
}) => {
  const [t, r] = oe([]), { disabled: o, multiple: i, onFileAccept: a, onFileReject: l, onFileRemove: u } = n || {}, s = L(
    (h) => {
      const v = h.flatMap((S) => {
        const C = eo(S.name), P = to(
          S,
          t.map((F) => F.file)
        );
        return [
          ...i ? [...t] : [],
          ...P ? [{ id: C, file: S }] : i ? [] : [...t]
        ];
      }).filter((S, C, P) => P.findIndex((F) => F.id === S.id) === C);
      r(v), a && a(v);
    },
    [t, i, a]
  ), d = L(
    (h) => {
      const v = h.flatMap((S) => {
        const C = eo(S.file.name), P = to(
          S.file,
          t.map((F) => F.file)
        );
        return [
          ...i ? [...t] : [],
          ...P ? [{ id: C, file: S.file, metaData: { errors: S.errors } }] : i ? [] : [...t]
        ];
      }).filter((S, C, P) => P.findIndex((F) => F.id === S.id) === C);
      r(() => v), l && l(v);
    },
    [t, i, l]
  ), f = L(
    (h) => {
      const v = t.filter((S, C) => C !== h);
      r(v), u && u(v);
    },
    [t, u]
  ), p = la({
    ...n,
    onDropAccepted: s,
    onDropRejected: d
  }), c = ye(
    () => ({ ...p, files: t, disabled: o, handleRemove: f }),
    [p, t, o, f]
  );
  return /* @__PURE__ */ g(sa.Provider, { value: c, children: e });
};
function ua() {
  const e = oo(sa);
  if (!e)
    throw new Error("useFileUpload must be used within FileUploadProvider");
  return e;
}
const _0 = Z(
  (e) => {
    var n, t;
    return te({
      root: {
        backgroundColor: e.palette.common.white,
        border: `1px dashed ${e.palette.neutral.light}`,
        padding: e.spacing(2),
        margin: `${e.spacing(2)} 0`,
        width: e.spacing(60),
        height: e.spacing(15),
        lineHeight: 1,
        cursor: "pointer",
        "&:hover": {
          border: `2px solid ${e.palette.primary.main}`,
          padding: `calc(${e.spacing(2)} - 1px)`
        }
      },
      active: {
        border: `2px solid ${e.palette.primary.main}`
      },
      disabled: {
        backgroundColor: (n = e.palette.neutral) == null ? void 0 : n.light,
        cursor: "not-allowed",
        "&:hover": {
          padding: e.spacing(2),
          border: `1px dashed ${(t = e.palette.neutral) == null ? void 0 : t.main}`
        }
      },
      fullWidth: {
        width: "100%"
      }
    });
  },
  { name: "gFileDropzone" }
), B0 = (e) => {
  const n = j(), t = W({ name: "gFileDropzone", props: { ...e }, theme: n }), {
    label: r = "Click here to choose a file, or drag and drop anywhere to import",
    LabelProps: o,
    className: i,
    inputId: a,
    classes: l = {},
    hook: u,
    fullWidth: s = !1,
    InputProps: d
  } = t, { getRootProps: f, getInputProps: p, disabled: c, isDragActive: h } = u ? u() : ua(), v = ie(_0(), l);
  return /* @__PURE__ */ K(
    rr,
    {
      ...f(),
      elevation: 0,
      square: !0,
      className: de(
        i,
        v.root,
        c && v.disabled,
        h && v.active,
        s && v.fullWidth
      ),
      children: [
        /* @__PURE__ */ g("input", { ...d, ...p(), ...a ? { id: a } : {} }),
        /* @__PURE__ */ g(
          ke,
          {
            color: c ? "textDisabled" : "primary",
            variant: "caption",
            className: v.label,
            ...o,
            children: r
          }
        )
      ]
    }
  );
};
B0.displayName = "FileDropzone";
const N0 = Z(
  (e) => te({
    root: {},
    item: {
      flexFlow: "column",
      alignItems: "flex-start",
      backgroundColor: e.palette.neutral.lighter,
      marginBottom: e.spacing(1)
    },
    error: {
      border: `1px solid ${e.palette.error.main}`
    },
    action: {
      top: e.spacing(3),
      right: e.spacing(0.5)
    }
  }),
  { name: "gFileList" }
), L0 = (e) => {
  const n = ["B", "KB", "MB", "GB", "TB", "PB"];
  let t = 0;
  for (t; e > 1024; t++)
    e /= 1024;
  return e.toFixed(1) + " " + n[t];
}, O0 = ue((e, n) => {
  const t = j(), r = W({ name: "gFileList", props: { ...e }, theme: t }), {
    classes: o = {},
    className: i,
    hook: a,
    ListItemProps: l,
    ListProps: u,
    ListItemTextProps: s,
    ListItemTextErrorProps: d
  } = r, f = ie(N0(), o), { files: p, handleRemove: c } = a ? a() : ua(), h = p.map((v, S) => {
    const {
      file: { name: C, size: P, path: F },
      metaData: E
    } = v, { errors: w } = E || {};
    return /* @__PURE__ */ Ma(
      Dn,
      {
        ...l,
        key: F,
        className: de(f.item, (w == null ? void 0 : w.length) && f.error)
      },
      /* @__PURE__ */ g(
        jt,
        {
          ...s,
          primaryTypographyProps: { variant: "body2", className: f.text },
          primary: C,
          secondary: L0(P),
          secondaryTypographyProps: { variant: "caption", className: f.caption }
        }
      ),
      /* @__PURE__ */ g(Fn, { disablePadding: !0, children: w == null ? void 0 : w.map((I) => /* @__PURE__ */ g(Dn, { disableGutters: !0, children: /* @__PURE__ */ g(
        jt,
        {
          ...d,
          primary: I.message,
          primaryTypographyProps: { variant: "caption", color: "error" }
        }
      ) }, I.code)) }),
      /* @__PURE__ */ g(Na, { className: f.action, children: /* @__PURE__ */ g(he, { "aria-label": `Remove ${C}`, onClick: () => c(S), children: /* @__PURE__ */ g(lt, { fontSize: "small" }) }) })
    );
  });
  return /* @__PURE__ */ g(Fn, { ...u, disablePadding: !0, ref: n, className: de(i, f.root), children: h });
});
O0.displayName = "FileList";
const z0 = Z(() => te({}), { name: "gFileUpload" }), H0 = ue((e, n) => {
  const t = j(), r = W({ name: "gFileUpload", props: { ...e }, theme: t }), {
    children: o,
    className: i,
    classes: a = {},
    label: l,
    helperText: u,
    inputId: s,
    ...d
  } = r, f = ie(z0(), a), { disabled: p } = d;
  return /* @__PURE__ */ K("div", { ref: n, className: de(i, f == null ? void 0 : f.root), children: [
    l ? /* @__PURE__ */ g(
      Jt,
      {
        disabled: p,
        className: f.label,
        ...s ? { htmlFor: s } : {},
        children: l
      }
    ) : null,
    u ? /* @__PURE__ */ g(Xt, { disabled: p, className: f.helperText, children: u }) : null,
    /* @__PURE__ */ g(V0, { options: d, children: o })
  ] });
});
H0.displayName = "FileUpload";
const G0 = Z(
  () => te({
    footer: {
      top: "auto",
      bottom: 0
    },
    spacer: {
      flex: "1 1 auto"
    }
  }),
  { name: "gFooter" }
), j0 = (e) => {
  const n = j(), t = W({ name: "gFooter", props: { ...e }, theme: n }), {
    leftChildren: r,
    rightChildren: o,
    AppbarProps: i,
    ToolbarProps: a,
    classes: l = {}
  } = t, u = G0();
  return /* @__PURE__ */ g(
    uo,
    {
      position: "fixed",
      className: de(u.footer, l == null ? void 0 : l.footer),
      ...i,
      children: /* @__PURE__ */ K(co, { ...a, children: [
        r && r,
        /* @__PURE__ */ g("div", { className: de(u.spacer, l == null ? void 0 : l.spacer) }),
        o && o
      ] })
    }
  );
};
j0.displayName = "Footer";
const W0 = Z(
  (e) => te({
    option: {
      '&:hover, &:active, &:focus, &[data-focus="true"]': {
        backgroundColor: e.palette.blue[50]
      },
      '&[aria-selected="true"]': {
        background: e.palette.blue[100],
        "&:hover": {
          background: e.palette.blue[200]
        }
      }
    }
  }),
  { name: "gAutocomplete" }
), U0 = (e) => {
  const { classes: n = {}, customRef: t, getOptionLabel: r } = e, o = ie(W0(), n);
  return /* @__PURE__ */ g(
    Sl,
    {
      ref: t,
      classes: o,
      renderTags: (i, a) => i.map((l, u) => /* @__PURE__ */ g(
        Qi,
        {
          ...a({ index: u }),
          label: r && r(l),
          size: "small"
        },
        u
      )),
      getOptionLabel: r,
      ...e
    }
  );
};
U0.displayName = "GlobalAutocomplete";
const q0 = Z(
  () => te({
    spacer: {
      flex: "1 1 auto"
    }
  }),
  { name: "gHeader" }
), K0 = (e) => {
  const n = j(), t = W({ name: "gHeader", props: { ...e }, theme: n }), {
    leftChildren: r,
    rightChildren: o,
    AppbarProps: i,
    ToolbarProps: a,
    classes: l = {}
  } = t, u = q0();
  return /* @__PURE__ */ g(uo, { position: "static", color: "primary", ...i, children: /* @__PURE__ */ K(co, { ...a, children: [
    r && r,
    /* @__PURE__ */ g("div", { className: de(u.spacer, l == null ? void 0 : l.spacer) }),
    o && o
  ] }) });
};
K0.displayName = "Header";
const Y0 = (e) => ({
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  backgroundPosition: "center",
  backgroundImage: `url(${e})`
}), J0 = Z(
  (e) => te({
    imgContainer: ({ width: n, height: t, backgroundImageUrl: r }) => {
      var o;
      return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "&.MuiGrid-item": {
          padding: 0
        },
        ...r ? Y0(r) : {},
        backgroundColor: (o = e.palette.neutral) == null ? void 0 : o.lighter,
        width: `${n}px`,
        height: `${t}px`,
        padding: e.spacing(0.25),
        borderRadius: e.spacing(0.5)
      };
    },
    pictureWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    imgRoot: {
      width: "100%",
      height: "100%",
      display: "block",
      background: "none"
    },
    img: {
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain"
    },
    popoverPaper: ({ width: n, height: t }) => {
      var r;
      return {
        composes: "$imgContainer",
        border: `2px solid ${(r = e.palette.gray) == null ? void 0 : r[100]}`,
        padding: 0,
        width: `${n * 3}px`,
        height: `${t * 3}px`,
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)"
      };
    },
    popover: {
      pointerEvents: "none"
    },
    popoverImg: {
      maxWidth: "100%"
    }
  }),
  { name: "gImagePane" }
), X0 = ue((e, n) => {
  const [t, r] = oe(null), o = j(), i = W({ name: "gImagePane", props: { ...e }, theme: o }), {
    src: a,
    alt: l,
    width: u = 40,
    height: s = 40,
    classes: d = {},
    sources: f,
    enableBackgroundImage: p,
    enableZoom: c,
    ...h
  } = i, v = J0({
    width: u,
    height: s,
    backgroundImageUrl: a && p ? a : void 0
  }), S = (C) => {
    C.stopPropagation(), r(t ? null : C.currentTarget);
  };
  return /* @__PURE__ */ K(Je, { children: [
    /* @__PURE__ */ g(
      "div",
      {
        ref: n,
        className: de(v.imgContainer, d.imgContainer),
        onMouseEnter: S,
        onMouseLeave: S,
        "data-tc": "ImagePane",
        children: a && !p && (f && f.length ? /* @__PURE__ */ K("picture", { className: de(v.pictureWrapper, d.pictureWrapper), children: [
          f.map((C, P) => /* @__PURE__ */ g("source", { srcSet: C.srcSet, media: C.media }, P)),
          /* @__PURE__ */ g(
            "img",
            {
              "data-tc": "ImagePreview",
              src: a,
              alt: l,
              className: de(v.img, d.img)
            }
          )
        ] }) : /* @__PURE__ */ g(
          La,
          {
            "data-tc": "ImagePreview",
            alt: l,
            src: a,
            variant: "square",
            classes: {
              root: de(v.imgRoot, d.imgRoot),
              img: de(v.img, d.img)
            },
            ...h
          }
        ))
      }
    ),
    a && c && /* @__PURE__ */ g(
      wa,
      {
        "data-tc": "ImagePanePopover",
        className: de(v.popover, d.popover),
        classes: {
          paper: de(v.popoverPaper, d.popoverPaper)
        },
        open: !!t,
        anchorEl: t,
        onClose: S,
        anchorOrigin: {
          vertical: "center",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        keepMounted: !0,
        disableRestoreFocus: !0,
        children: /* @__PURE__ */ g(
          "img",
          {
            src: a,
            alt: l,
            className: de(v.popoverImg, d.popoverImg),
            "data-tc": "PopoverImg"
          }
        )
      }
    )
  ] });
});
X0.displayName = "ImagePane";
const Z0 = Z(
  (e) => te({
    container: {},
    label: {
      marginBottom: e.spacing(0.5)
    }
  }),
  { name: "gRadioGroup" }
), Q0 = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gRadioGroup", props: { ...e }, theme: t }), {
      children: o,
      helperText: i,
      label: a,
      HelperTextProps: l,
      LabelProps: u,
      defaultValue: s,
      value: d,
      onChange: f,
      name: p,
      row: c,
      classes: h = {},
      ...v
    } = r, S = ie(Z0(), h);
    return /* @__PURE__ */ K(
      nr,
      {
        component: "fieldset",
        variant: "outlined",
        className: S.container,
        ...v,
        ref: n,
        children: [
          a ? /* @__PURE__ */ g(Jt, { component: "legend", className: S.label, ...u, children: a }) : null,
          /* @__PURE__ */ g(
            Oa,
            {
              name: p,
              defaultValue: s,
              value: d,
              onChange: f,
              row: c,
              children: o
            }
          ),
          i ? /* @__PURE__ */ g(Xt, { ...l, children: i }) : null
        ]
      }
    );
  }
);
Q0.displayName = "RadioGroup";
const ev = Z(
  (e) => te({
    root: ({ severity: n }) => {
      var t;
      return {
        minWidth: "242px",
        padding: e.spacing(1.25, 2),
        display: "flex",
        alignItems: "center",
        backgroundColor: n ? void 0 : e.palette.common.white,
        color: n || (t = e.palette.neutral) == null ? void 0 : t.main,
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)"
      };
    },
    icon: ({ severity: n, enableIcon: t }) => ({
      display: !n || !t ? "none" : "inherit"
    }),
    message: {
      padding: 0,
      overflow: "hidden",
      maxWidth: "380px"
    },
    filledError: {
      backgroundColor: e.palette.error.main,
      fontWeight: 400
    },
    filledSuccess: {
      backgroundColor: e.palette.success.main,
      fontWeight: 400
    },
    filledWarning: {
      backgroundColor: e.palette.warning.main,
      fontWeight: 400
    },
    filledInfo: {
      backgroundColor: e.palette.primary.main,
      fontWeight: 400
    }
  }),
  { name: "gSnackbarAlert" }
), tv = Z(
  (e) => te({
    root: ({ severity: n }) => ({
      color: n ? "inherit" : e.palette.secondary.main,
      padding: e.spacing(1),
      minWidth: "fit-content"
    })
  }),
  { name: "gSnackbarAlert" }
), ca = (e) => {
  const n = j(), t = W({ name: "gSnackbarAlertAction", props: { ...e }, theme: n }), { text: r, onClick: o, severity: i, userClasses: a } = t, l = ie(tv({ severity: i }), a);
  return /* @__PURE__ */ g(
    $n,
    {
      className: de(l.root, a == null ? void 0 : a.root),
      onClick: o,
      variant: "text",
      children: r
    }
  );
};
ca.displayName = "SnackbarAlertAction";
const da = (e) => {
  const n = j(), t = W({ name: "gSnackbarAlertDismiss", props: { ...e }, theme: n }), {
    size: r = "small",
    darkMode: o = !0,
    onClose: i,
    ariaLabelText: a = "Cancel notification icon",
    "data-tc": l = "cancelNotification"
  } = t;
  return /* @__PURE__ */ g(
    he,
    {
      "data-tc": l,
      size: r,
      onClick: i,
      "aria-label": a,
      darkMode: o,
      children: /* @__PURE__ */ g(lt, { fontSize: "medium" })
    }
  );
};
da.displayName = "SnackbarAlertDismiss";
const nv = (e) => {
  const n = j(), t = W({ name: "gSnackbarAlert", props: { ...e }, theme: n }), {
    enableIcon: r = !1,
    enableAction: o = !1,
    enableDismiss: i = !1,
    onClose: a,
    severity: l,
    alertContent: u,
    ActionComponentProps: s = { text: "", onClick: () => {
    } },
    ActionComponent: d = ca,
    DismissComponent: f = da,
    userClasses: p
  } = t, c = ie(ev({ severity: l, enableIcon: r }), p);
  return /* @__PURE__ */ g(
    so,
    {
      classes: c,
      variant: "filled",
      severity: l,
      iconMapping: {
        error: /* @__PURE__ */ g(go, { "aria-label": "ErrorIcon" }),
        success: /* @__PURE__ */ g(Zt, { "aria-label": "SuccessIcon" }),
        warning: /* @__PURE__ */ g(or, { "aria-label": "WarningIcon" }),
        info: /* @__PURE__ */ g(ir, { "aria-label": "InfoIcon" })
      },
      action: /* @__PURE__ */ K(Je, { children: [
        o ? /* @__PURE__ */ g(d, { ...s, severity: l }) : null,
        i ? /* @__PURE__ */ g(f, { onClose: a }) : null
      ] }),
      children: u
    }
  );
};
nv.displayName = "SnackbarAlert";
const rv = Z(
  (e) => te({
    iconButton: {
      padding: e.spacing(1),
      position: "relative",
      "& svg": {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }
    },
    button: {
      padding: e.spacing(1, 2)
    },
    groupedContainedPrimary: {
      "&:not(:last-child)": {
        borderRight: `1px solid ${e.palette.common.white}`
      }
    },
    paper: {
      boxShadow: Tt.medium
    }
  }),
  { name: "gSplitButton" }
), ov = ue((e, n) => {
  const t = j(), r = W({ name: "gSplitButton", props: { ...e }, theme: t }), {
    classes: o = {},
    variant: i = "contained",
    size: a = "medium",
    children: l,
    onClick: u,
    disabled: s,
    renderMenu: d,
    className: f,
    ButtonProps: p,
    ButtonGroupProps: c,
    IconButtonProps: h,
    PaperProps: v
  } = r, S = ie(rv(), o), [C, P] = oe(!1), F = pe(null), E = () => {
    P((I) => !I);
  }, w = (I) => {
    F.current && F.current.contains(I.target) || P(!1);
  };
  return /* @__PURE__ */ K("div", { className: de(S.root, f), ref: n, children: [
    /* @__PURE__ */ K(
      za,
      {
        ...c,
        variant: i,
        size: a,
        ref: F,
        disabled: s,
        classes: {
          root: S.buttonGroup,
          groupedContainedPrimary: S.groupedContainedPrimary
        },
        children: [
          /* @__PURE__ */ g(
            $n,
            {
              ...p,
              onClick: u,
              classes: {
                root: S.button
              },
              children: l
            }
          ),
          /* @__PURE__ */ g(
            $n,
            {
              ...h,
              onClick: E,
              classes: {
                root: S.iconButton
              },
              children: /* @__PURE__ */ g(st, { fontSize: "small", titleAccess: "Icon Button" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g(
      no,
      {
        open: C,
        anchorEl: F.current,
        role: void 0,
        transition: !0,
        disablePortal: !0,
        className: S.popper,
        children: ({ TransitionProps: I, placement: B }) => /* @__PURE__ */ g(
          xa,
          {
            ...I,
            style: {
              transformOrigin: B === "bottom" ? "center top" : "center bottom"
            },
            children: /* @__PURE__ */ g(
              rr,
              {
                ...v,
                classes: {
                  root: S.paper
                },
                children: /* @__PURE__ */ g(ct, { onClickAway: w, children: d(w) })
              }
            )
          }
        )
      }
    )
  ] });
});
ov.displayName = "SplitButton";
const iv = ({ color: e = "#FFFFFF" }) => /* @__PURE__ */ K("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ g("title", { children: "Status Solid" }),
  /* @__PURE__ */ g("circle", { cx: "4", cy: "4", r: "4", fill: e })
] }), av = Z(
  (e) => te({
    statusWrapper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    status: {
      marginLeft: e.spacing(1)
    }
  }),
  { name: "gStatusWrapper" }
), lv = (e) => {
  const n = j(), t = W({ name: "gStatusWrapper", props: { ...e }, theme: n }), { children: r, color: o, classes: i = {} } = t, a = ie(av(), i);
  return /* @__PURE__ */ K(Sr, { className: a.statusWrapper, children: [
    /* @__PURE__ */ g(iv, { color: o }),
    /* @__PURE__ */ g(Sr, { className: a.status, children: r })
  ] });
};
lv.displayName = "StatusWrapper";
const sv = Z(
  (e) => te({
    container: {},
    label: {
      marginBottom: e.spacing(0.5)
    }
  }),
  { name: "gSwitchGroup" }
), uv = ue(
  (e, n) => {
    const t = j(), r = W({ name: "gSwitchGroup", props: { ...e }, theme: t }), {
      children: o,
      helperText: i,
      label: a,
      row: l = !1,
      HelperTextProps: u,
      LabelProps: s,
      classes: d = {},
      ...f
    } = r, p = ie(sv(), d);
    return /* @__PURE__ */ K(
      nr,
      {
        component: "fieldset",
        variant: "outlined",
        className: p.container,
        ...f,
        ref: n,
        children: [
          a ? /* @__PURE__ */ g(Jt, { component: "legend", className: p.label, ...s, children: a }) : null,
          /* @__PURE__ */ g(ao, { row: l, children: o }),
          i ? /* @__PURE__ */ g(Xt, { ...u, children: i }) : null
        ]
      }
    );
  }
);
uv.displayName = "SwitchGroup";
const cv = Z(
  (e) => te({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: e.spacing(1),
      flexDirection: "row-reverse"
    },
    badge: ({ active: n }) => {
      var t, r, o;
      return {
        ...n && {
          color: (r = (t = e.palette) == null ? void 0 : t.text) == null ? void 0 : r.primary
        },
        display: "flex",
        height: "20px",
        padding: `0px ${e.spacing(0.75)}`,
        alignItems: "center",
        borderRadius: e.spacing(0.5),
        border: `1px solid ${(o = e.palette.neutral) == null ? void 0 : o.light}`,
        fontSize: "0.75rem",
        position: "static",
        transform: "none"
      };
    }
  }),
  { name: "gTabLabelWithBadge" }
), Gv = (e) => {
  const n = j(), t = W({ name: "gTabLabelWithBadge", props: { ...e }, theme: n }), { label: r, count: o, max: i, active: a, classes: l = {}, ...u } = t, s = ie(cv({ active: a }), l);
  return /* @__PURE__ */ g(Ha, { badgeContent: o, max: i, classes: s, ...u, children: /* @__PURE__ */ g("div", { children: r }) });
}, jv = (e) => {
  const n = j(), t = W({ name: "gTooltipTitle", props: { ...e }, theme: n }), { Content: r, Icon: o } = t;
  return /* @__PURE__ */ K(Je, { children: [
    o ? /* @__PURE__ */ g(o, { fontSize: "medium" }) : null,
    /* @__PURE__ */ g(r, { variant: "body1" })
  ] });
}, dv = Z(
  (e) => te({
    root: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      gap: e.spacing(1),
      listStyle: "none",
      padding: 0,
      margin: 0
    },
    count: {
      color: "inherit"
    }
  }),
  { name: "gTruncatedChips" }
), gv = ue((e, n) => {
  const t = j(), r = W({ name: "gTruncatedChips", props: { ...e }, theme: t }), { children: o, classes: i = {}, numberOfChipsToShow: a } = r, l = ie(dv(), i), u = Pn.toArray(o), s = u.length > a, d = u.slice(a), f = u.slice(0, a);
  return /* @__PURE__ */ K("ul", { ref: n, className: l.root, children: [
    Pn.map(f, (p, c) => /* @__PURE__ */ g("li", { children: p }, c)),
    s && /* @__PURE__ */ g("li", { className: l.count, role: "note", children: /* @__PURE__ */ g(Ra, { children: `+${d.length}` }) })
  ] });
});
gv.displayName = "TruncatedChips";
export {
  Pl as Banner,
  wo as BannerActions,
  xo as BannerContent,
  Ro as BannerTitle,
  Dl as CheckboxGroup,
  Qi as Chip,
  zv as ChipBreadcrumbs,
  Hv as ChipIcon,
  Iv as DataTable,
  wr as DataTableCheckbox,
  Jh as DateCalendar,
  Av as DateField,
  qi as DatePicker,
  Tv as DateRangeField,
  Yi as DateRangePicker,
  Ev as DateTimeField,
  Xi as DateTimePicker,
  Vv as DateTimeRangeField,
  Xh as DateTimeRangePicker,
  Dv as EditableCell,
  B0 as FileDropzone,
  O0 as FileList,
  H0 as FileUpload,
  j0 as Footer,
  U0 as GlobalAutocomplete,
  K0 as Header,
  X0 as ImagePane,
  Fv as LinkCell,
  Uo as NumberField,
  Q0 as RadioGroup,
  nv as SnackbarAlert,
  ca as SnackbarAlertAction,
  da as SnackbarAlertDismiss,
  ov as SplitButton,
  lv as StatusWrapper,
  uv as SwitchGroup,
  Gv as TabLabelWithBadge,
  Lv as TableDateFilter,
  Nv as TableDateRangeFilter,
  Ov as TableDateTimeFilter,
  kv as TableNumberFilter,
  Mv as TableSelectFilter,
  $v as TableTextFilter,
  _v as TimeField,
  Bv as TimeRangeField,
  jv as TooltipTitle,
  gv as TruncatedChips,
  qv as createFilterOptions,
  Zn as getChipBackgroundColour,
  Ht as getChipColour,
  dt as getErrorMessage
};
//# sourceMappingURL=index.js.map
